// 命名規則建議
// 直接以路徑命名 Portal = hp
// ex: hp.home, hp.m5.m510050, hp.m5.m510010.wf010
// 由於共用的在多人協作會有衝突的情況，所以留下一個 global.normal 之後在把共用的放進來
// 以下不要放註釋
module.exports = {
	'global.normal': {
		'add': '新增',
		'modify': '修改',
		'update': '更新',
		'cancel': '取消',
		'view': '檢視',
		'config': '設定',
		'edit': '編輯',
		'delete': '刪除',
		'refresh': '重新整理',
		'export': '匯出',
		'exportInfo': '匯出資料',
		'sendOut': '送出',
		'pleaseSelect': '請選擇',
		'startTime': '開始時間',
		'endTime': '結束時間',
		'sure': '確定',
		'close': '關閉',
		'show': '顯示',
		'informal': '不拘',
		'normal': '正常',
		'abnormal': '異常',
		'remove': '移除',
		'today': '今天',
		'disable': '停用',
		'enable': '啟用',
		'error': '錯誤',
		'noInfo': '無資料',
		'finish': '完成',
		'correct': '正確',
		'yes': '是',
		'no': '否',
		'departmentName': '部門名稱',
		'staff': '員編',
		'name': '姓名',
		'employeeNumber': '員工編號',
		'addANewStroke': '新增一筆',
		'all': '全部',
		'dept': '部門',
		'viewBtn': '查看',
		'selectAll': '全選',
		'january': '1月',
		'february': '2月',
		'march': '3月',
		'april': '4月',
		'may': '5月',
		'june': '6月',
		'july': '7月',
		'august': '8月',
		'september': '9月',
		'october': '10月',
		'november': '11月',
		'december': '12月',
		'weekToNum1': '一',
		'weekToNum2': '二',
		'weekToNum3': '三',
		'weekToNum4': '四',
		'weekToNum5': '五',
		'weekToNum6': '六',
		'weekToNum7': '日',
	},
	'components.grids': {
		'fetchErrMsg': '讀取資料錯誤',
		'emptyWarning': '沒有符合查詢條件的資料，請放寬條件重新查詢',
		'sureDeleteIt': '確定要刪除嗎?',
		'deleteCountMsg': '確定要刪除此 <%= count %> 筆資料嗎?',
		'successCount': ' (成功 <%= success %> 筆',
		'successCounts': ' (成功 <%= success %> 筆',
		'failCount': '，失敗 <%= fail %> 筆',
		'failCounts': '，失敗 <%= fail %> 筆',
		'usedCount': '，使用中 <%= used %> 筆',
		'usedCounts': '，使用中 <%= used %> 筆',
		'errorCount': '，錯誤 <%= unexpected %> 筆',
		'errorCounts': '，錯誤 <%= unexpected %> 筆',
		'simpleSearch': '簡易搜尋',
		'advancedSearch': '進階查詢',
		'advancedSearchConfig': '進階查詢條件設定中',
		'counditionCount': '<%= count %> 個條件',
		'allCount': '共 <%= count %> 筆',
		'allCounts': '共 <%= count %> 筆',
		'matchFewCount': '符合 <%= count %> 筆',
		'matchFewCounts': '符合 <%= count %> 筆',
	},
	'components.utils': {
		'today': '今天',
		'to': '至',
		'noInfo': '無資訊',
		'seeMore': '查看更多',
	},
	'hp.home': {
		'hello': '哈哈',
		'noAnnouncementYet': '尚無公告',
		'noNotifictionItemYet': '尚無通知',
		'gettingpaid': '薪資已發放！',
		'notice': '提醒您，依「個人資料保護法」之規定，取得或使用員工資料時，絕不洩漏、交付或以其他方式使非經合法授權之任何第三人知悉。',
		'know': '我知道了',
	},
	'hp.m5.m510010.form': {
		'programError': '程式錯誤',
		'noApplicationPermission': '您已無申請權限，請重新確認',
		'youNeedToUploadAtLeast': '至少需上傳一個附件',
		'theSignoffProcess': '未產生簽核流程，無法啟動表單',
		'failedToWriteToForm': '寫入表單失敗',
		'attachmentUpdateFailed': '附件更新失敗',
		'enterAReasonUpToWords': '輸入原因，最多<%=max%>字',
		'attachmentLabel': '附件',
		'youDoNotCurrentlyHaveAnyDataToChangeYourTimeOfDuty': '您目前沒有可異動的假勤資料',
		'atPresentTheSystemAllows': '目前系統允許異動時間內，無任何假勤資料，',
		'allAppliedLeaveInformationMustWait': '所有已申請的假勤資料，須等待簽核完成後，才能進行異動。',
		'clickTheButtonBelowToSee': '點擊下方按鈕了解簽核進度',
		'understandSignoffProgress': '了解簽核進度',
		'lastMonth': '上個月',
		'thisYear': '本年度',
		'originalApplicationTime': '原申請時間：<%=start%>至<%=end%>，',
		'actualResults': '實際結果：',
		'noNeedToJudge': '不須判斷',
		'judgingCardInformation': '判斷刷卡資料',
		'remindYou': '提醒您',
		'pleaseHelpMeAdjust': '確定，請幫我調整',
		'effectiveDate': '生效日期',
		'clearReselection': '清除重選',
		'failedToLoadDataBeforeThe': '載入異動前資料失敗',
		'project': '項目',
		'beforeTheChange': '異動前',
		'afterTheChange': '異動後',
		'changeTheProject': '異動項目',
		'totalItems': '共<%=temp1%>項',
		'changePersonnel': '異動人員',
		'pleaseEnterANumericType': '請輸入數字型態',
		'mustBeLessThan': '必須小於 <%=num%>',
		'mustBeGreaterThan': '必須大於 <%=num%>',
		'pleaseEnterANumber': '請輸入數字',
		'required': '必填',
		'pleaseSelectOvertimeFirst': '請先選擇加班時間',
		'otherOvertimeRulesLoadedIncorrectly': '其他加班規定載入錯誤',
		'overtimeHoursIs0PleaseReselectOvertime': '加班合計時數為0，請重新選擇加班時間',
		'pleaseEnterAStartAndEndTime': '請輸入開始與結束時間',
		'actualAndHoursResultsThatComplyWithCompanyOvertimeRules': '您申請的加班時間經系統比對出勤資料後，將調整為符合公司加班規則的實際時間與時數結果。',
		'pleaseReselectOvertime': '請重新選擇加班時間',
		'overtimeCheckError': '加班檢查錯誤',
		'actualResultsAdjustedToComplyWithCompanyHoursOfOvertimeRules': '已將您申請的時數，調整為符合公司加班規則的實際結果。原申請時間：<%=otStart%>至<%=otEnd%>，',
		'companyOvertimeCategoryRules': '系統根據您輸入的加班時間，依公司加班類別規則區分如下',
		'simultaneousRelease': '同時發放',
		'overtimePay': '加班費',
		'compensatoryLeave': '補休假',
		'costCenterItem': '(成本中心：<%=name%>，加班費 <%=otName%>，補休假 <%=calName%>)',
		'noCostCenterItem': '<%=name%>，加班費 <%=otName%>，補休假 <%=calName%>',
		'attachmentWriteError': '附件寫入錯誤',
		'serverError': '伺服器錯誤',
		'totalHours': '假勤合計時數',
		'costCenter': '成本中心設定',
		'typeNoLongerOpen': '已不開放此申請類型',
		'deduction': '扣除',
		'notDeduction': '不扣除',
	},
	'hp.m5.m510010.wf030': {
		'cannotRepeatTime': '申請時間不可重複',
		'applicant': '申請人',
		'forgetTheSwipeTime': '忘刷卡時間',
		'forgotToBrushTheReason': '忘刷原因',
	},
	'hp.m5.m510010.wf050': {
		'theLeaveCheckHasNotBeenPassed': '銷假檢查未過',
		'failedToWriteToTheFakeMasterFile': '寫入銷假主檔失敗',
		'theApplicationForAFakeSlipFailed': '銷假單申請失敗',
		'theProjectLoadingErrorCanBeChanged': '可異動假勤項目載入錯誤',
		'obtainingFalseAttendanceErrors': '取得假勤錯誤',
		'noneMessage': '無 <%=temp1%> <%=temp2%> <%=temp3%>',
		'falseAttendanceDataError': '假勤資料錯誤: <%=temp1%>',
		'theStartDateOfTheLeave': '假勤起始日',
		'endOfLeaveDay': '假勤結束日',
		'leaveProject': '假勤項目',
		'cancelType': '銷假類型',
		'leaveCancelTime': '銷假時間',
	},
	'hp.m5.m510010.wf010': {
		'theLeaveSlipApplicationFailed': '請假單申請失敗',
		'theLeaveCheckHasNotBeen': '假勤檢查未過',
		'failedToWriteToTheFake': '寫入假勤主檔失敗',
		'pleaseSelectTheTimeOfAbsence': '請先選擇假勤時間',
		'fakeProjectLoadingError': '假勤項目載入錯誤',
		'pleaseEnterAStartAndEnd': '請輸入開始與結束時間',
		'getTheErrorOfTheDay': '取得事件發生日錯誤',
		'falseAttendanceCalculationError': '假勤計算錯誤',
		'pleaseSelectTheLeaveItemFirst': '請先選擇假勤項目',
		'cancelTheDateOnWhichThe': '取消新增事件發生日',
		'theNewEventOccurredOnA': '新增事件發生日',
		'selectTheDateOnWhichThe': '選擇已申請發生日',
		'servedAsAgentForOtherColleagues': '部分或全部的假勤時間已擔任其他同仁的職務代理人',
		'issueHint': '需為 <%=X%> <%=Y%>的倍數，送出後將自動調整假勤時數',
		'startDateMustBeforeEndDate': '起始日期需早於結束日期',
	},
	'components.Dialog': {
		'correctInformation': '正確資料',
		'confirmTheImport': '確定匯入',
		'fileErrorTheFileFormatMust': '檔案錯誤：檔案格式須為Excel(.xlsx)，上限10MB。',
		'fileNameNotContainSpecialChar': '檔案名稱不可包含特殊字元 \\ / : * ? " < > | # % &',
		'errorMsg': '錯誤訊息',
		'exceptionDescription': '異常說明',
		'dateFormatError': '不符合日期格式',
		'importDataError': '錯誤匯入資料',
		'importSuccess': '匯出完成',
		'verificationResult': '(驗證結果)',
		'correct': '正確',
		'fieldCountError': '共<%= count %>個欄位錯誤',
		'anomalousData': '異常資料',
		'downloadErrorData': '下載錯誤資料',
		'importResult': '(匯入結果)',
		'importCompleted': '匯入完成',
		'importCount': '匯入筆數',
		'importCompletedCloseWindow': '匯入完成，關閉視窗',
		'exportCompleted': '匯出完成',
		'exportFailed': '匯出失敗',
		'note': '備註',
		'fileUploadFailed': '檔案上傳失敗，請重新上傳',
		'invalidFileFormat': '檔案內容格式無效，請重新上傳',
		'uploadFailed': '上傳失敗',
		'importFailed': '匯入失敗',
		'fieldReminders': '有<%= count %>個欄位提醒',
	},
	'components.Dialogs': {
		'identifyAdditions': '確定新增',
		'newInProgress': '新增中',
		'theWindowDoesNotCloseAfter': '新增後視窗不關閉',
		'identifyModifications': '確定修改',
		'underModification': '修改中',
		'notEntered': '(未輸入)',
		'thisInformationCannotBeViewed': '無法檢視此筆資料',
		'editTheProfile': '編輯資料',
		'modifyTheJourney': '修改歷程',
		'previousStep': '上一步',
		'next': '下一步',
		'unableToLoadLongJobInformation': '無法載入長時作業資訊',
		'pleaseClickToSelectTheImport': '請「點擊」選擇匯入檔案，或將匯入檔案「拖拉」於此處進行匯入作業',
		'theFileFormatIsIncorrect': '檔案格式錯誤，或大小超過 10 MB。',
		'nonExistentFormat': '不存在的格式：<%=temp1%>',
		'fileNamesCannotContainSpecialCharacters': '檔案名稱不可包含特殊字元 \\ / : * ? " < > | # % & ',
		'theAssignmentHasEndedPlease': '作業已結束，請重新整理後再試一次',
		'importTheResults': '匯入結果',
		'numberOfSuccesses': '成功筆數:',
		'numberOfFailures': '失敗筆數:',
		'closeTheWindow': '關閉視窗',
		'downloadFailedData': '下載失敗資料',
		'thatSRight': '正確',
		'totalFieldErrors': '共<%=temp1%>個欄位錯誤',
		'verifyTheStatus': '驗證狀態',
		'correctData': '正確資料:',
		'processing': '處理中',
		'theDownloadIsComplete': '下載完成',
		'confirmTheDownload': '確定下載',
		'confirmTheDownloadUS': '確定下載',
		'downloading': '下載中 ...',
		'errorFreeDataIsAvailableFor': '無錯誤資料可下載',
		'fail': '失敗',
		'succeed': '成功',
		'noData': '無資料:<%=temp1%>',
		'partialImport': '部分匯入',
		'importAll': '全部匯入',
		'cancelTheImport': '取消匯入',
		'abnormalData': '異常資料:<%=temp1%>',
		'downloadErrorData': '下載錯誤資料',
		'ifThereIsNoDataIn': '您所上傳的檔案內容無資料，請選擇其他檔案重新上傳。',
		'afterPreviewingTheFirst': '以上預覽您所上傳檔案中的前10筆資料(不含標題)，確認無誤後，點擊「開始檢查資料」後，系統將開始執行匯入作業。<%=temp1%><%=temp2%>注意:若前10筆資料欄位中皆為空值，系統預覽時仍會呈現前10筆的空資料，且進行匯入作業時會自動略過空資料。',
		'nonExistentFormat2': '不存在的格式！',
		'ImportResult': '<%=temp1%> (匯入結果)',
		'ValidationResult': '<%=temp1%> (驗證結果)',
		'ImportFilePreview': '<%=temp1%> (匯入檔案預覽)',
		'theImportIsComplete': '匯入完成',
		'startCheckingTheMaterials': '開始檢查資料',
		'reUploadTheArchive': '重新上傳檔案',
		'cropThePicture': '裁切圖片',
		'theUploadedImageIsInThe': '上傳圖片格式錯誤，或尺寸超過3MB。',
		'areYouSureYouWantTo': '確定要移除圖片嗎?',
		'removeTheImage': '移除圖片',
		'DragAndDropAn': '+ 拖拉圖片至此或點擊並選取上傳圖片 ',
		'sending': '送出中 ...',
		'downloadTheImportSample': '下載匯入範例',
		'pleaseDownloadAndImportInTraditional': '請用繁中語系下載及匯入',
	},
	'components.Input': {
		'upToWords': '最多 <%=max%> 個字',
		'requiredField': '必填欄位',
		'minimumWords': '最少 <%=min%> 個字',
		'theFormatDoesNotConform': '格式不符合',
		'pleaseEnterTheCorrectEmailFormat': '請輸入正確的E-mail格式',
		'pleaseEnterDateFormatYYYYMMDD': '請輸入日期格式(YYYY/MM/DD)',
		'pleaseEnterTimeFormathhmm': '請輸入時間格式(hh:mm)',
		'pleaseEnterADFormatYYYY': '請輸入西元年格式(YYYY)',
		'pleaseEnterTheFormatOfAD': '請輸入西元年月格式(YYYY/MM)',
		'pleaseEnterTheFormatOfThe': '請輸入西元月日格式(MM/DD)',
		'pleaseEnterTheDateTimeFormat': '請輸入日期時間格式(YYYY/MM/DD hh:mm)',
		'pleaseEnterTheDateRangeYYYYMMDD': '請輸入日期區間(YYYY/MM/DD ~ YYYY/MM/DD)',
		'pleaseEnterTheMobilePhoneNumber': '請輸手機號碼格式，例如：0988888888',
		'pleaseEnterTheCorrectPhoneNumber': '請輸入正確電話號碼格式，例如：\\n0288888888, 02-88888888, (02)88888888',
		'pleaseEnterTheExtensionFormatFor': '請輸入分機格式，例如：99, 888, 1234',
		'pleaseEnterAPhoneOrMobile': '請輸入電話或手機號碼格式，例如：0288888888 或 0988888888',
		'pleaseEnterTheCorrectUniformNumbering': '請輸入正確的統一編號格式',
		'pleaseEnterTheCorrectIPvFormat': '請輸入正確的IPv4格式',
		'pleaseEnterTheCorrectIPv6Format': '請輸入正確的IPv6格式',
		'rise': '起',
		'apocalypse': '訖',
		'aStartingValueIsRequired': '需要起始值',
		'anEndValueIsRequired': '需要結束值',
		'theStartingValueCannotBeLess': '起始值不能小於 <%=min%>',
		'theStartingValueCannotBeGreater': '起始值不能大於 <%=max%>',
		'theEndValueCannotBeLess': '結束值不能小於 <%=min%>',
		'theEndValueCannotBeGreater': '結束值不能大於 <%=max%>',
		'theStartValueCannotBeGreater': '起始值不能大於結束值',
		'pleaseEnterTheCorrectIDNumber': '請輸入正確的身分證字號',
		'pleaseEnterAPassword': '請輸入密碼',
		'thePasswordLengthIsUpTo': '密碼長度最多為 <%=max%>',
		'passwordLengthIsAtLeast': '密碼長度至少為 <%=min%>',
		'total': '共<%=temp1%>日',
		'pleaseEnterTheDateFormat': '請輸入日期格式(YYYY/MM/DD) ex: 2020/05/13',
		'pleaseEnterTheADFormat': '請輸入西元年格式(YYYY) ex:2020',
		'pleaseEnterTheYearAndMonth': '請輸入年月格式(YYYY/MM) ex:2020/05',
		'pleaseEnterTheMonthFormat': '請輸入月份格式(MM) ex:08',
		'pleaseEnterMonthAndDayFormat': '請輸入月日格式(MM/DD) ex:08/25',
		'pleaseEnterTheTimeFormat': '請輸入時間格式(hh:mm) ex:23:15',
		'pleaseEnterTheHourFormat': '請以小時為單位輸入（hh:mm）ex：23:00',
		'pleaseEnterTheDatetimeFormat': '請輸入日期時間格式(YYYY/MM/DD hh:mm) ex:2020/05/13 23:15',
		'pleaseEnterANumericType': '請輸入數字型態',
		'mustBeLessThan': '必須小於 <%=max%>',
		'mustBeGreaterThan': '必須大於 <%=min%>',
		'mustBeAMultiple': '必需為 <%=unit%> 的倍數',
		'startDate': '開始日期',
		'endDate': '結束日期',
		'aStartOrEndDateIs': '需要起始或結束日期',
		'aStartDateIsRequired': '需要起始日期',
		'anEndDateIsRequired': '需要結束日期',
		'theStartDateMustBeEarlier': '起始日期需早於結束日期',
		'theTimeRangeMustBeLess': '時間範圍必需小於 <%=rangeMax%>',
		'theTimeRangeMustBeGreater': '時間範圍必需大於 <%=rangeMin%>',
		'theDayBeforeYesterday': '前日',
		'day': '當日',
		'next': '次日',
		'pleaseSelectTheDepartment': '請挑選部門 ...',
		'searchDepartment': '搜尋部門 ...',
		'theOrganizationChart': '組織圖(<%=temp1%>)未啟用或無部門資料',
		'countiesCitiesAndTownships': '縣 市 鄉 鎮',
		'youCanSelectUpTo': '最多可選 <%=max%> 項',
		'atLeastMin': '最少需選 <%=min%> 項',
		'easyFiltering': '簡易篩選',
		'advancedFiltering': '進階篩選',
		'advancedFilterSettings': '進階篩選條件設定中...',
		'selected': '已選取',
		'search': '搜尋 ...',
		'translate error': 'number',
		'deactivated': '已停用',
		'selectedItemIsInactive': '所選項目包含已停用選項，請重新選擇',
		'noMatchingInformation': '無符合資料',
		'join': '加入',
		'unitYear': '年',
		'unitMonth': '月',
		'unitDay': '日',
	},
	'hp.m4.m410020': {
		'salaryMonth': '薪資月份',
		'salaryCate': '薪資類別',
		'payroll': '薪資袋',
		'return': '返回',
		'nonEmpAccessDenied': '非員工無查詢權限',
		'payrollLogin': '薪資袋登入',
		'pwChangeOK': '密碼變更成功',
		'pwForgotten': '忘記密碼',
		'loginOK': '登入成功',
		'notice': '訊息',
		'pwMustChange': '必須變更密碼',
		'loginError': '登入失敗',
		'noApplication': '應用程式不存在',
		'pwGone': '員工薪資袋密碼資料不存在',
		'pwBroken': '薪資袋密碼狀態錯誤',
		'pwInactive': '薪資袋密碼待啟用',
		'pwLocked': '薪資袋密碼已鎖定',
		'pwClosed': '薪資袋密碼已停用',
		'waitLocked': '密碼已鎖定，請等待 <%= accountLockoutTime %> 分鐘後再登入',
		'notifiedAdmin': '已通知系統管理員，請靜待處理，謝謝。',
		'forgetExceeded': '忘記密碼點按次數已超過上限！為保障您的密碼安全，密碼將改為停用，並已通知系統管理員處理，謝謝',
		'resetMailSent': '系統已寄發薪資袋重設密碼函至您的信箱，請於30分鐘內重新設定，逾期失效，謝謝。',
		'sendFatal': '發送失敗',
		'pwPayroll': '薪資袋密碼',
		'pwHintLogin': '為確保薪資資料安全，請協助輸入電子薪資袋密碼(非Portal登入密碼)',
		'pwHintClose': '密碼已停用，若有問題，請洽詢系統管理員',
		'tellAdmin': '通知管理員',
		'tokenFault': 'TOKEN錯誤',
		'charRuleFailed': '文數字檢查錯誤',
		'spCharRequired': '密碼需有特殊符號檢查錯誤',
		'sameAsPrevious': '新舊密碼不可以一樣',
		'pwConfirmFailed': '新密碼不一致',
		'pwModify': '修改密碼',
		'pwCurrent': '舊密碼',
		'pwResetNoted': '已發送重設薪資袋密碼通知',
		'remindedAdmin': '忘記密碼已連絡HR處理',
		'ajaxFatal': '讀取失敗',
		'payrollUnset': '員工未設定薪資袋格式',
		'payrollOutRange': '僅可查詢 <%= qryLimitMonth %> 個月內的薪資袋資料，請重新查詢',
		'operationTimedOut': '驗證失效或操作逾時，請重新登入',
		'taxBonusHint': '課稅屬性總金額=獎金加項的應稅 - 獎金扣項的應稅',
		'taxSalayHint': '課稅屬性總金額=薪資結構的應稅+薪資加項的應稅 - 薪資扣項的應稅',
		'attendAmtHint': '「當月加項金額/當月扣項金額」可能因金額異動或小數點關係而有落差，<%= br %>實際請以「薪資加項/薪資扣項」金額為主。',
		'bonus1st': '第一筆',
		'bonus2nd': '第二筆',
		'bonus3rd': '第三筆',
		'bonus4th': '第四筆',
		'bonus5th': '第五筆',
		'bonus6th': '第六筆',
		'bonus7th': '第七筆',
		'bonus8th': '第八筆',
		'failExceeded': '密碼錯誤達 <%= cnts %> 次，請等待 <%= mins %> 分鐘後再登入',
		'payrollNoFmt': '未設定薪資袋格式',
		'noSpeed': '未建立快速登入',
		'pubKeyFail': '金鑰驗證失敗',
		'pubKeyBroken': '金鑰操作異常',
		'authFatal': '辨識失敗',
		'pwLocking': '密碼鎖定中',
		'pwClosing': '密碼狀態異常，請聯絡系統管理員',
		'pwResetFatal': '重設密碼失敗',
		'pwLostFatal': '申請忘記密碼失敗',
		'pwMaxClosed': '已超過次數，您的密碼已改為停用，並已連絡帳號管理者',
		'noAnyPayData': '無任何薪資資料',
		'opFatal': '操作失敗',
		'noPayData': '無薪資資料',
		'waitSalary': '請待有薪資資料後，再進行查詢',
		'noMail': '申請重設密碼失敗，無mail可寄發通知函，請聯絡系統管理員，謝謝。',
		'noMailForAPP': '無 email 可寄發密碼通知函，請聯絡系統管理員，謝謝。',
		'headerForAPP': '申請重設密碼失敗',
	},
	'hp.m4.m410040': {
		'queryInterval': '查詢區間',
		'ifNoQueryIntervalIsSet': '若未設定查詢區間，將預設查詢<%=temp1%>~<%=temp2%>的資料',
		'selectAStartDate': '選擇開始日期',
		'selectAnEndDate': '選擇結束日期',
		'kabie': '卡別',
		'state': '狀態',
		'theOvertimeAttendanceReasonWasUpdated': '超時出勤原因更新成功',
		'multipleOvertimeAttendanceReasonsAreUpdated': '多筆超時出勤原因更新成功',
		'noInformationTryToSearchAgain': '無資訊，試試重新搜尋吧!',
		'failedToCountTheNumberOf': '計算請假表單、忘刷表單數量失敗',
		'serialNumber': '序號',
		'dateOfWork': '工作日期',
		'banBing': '班別',
		'timeOfAttendance': '應出勤時間',
		'clockinTime': '打卡時間',
		'systemOperation': '系統作業',
		'overtimeAttendance': '超時出勤',
		'multipleFills': '多筆填寫',
		'bodyTemperature': '體溫',
		'remark': '備註',
		'oopsIHaventFilledIn': 'Oops ! 還沒填寫呦',
		'cause': '原因:',
		'leave': '請假',
		'forgetToBrush': '忘刷',
		'editTheReasonForOvertimeAttendance': '編輯超時出勤原因',
		'pleaseFillInTheReason': '請填寫原因',
		'incorrectOnboardingJourneyTime': '載入打卡歷程時間錯誤',
		'thereIsNoRecordOfAny': '沒有任何打卡紀錄喔!',
		'overtimeAttendanceReason': '超時出勤原因',
		'theDescriptionMustBeLessThan': '說明內容必須少於100字內',
		'sendingOut': '送出中',
		'onboardingTimeoutAttendanceReasonError': '載入超時出勤原因錯誤',
		'updateDate': '更新日期',
		'selectAll': '全選',
		'expectedHoursOfAttendance': '應出勤時間:',
		'dateOfWork2': '工作日期:',
		'clockInJourneyTime': '打卡歷程時間',
		'clockInTime': '打卡時間',
		'timeoutDescription': '超時出勤說明',
		'reason': '超時出勤原因',
		'genTestData': '隨機產生打卡資料',
	},
	'hp.Header': {
		'theSwitchoverFailed': '切換失敗',
		'successfullySwitchedTo': '成功切換至：<%=temp1%>',
		'individual': '個人',
		'announcement': '公告',
		'form': '表單',
		'classSchedule': '班表',
		'logOffTheSystem': '登出系統',
		'areYouSureYouWantTo': '確定要登出嗎?',
		'failedToLogOffTheSystem': '登出系統失敗',
		'announcementQueryError': '公告查詢錯誤',
		'daysago': '<%=temp1%> 天前',
		'hoursago': '<%=temp1%> 小時前',
		'tempminutesago': '<%=temp1%> 分鐘前',
		'minutesago': '0分鐘前',
		'latestNotices': '最新通知',
		'readall': '全部讀取',
		'removeall': '全部移除',
		'youdonthavethelatestnotice': '您沒有最新通知！',
		'agentidentity': '代理身份',
		'basicinformation': '基本資訊',
		'listofrelatives': '親屬名單',
		'accountsecurity': '帳號安全',
		'switchidentities': '切換身份',
		'language': '語言：',
		'logout': '登出',
		'selectIdentity': '選擇身份',
		'selectalanguage': '選擇語言',
		'headFor': '前往',
		'NonEmployees': '(非員工) ',
		'personalSettings': '個人設定',
	},
	'components.EmpUtils': {
		'department': '部門',
		'headOfDepartment': '部門主管',
		'incumbentStatus': '在職狀況',
		'dateRelated': '日期相關',
		'withholdingUnit': '扣繳單位',
		'laborProtectionCompilation': '勞保統編',
		'healthInsuranceCompilation': '健保統編',
		'posts': '職位',
		'grade': '職等',
		'rank': '職級',
		'jobCategory': '職務類別',
		'occupation': '職種',
		'identityCategory': '身分類別',
		'directAndIndirect': '直間接別',
		'separationOfResponsibilities': '責任區分',
		'preparationStatus': '編制狀況',
		'workArea': '工作區域',
		'placeOfWork': '工作地點',
		'factoryBy': '廠別',
		'classAttributes': '班別屬性',
		'salaryMethod': '計薪方式',
		'probationaryExpirationStatus': '試用期滿狀態',
		'basicData': '基本資料',
		'householdRegistrationAddressArea': '戶籍地址地區',
		'mailingAddressArea': '通訊地址地區',
		'employee': '員工',
		'firm': '公司',
		'partTimeStatus': '部分工時/全時',
		'thisEmployeeViewPermissionIsNot': '無此員工檢視權限',
		'noInformationOnThisEmployeeWas': '查無此員工資料',
		'readError': '讀取錯誤',
		'reloadTheData': '重新載入資料',
		'pickEmployees': '挑選員工',
		'searchForNameEditors': '搜尋姓名員編...',
		'moreSearchCriteria': '更多搜尋條件',
		'companyAffiliation': '所屬公司',
		'wordStatus': '在職狀態',
		'employeeNumberOnwards': '員工編號起',
		'employeeNumber': '員工編號訖',
		'searcherNameExtension': '搜尋員編、姓名、分機、信箱...',
		'selectCompany': '公司',
		'setFilters': '設定篩選條件',
		'excludeSpecificPeople': '排除特定人員 ',
		'previewOfTheResults': '結果預覽',
		'youCanOnlyRules': '最多只能 <%=max%> 個規則',
		'aMinimumOfRules': '最少需要 <%=min%> 個規則',
		'condition': '條件:',
		'exclude': '排除:',
		'firmEmp': '公司:',
		'establishFilters': '建立篩選條件',
		'memberCheck': '成員檢核',
		'reviewTheFilters': '檢視篩選條件',
		'editTheFilterCriteria': '編輯篩選條件',
		'thereAreCurrentlyNoOtherCompanies': '目前沒有其他公司，無法繼續作業',
		'dateOfArrival': '到職日期',
		'dateOfDeparture': '離職日期',
		'leaveWithoutPayDate': '留職停薪日期',
		'gender': '性別',
		'ageRange': '年齡範圍',
		'seniorityRange': '年資範圍',
		'staffingRange': '員編範圍',
		'employeeCardNumberRange': '員工卡號範圍',
		'nationality': '國籍',
		'organizationChart': '組織圖',
		'level': '層級',
		'noPermissions': '無權限',
		'numberOfExcluded': '排除人數:',
		'ifThereAreNoEligibleEmployees': '無符合條件的員工，無法排除',
		'accordingToTheFilterCriteria': '根據篩選條件，目前無符合條件員工',
		'organizationChartCategories': '組織圖類別',
		'numberOfSelectedPeople': '已選人數<%=temp1%>筆',
		'reviewMembers': '檢核成員',
		'thereAreCurrentlyNoEligibleEmployees': '目前無符合條件員工',
		'sector': '部門1',
		'positionTitle': '職位(職稱)',
		'gradeGrade': '職等/職級',
		'dateOfBirth': '出生日期',
		'maritalStatus': '婚姻狀況',
		'highestEducation': '最高學歷',
		'recentExperience': '最近經歷',
		'companyPhone': '公司電話',
		'companyEMail': '公司E-mail',
		'mobilePhone': '行動電話',
		'personalEMail': '個人E-mail',
		'familyRegistrationTelephone': '戶籍電話',
		'registeredAddress': '戶籍地址',
		'homePhone': '住家電話',
		'mailingAddress': '通訊地址',
		'foreignAddress': '國外地址',
		'socialAccount': '社群帳號1',
		'socialAccount2': '社群帳號2',
		'emergencyContact': '緊急聯絡人(1)',
		'emergencyContactRelationship1': '緊急聯絡人關係(1)',
		'phone': '電話(1)',
		'mobilePhone1': '行動電話(1)',
		'emergencyContacts2': '緊急聯絡人(2)',
		'emergencyContactRelationships2': '緊急聯絡人關係(2)',
		'phone2': '電話(2)',
		'mobilePhone2': '行動電話(2)',
		'noInformationOnThisNonEmployee': '查無此非員工資料',
		'staffEditor': '員編:',
		'arrivalDate': '到職日:',
		'pickNonEmployees': '挑選非員工',
		'failedToReadNonEmployeeData': '讀取非員工資料失敗',
		'search': '搜尋...',
		'fromTheCodeNameOfThe': '所得人代號起',
		'theRecipientCodeName': '所得人代號訖',
		'nameOfTheRecipient': '所得人姓名/名稱',
		'iDNumberCompanyCompilation': '身分證號/公司統編起',
		'iDorCompanyCompilation': '身分證號/公司統編訖',
		'categoryOfEarner': '所得人類別',
		'clickToPickOtherNonEmployees': '點選可挑選其他非員工',
		'employeeName': '員工姓名',
		'directIndirect': '直/間接',
		'workAreaLocation': '工作區域/地點',
		'workRules': '工時規則',
		'scheduledHours': '已排時數',
		'elapsedHoursOn': '已排時數(起)',
		'scheduledHoursToDate': '已排時數(迄)',
		'failedToReadEmployeeData': '讀取員工資料失敗',
		'unselect': '未選擇員工',
		'selected': '已選擇員工',
		'keywords': '員工關鍵字',
		'empNumberStart': '員工編號(起)',
		'empNumberEnd': '員工編號(迄)',
	},
	'hp.m5.m510010.wf080': {
		'unit': '份',
		'headerItem': '文件項目',
		'headerNum': '數量(份)',
		'applicationDocument': '申請文件',
		'reasonForApplying': '用途說明',
	},
	'hp.m5.m5Picker': {
		'wfForm': '表單',
		'amOtType': '加班類別',
		'pbRccc': '成本中心',
		'pbVarsCause': '核薪原因',
		'pbSalaryItem': '薪資科目',
		'pbCurrency': '幣別',
		'edVarsCause': '異動原因',
		'osSNO': '扣繳單位(統編)',
		'osSNOCompilation': '統編',
		'osOrgType': '組織類別',
		'edJob': '職位',
		'edGrade': '職等',
		'edLevel': '職級',
		'edJobCat': '職務類別',
		'edJobDesct': '職務說明書',
		'edJobStyle': '職種',
		'edJobBiz': '名片職務',
		'edIdentity': '身分類別',
		'edArea': '工作區域',
		'edSite': '工作地點',
		'edFactory': '廠別',
		'amTemplate': '出勤規則範本',
		'amShift': '班別',
		'amCalendar': '行事曆',
		'amAnnual': '特休規則',
		'amFlexible': '彈性假規則',
		'amOtRule': '加班規則',
		'amOtWorkHour': '工時規則',
		'amSectionRule': '時段班別規則',
		'amAttendRule': '出勤時數規則',
		'wfDocType': '文件類別',
		'osCompany': '公司',
		'edQuitCause': '離職原因',
		'edBizProperty': '出差性質',
		'edBizArea': '出差地點',
		'edBizTrans': '交通工具',
		'edBizTodo': '委辦事項',
	},
	'hp.m5.m510010.wf064': {
		'quitDateTip': '離職生效日為最後工作日，員工當天仍算在職',
		'selectDate': '選擇日期',
		'quitCauseDescPla': '請輸入文字',
		'homeTelPla': '例如：02 22881256',
		'mobileTelPla': '例如：0912345678',
		'personalEmailPla': '例如：104@gmail.com',
		'postCodePla': '請選擇縣市區域',
		'contactAddressPla': '請輸入通訊地址',
		'handoverContentPla': '輸入工作內容，最多1000字',
		'resignMoreStay': '離職生效日必需大於留停作業生效日',
		'hasResignation': '已有大於生效日後的離職資料',
		'resignMoreDueDate': '離職生效日必需大於等於到職日',
		'handoverUpdateFailed': '交接文件寫入錯誤',
		'typeOfResignation': '離職類型',
		'resignationNumber': '離職編號',
		'effectiveDateOfSeparation': '離職生效日',
		'reasonForLeaving': '離職原因',
		'reasonForResignation': '離職原因說明',
		'contactAfterLeaving': '離職後聯絡方式',
		'homeTelLabel': '電話',
		'mobileTelLabel': '手機',
		'addressLabel': '地址',
		'handoverLabel': '交接工作資料',
		'handoverContentLabel': '交接工作內容',
		'handoverPersonLabel': '交接人',
		'handoverDocumentsLabel': '交接文件',
		'interviewRecordLabel': '面談記錄',
		'hrInterviewRecordLabel': 'HR 面談記錄',
		'reviewHrPla': '請輸入面談記錄，最多1000字',
		'supervisorInterviewRecordLabel': '主管面談記錄',
		'reviewLeaderPla': '請輸入面談記錄，最多1000字',
		'includeTurnoverRateLabel': '納入離職率計算',
		'neverHireLabel': '永不錄用',
		'neverHireReasonLabel': '永不錄用原因',
		'neverHiredReasonPla': '請輸入原因，最多1000字',
		'effectiveSetting': '生效設定',
		'resignationDateIsSalaryEffLabel': '離職日未到，計薪先行生效',
		'reasonForLeavingHasBeenDisabled': '離職原因已停用',
		'resignationIsNotEffectiveJobAlreadyExists': '離職未生效作業已存在',
		'reasonForLeavingHasBeenRemoved': '離職原因已刪除',
		'handoverPersonEmploymentStatus': '交接人已非在職狀態',
		'interviewDocuments':'面談檔案',
		'infoTel':'聯絡方式–電話',
		'infoPhone':'聯絡方式–手機',
		'infoEMail':'聯絡方式–Email',
		'infoAddress':'聯絡方式–地址',
	},
	'hp.m5.m510010.wf065': {
		'handoverPersonEmploymentStatus': '交接人已非在職狀態',
		'stayReasonRemoved': '留停原因已刪除',
		'theReinstatementDateIsGreaterThanStayDate': '預計復職日要大於留停生效日',
		'effectiveDateOfStayAndTypeIsNotRepeatable': '留停生效日+留停類型不可重複',
		'effectiveSateOfStayEqualToReinstatementDate': '留停生效日必需大於等於上次復職日',
		'dwellReasonDisabled': '留停原因已停用',
		'thereArePendingStayOperations': '尚有未生效的留停作業',
		'thereArePendingReinstatementOperations': '尚有未生效的復職作業',
		'noReinstatementOperations': '未有復職作業',
		'stayMoreDueDate': '留停生效日必需大於等於到職日',
		'handoverUpdateFailed': '交接文件寫入錯誤',
		'reasonForStay': '留停原因',
		'stopCauseDescPla': '請輸入文字',
		'stopDateTip': '留停生效日為最後工作日，員工當天仍算在職',
		'selectDate': '選擇日期',
		'homeTelPla': '例如：02 28980098',
		'mobileTelPla': '例如：0912345678',
		'personalEmailPla': '例如：104@gmail.com',
		'postCodePla': '請選擇縣市區域',
		'contactAddressPla': '請輸入通訊地址',
		'handoverContentPla': '輸入工作內容，最多1000字',
		'addHandoverWorkContent': '新增交接工作內容',
		'stayTypeLabel': '留停類型',
		'stayTNumberLabel': '留停編號',
		'reasonForStayLabel': '留停原因說明',
		'effectiveDateOfStayLabel': '留停生效日',
		'estimatedReturnDateLabel': '預計復職日',
		'stayDateIsSalaryEffLabel': '留職停薪日未到，計薪先行生效',
		'contactAfterLeaving': '留停期間聯絡方式',
		'homeTelLabel': '電話',
		'mobileTelLabel': '手機',
		'addressLabel': '地址',
		'handoverLabel': '交接工作資料',
		'handoverContentLabel': '交接工作內容',
		'handoverPersonLabel': '交接人',
		'handoverDocumentsLabel': '交接文件',
		'insuranceInformationLabel': '保險資料',
		'healthStatusLabel': '健保狀態',
		'laborInsuranceStatusLabel': '勞保狀態',
		'thereIsNoEffectiveReinstatementDate': '尚未有生效之復職日',
		'parentalLeaveInfo': '育嬰留停資訊',
		'ageNone': '年齡：--',
		'ageInfo': '年齡：<%=n%> 歲',
		'otherChild': '此位子女其他申請資料',
		'times': '次數',
		'parentalLeaveSeniority': '育嬰留停年資',
		'timesFormat': '<%=Y%> 年 <%=M%> 月 <%=D%> 日',
		'childRequired': '需填寫子女姓名',
		'childCareTypeRequired': '需填寫育嬰留停種類',
		'notExistChild': '<%=n%> 不存在',
		'notChildApplicant': '<%=n%> 的關係非子女',
		'warningStayDate': '留停生效日當日子女大於等於 3 歲',
		'warningReinstatementDate': '預計復職日子女大於 3 歲',
		'warningSeniority': '員工年資未滿 6 個月',
		'perviewChild': '<%=n%>（年齡：<%=y%> 歲）',
		'nameOfChild': '子女姓名',
		'typeOfParentalLeave': '育嬰留停種類',
		'downloadChild': '<%=t%>，<%=c%> 次，育嬰留停年資 ',
	},
	'sp.wf065.ed.emp.stop.Check': {
		'code11': '該公司沒有此員工',
		'code12': '<%=n%> 不存在',
		'code13': '育嬰留停種類不符合',
		'code14': '育嬰留停情境不符合',
		'code15': '<%=n%> 的關係非子女',
		'code21': '申請超過次數',
		'code22': '留停期間不符合申請年資限制',
		'code23': '已超過可申請時間',
		'code31': '留停生效日當日子女大於等於 3 歲',
		'code32': '留停生效日當日子女大於等於 3 歲',
		'code33': '預計復職日子女大於 3 歲',
		'code34': '預計復職日子女大於 3 歲',
		'code41': '員工年資未滿 6 個月',
		'code42': '員工年資未滿 6 個月',
		'code51': '已有大於等於留停生效日或展延生效日的復職資料',
		'code52': '申請期間與子女出生時間不符',
	},
	'hp.RouteWrapper': {
		'loginFailedTheAccountStatus': '系統已自動登出，請重新登入',
		'verifyOfYourAccount': '您無使用該功能權限，請重新確認您使用的帳號權限。',
	},
	'hp.Signin': {
		'pleaseSelectYourCompany': '請選擇您所屬的公司:',
		'passwordSettingFailed': '密碼設定失敗',
		'theAccountDoesNotExist': '帳號不存在',
		'theAccountStatusIsAbnormalAnd': '帳號狀態異常，無法變更密碼',
		'ifThePasswordDoesNotMeet': '密碼不符合登入規則要求的長度或複雜性，請重新設定',
		'ifYouLogInTooMany': '登入錯誤太多次，帳號將鎖定 <%=temp1%> 分鐘',
		'youVeLoggedInYou': '您已經登入過了，稍後將自動重新整理畫面...',
		'loginFailed': '登入失敗',
		'theAccountNumberOrPasswordIs': '帳號或密碼錯誤',
		'aDVerificationFailed': 'AD驗證失敗',
		'youAreCurrentlyUsingADevice': '您目前使用裝置(IP未允許)沒有存取此系統的權限',
		'ifTheAccountStatusIsAbnormal': '帳號狀態異常(鎖定、關閉、未驗證...)，請聯絡系統管理者',
		'accountPermissionsAreUnusualOrHave': '帳號權限異常或沒有權限',
		'enableTheAccount': '啟用帳號',
		'firstTimeUsingTheSystem': '第一次使用系統',
		'youMustEnableYourAccountFirst': '必需先啟用帳號',
		'steps': '步驟:',
		'Verification': '1. 驗證',
		'account': '帳號',
		'Settings': '2. 設定',
		'password': '密碼',
		'EnableFinish': '3. 啟用完成',
		'logIn': '登入',
		'forgotPassword': '忘記密碼',
		'thePasswordModificationIsComplete': '密碼修改完成',
		'hello': '<%=temp1%>您好,',
		'yourPassword': '您的密碼',
		'yourPasswordHasBeen': '您的密碼<%=temp1%>已經修改完成！',
		'canBeDirectly': '可直接<%=temp1%>，謝謝！',
		'logInToTheSystem': '登入系統',
		'setAPassword': '設定密碼',
		'passwordPlaceholder': '密碼',
		'confirmThePassword': '確認密碼',
		'yourPasswordMustMeetTheFollowing': '您的密碼必須符合以下要求',
		'theMinimumPasswordLengthIs': '密碼長度最小<%=temp1%>字元',
		'thePasswordIsACombinationOf': '密碼為英文數字組合',
		'thePasswordMustHaveASpecial': '密碼需有特殊符號',
		'thePasswordContainsAtLeastOne': '密碼至少包含一個大寫英文字',
		'thePasswordIsEnteredTheSame': '兩次密碼輸入相同',
		'account2': '帳號:',
		'inTheSetting': '設定中',
		'logInToYourAccount': '登入帳號 Account',
		'rememberTheAccountNumber': '記住帳號',
		'loginPassword': '登入密碼 Password',
		'theRequestToResetThePassword': '申請重設密碼失敗',
		'youEnteredTheWrongAccountNumber': '您輸入的帳號有誤。',
		'youAreUsingAnADAccount': '您使用的是AD帳號，重設AD帳號密碼請聯絡公司MIS人員，謝謝！',
		'yourAccountIsNotEnabled': '您的帳號未啟用，請連絡帳號管理者再寄一次帳號認證信',
		'yourAccountHasBeenClosed': '您的帳號已關閉，請連絡帳號管理者，謝謝!',
		'failedToGenerateToken': '產生token失敗',
		'failedToSendNotificationLetterWithout': '寄送通知信失敗，無信件範本',
		'userAccount': '使用者帳號',
		'applying': '申請中',
		'requestAPasswordReset': '申請重設密碼',
		'yourHasBeenSent': '您的<%=temp1%>已經寄送到<%=temp2%>，請盡速取信，並點選連結進行密碼重設，連結有效期限為<%=temp3%>分鐘，謝謝！',
		'PasswordResetLetter': '「密碼重設信函」',
		'weHaveNotifiedYourCompanyResponsible': '我們已經通知貴公司負責人員協助您重設密碼。',
		'ifYouNeedToUseThe': '若急須使用系統，請主動聯繫貴公司負責人員。謝謝！',
		'logBackIn': '重新登入',
		'yourAccountIsLockedPlease': '您的帳號鎖定中，請連絡帳號管理者，謝謝',
		'yourAccountHasBeenClosedThx': '您的帳號已關閉，請連絡帳號管理者，謝謝',
		'yourAccountIsNotVerified': '您的帳號未認證',
		'theInputIsWrongTooMany': '輸入太多次錯誤，帳號已被鎖定',
		'noAccountInformation': '無帳號資訊',
		'theUserAccountDoesNotExist': '該使用者帳號不存在',
		'passwordMinimumLengthCheckError': '密碼最小長度檢查錯誤',
		'thePasswordDoesNotMeetThe': '密碼不符合密碼設定要求，請重新設定',
		'theAccountStatusIsWrong': '帳號狀態錯誤',
		'theTimeHasNotYetCome': '時間未到',
		'duplicateLastPassword': '與上次密碼重複',
		'yourAccountIsAnIntegratedAD': '您的帳號為整合AD帳號，無法修改密碼',
		'authenticationModeError': '認證模式錯誤',
		'thePasswordWasEnteredIncorrectly': '密碼輸入錯誤',
		'theLinkToTheLetterIs': '信件連結已失效，請確認帳號是否開啟或已重新寄發帳號認證信',
		'passwordCannotBeChanged': '無法變更密碼',
		'thePasswordDoesNotMatch': '密碼不一致，請確認',
		'blankInputIsNotAllowed': '不允許輸入空白',
		'passwordRulesAreNotMet': '密碼規則不符合',
		'theFirstTimeYouUseThe': '第一次使用系統<%=temp1%>必需先啟用帳號<%=temp2%><%=temp3%>步驟:<%=temp4%>1.驗證<%=temp5%>與<%=temp6%><%=temp7%>2.設定<%=temp8%><%=temp9%>3.啟用完成',
		'authenticationCode': '認證碼',
		'theAccountIsEnabled': '帳號啟用完成',
		'yourAccountHasBeen': '您的帳號<%=temp1%>已經啟用完成！',
		'pleaseWithTheNew': '請用剛設定的新密碼<%=temp1%>，謝謝！',
		'hello2': ' 您好,',
		'ClickOnThe': '1.點擊信件<%=temp1%>',
		'EnableComplete': '2. 啟用完成',
		'link': '連結',
		'VerifyThat': '1.驗證<%=temp1%>與<%=temp2%>',
		'Set': '2.設定<%=temp1%>',
		'VerifyThat1': '1.驗證<%=temp1%>',
		'failedToEnableAccount': '啟用帳號失敗',
		'accountError': '帳號錯誤',
		'linkValidationFailed': '連結驗證失敗',
		'invalidLink': '無效的連結',
		'thisLinkHasExpiredPlease': '此連結已過期，請重新申請！',
		'yourCurrentDeviceIPIs': '您目前使用裝置(IP未允許)沒有存取此系統的權限，請換有權限的裝置或連絡帳號管理者，謝謝!',
		'anUnspecifiedErrorOccurred': '發生不明的錯誤',
		'verify': '驗證中 ...',
		'theLinkHasAlreadyCompletedThe': '該連結已經完成設定新密碼或者又有更新的申請；若是後者請使用最新收到mail中的連結，謝謝!',
		'youHaveSuccessfullyChangedThePassword': '您已經成功變更密碼，請以新密碼<%=temp1%>系統，謝謝！',
		'hello3': '您好，',
		'newPassword': '新密碼',
		'user': '使用者',
		'eMail': '郵件信箱',
		'confirmTheNewPasswordAgain': '再次確認新密碼',
		'confirmTheReset': '確定重設',
		'resetThePassword': '重設密碼',
		'reset': '重設中',
		'invalidLinks': '無效連結',
		'resetPasswordFailedThisLink': '重設密碼失敗：此連結已過期，請重新申請！',
		'yourCurrentDeviceIPNot': '您目前使用裝置(IP未允許)沒有存取此系統的權限，請換有權限的裝置或連絡帳號管理者',
		'theLinkHasAlreadyCompletedThePassword': '該連結已經完成設定新密碼或者又有更新的申請；若是後者請使用最新收到mail中的連結',
		'ifYouDoNotHaveAn': '無 email 可寄發密碼通知函，請聯絡系統管理員',
		'ifTheSystemIsAbnormalContact': '系統異常，請聯絡系統管理員',
		'requireSignInWithAadRuleMsg': '需要使用Microsoft帳號登入',
		'resetPasswordAadRuleMsg': '此帳號不適用，需使用Microsoft 帳號登入',
		'theAccountDoesNotExistOrNotAadRule': '帳號不存在，或不適用Microsoft帳號登入',
		'azureADVerificationFailed': 'Azure Active Directory驗證失敗',
		'companyNoAzureADLoginRules': '該公司無AzureAD登入規則',
		'oneTimePass': 'OTP 密碼',
		'fatalOtp': 'OTP 密碼錯誤，請重新輸入',
	},
	'hp.m5.m510020': {
		'startToEnd': '<%=temp1%> 至 <%=temp2%>',
		'yes': '有',
		'not': '無',
		'incomeTaxCalculationRules': '所得稅計算規則',
		'summary': '摘要',
		'downtimeTelephone': '留停期間-電話',
		'duringTheStayPeriodMobilePhone': '留停期間-手機',
		'stayEmail': '留停期間-Email',
		'periodOfStayAddress': '留停期間-地址',
		'youCanSeeTheFullInformation': '您可至表單內頁查看完整資訊',
		'principal': '主要及其他承辦人',
		'resubmittingFailed': '重送表單失敗',
		'notHavePermission ': '您已無 <%=name%> 的申請權限，無法重送表單',
		'approverFormNo': '簽核人/被異動人/表單編號',
		'changeApproverByBatch': '批次更改簽核人',
		'ｗithdrawByBatch': '批次抽單',
		'unableToWithdraw': '無法抽單',
		'resubmit': '重送',
		'withdrawnCompleted': '抽單完成',
		'withdrawnFailed': '抽單失敗',
		'beenWithdrawn': '表單已被他人抽單、刪單、簽核完成、或已進行結算，因此無法抽單',
		'changedSuccessfully': '批次更改簽核人成功',
		'ChangedFailed': '批次更改簽核人失敗',
		'fromTheOriginalSigner': 'Oops! 無任何原簽核人的待簽表單',
		'notPossibleToChange': 'Oops ! 全部無法更改簽核人',
		'skipAndProceed': '略過，繼續更改簽核人',
		'importSheetError': '因 excel 的 sheet 名稱精簡為 30 個字元後仍重複，建議您單獨下載表單，或調整表單名稱。',
	},
	'hp.SigninMobile': {
		'hello': '<%=temp1%>您好,',
		'yourAccountHasBeenLockedPlease': '您的帳號已鎖定，請於鎖定效期之後再次登入本系統或連絡帳號管理者，謝謝！',
		'failedToVerifyTheAccount': '驗證帳號失敗',
		'youEnteredTheWrongVerificationCode': '您輸入的認證碼有誤。',
		'validating': '驗證中',
		'verifyTheAccount': '驗證帳號',
	},
	'hp.Home': {
		'iMTheBest': '我最棒!',
		'specialBreak': '特休',
		'compensatoryLeave': '補休',
	},
	'hp.m5.m510010.wf040': {
		'theleaveCheckHasNotPassed': '假勤異動檢查未過',
		'failedToAApplyForALeaveOfAbsenceTransactionOPrderk': '假勤異動單申請失敗',
		'failedToWriteToLeaveMasterFile': '寫入假勤主檔失敗',
		'theTotalNumberOfLeavesOfAbsenceCannotBe0': '請假合計時數不可為0',
		'pleaseSelectTheTimeOfAbsence': '請先選擇假勤時間',
		'loadingErrorsForChangeableLeaveItems': '可異動假勤項目載入錯誤',
		'obtainingLeaveDataError': '取得假勤資料錯誤',
		'theOriginalApplicationLeaveTimeIsTheSame': '新增<%=formsetBasicName%>失敗：異動後時間不得與原申請假勤時間相同',
		'pleaseReselectTheLeaveTime': '請重新選擇假勤時間',
		'falseAttendanceCalculationError': '假勤計算錯誤',
		'pleaseSelectTheShiftLeaveItemFirst': '請先選擇異動假勤項目',
		'noneMessage': '無 <%=temp1%> <%=temp2%> <%=temp3%>',
		'noneMessageHour': '無 <%=temp1%> <%=temp2%>',
		'falseAttendanceDataError': '假勤資料錯誤: <%=temp1%>',
		'theStartDateOfTheLeave': '假勤起始日',
		'endOfLeaveDay': '假勤結束日',
		'leaveProject': '假勤項目',
		'leaveDay': '假勤日期',
		'schedulingEmployeesAreNotAllowedToAskForLeave': '新增<%=formsetBasicName%>失敗：不需排班員工不可請假',
		'leaveHoursCannotBe0Error': '新增<%=formsetBasicName%>失敗：請假合計時數不可為0',
		'attachError': '新增<%=formsetBasicName%>失敗：<%=message%>',
		'originalApplicationLeaveTime': '原申請假勤時間',
		'totalHoursOfLeave': '請假合計時數',
		'leaveTimeAfterTheChange': '異動後假勤時間',
		'changeReason': '異動原因',
		'noThisLeaveData': '該公司沒有此請假資料',
		'oldTotalLeaveDate': '原請假合計時數',
		'newLeaveDate': '異動後請假合計時數',
		'theTimeOfLeaveAfterThe': '異動後的假勤時間必須在「整體」的出差起訖時間內',
		'changeType': '異動類型',
		'changeableLeaveItem': '可異動假勤項目',
	},
	'hp.m5.m510010.wf090': {
		'attendanceSheetApplicationFailed': '出勤單申請失敗',
		'attendanceHoursCheckFailed': '出勤時數檢查未過',
		'failedToWriteToAttendanceMasterFile': '寫入出勤主檔失敗',
		'pleaseSelectTheAttendanceTimeFirst': '請先選擇出勤時間',
		'otherTimeRequirementLoadingError': '其他出勤時數規定載入錯誤',
		'pleaseReselectTheAttendanceTime': '請重新選擇出勤時間',
		'theActualTimeAndHoursResultOfTheAttendanceHoursRule': '您申請的出勤時間經系統比對出勤資料後，將調整為符合公司出勤時數規則的實際時間與時數結果。',
		'hourCheckError': '時數檢查錯誤',
		'errorReadingAttendanceRules': '讀取出勤規則錯誤',
		'attendancePeriod': '出勤時段',
		'attendanceHours': '出勤時數',
		'actualResultsAdjustedToComplyWithCompanyTimeOfDayRules': '您申請的時數並非為最終結果，尚待系統比對出勤資料後，調整為符合公司出勤時數規則的實際結果。',
		'actualResultsAdjustedToComplyWithCompanyHoursOfAttendanceRules': '已將您申請的時數，調整為符合公司出勤時數規則的實際結果。原申請時間：<%=attendStart%>至<%=attendEnd%>，',
		'attendanceTotalHoursLoadingError': '出勤總計時數載入錯誤',
		'totalHoursOfAttendance': '出勤總計時數',
		'attendanceHoursStatistics': '出勤時數統計',
		'costCenterItem': '成本中心：<%=name%>，出勤時數<%=hours%>',
		'applicationType': '申請類型',
		'attendanceTime': '出勤時間',
		'attendanceAttributionDate': '出勤歸屬日',
		'totalAttendanceHours': '出勤合計時數',
		'reasonForAttendance': '出勤原因',
		'typeNoLongerOpen': '已不開放此申請類型',
	},
	'hp.m5.m510010.wf020': {
		'overtimeApplicationFailed': '加班單申請失敗',
		'overtimeCheckHasNotPassed': '加班單檢查未過',
		'failedToWriteOvertimeMasterFile': '寫入加班主檔失敗',
		'advanceOvertimeHoursLoadingError': '預先加班時間載入錯誤',
		'errorGettingAdvanceOvertimeHours': '取得預先加班時間錯誤',
		'withPreAppliedOvertime': '有預先申請加班',
		'actualResultsAdjustedToComplyWithCompanyOvertimeRules': '您申請的時數並非為最終結果，尚待系統比對出勤資料後，調整為符合公司加班規則的實際結果。',
		'totalOvertimeHoursLoadedIncorrectly': '加班總計時數載入錯誤',
		'totalOvertimeHours': '加班總計時數',
		'overtimeStatistics': '加班統計',
		'actualOvertime': '實際加班時間',
		'totalActualOvertimeHours': '實際加班合計時數',
		'advanceOvertime': '預先加班時間',
		'totalNumberOfOvertimeHoursWorkedInAdvance': '預先加班合計時數',
		'theSelectedAdvanceOvertimePayHas': '員工預先加班單不存在',
		'costCenterItem': '成本中心：<%=name%>，加班費 <%=otName%>，補休假 <%=calName%>',
		'clockInOut': '打卡時間',
		'totalOverTimeApplication': '加班總計時數(不含本次申請)',
		'mailClock': '打卡 ',
	},
	'hp.m5.m510010.wf022': {
		'exchangeMethod': '抵換方式',
		'overtimeCheckHasNotPassed': '加班單檢查未過',
		'failedToApplyForPreOvertimeWorkOrder': '預先加班單申請失敗',
		'failedToWritePreOvertimeMasterFile': '預先加班單申請失敗',
		'appliedHoursWithTheAttendanceDataAgain': '您申請的時數並非最終結果，待申請加班單時，系統將再次比對出勤資料。',
		'overtime': '加班時間',
		'totalOvertimeHours': '加班合計時數',
		'failedToWriteToMasterFileOfPreOvertimeWorkSheet': '寫入預先加班單主檔失敗',
		'deductRestTimeOldInitial': '根據公司規定而決定是否扣除休息時間',
		'deductRestTime': '扣除休息時間',
	},
	'hp.m5.m510010.wf060': {
		'theReasonForTheChangeIsDisabled': '異動原因已停用',
		'theReasonForTheChangeHasBeenDeleted': '異動原因已刪除',
		'clockingInAndWorkingOvertimeOn': '工作日打卡轉加班',
		'asAReminderIfYouAdjust': '提醒您，若調整職等，也需同步調整職級，避免職級變成空白。',
		'remindYouThatIfYouAdjust': '提醒您，若調整工作區域，也需同步調整工作地點，避免工作地點變成空白。',
		'atLeastOneProjectChange': '至少要有一個項目更動',
		'employeesOnTheDayOfChange': '異動日員工需在職',
		'theChangeProjectHasNotYet': '異動項目有未生效異動',
		'thereAreRelativelyNewChangesIn': '異動項目有較新的已生效異動',
		'ifThereIsALeaveRequest': '生效日以後已有請假資料，班別屬性不可異動為不需排班',
		'thePreChangeShiftAndThe': '異動前班別與異動後班別，工作時間重疊，不可儲存',
		'ifTheCardComparisonFieldNeeds': '若刷卡比對欄位為需比對及產生異常、需比對不須產生異常時，則允許打卡方式欄位異動後需有一項為是',
		'theSpecialBreakRuleIsNull': '特休規則異動後為空值',
		'overtimeRulesAreNullAfterChanges': '加班規則異動後為空值',
		'nullValueAfterAChangeIn': '工時規則異動後為空值',
		'theValueIsNullAfterThe': '刷卡比對異動後為空值',
		'theClassAttributeIsNullAfter': '班別屬性異動後為空值',
		'theChangeInClassAttributesIs': '班別屬性異動為不需排班(依時數申請)，不可設定班別、時段班別規則',
		'theChangeInClassAttributesIsNeedCalendar': '班別屬性異動為不需排班(依時數申請)，需設定行事曆、特休假規則、出勤時數規則、工作日打卡轉加班、加班規則、工時規則',
		'theChangeInClassAttributesIsNotNeedCalendar': '班別屬性異動為排班(依時段)，不可設定班別、行事曆、出勤時數規則、工作日打卡轉加班',
		'theChangeInClassAttributesIsNeedRule': '班別屬性異動為排班(依時段)，需設定時段班別規則、特休假規則、加班規則、工時規則',
		'theChangeInClassAttributesIsNotNeedRule': '班別屬性異動為排班(依班別)，不可設定班別、行事曆、時段班別規則、出勤時數規則、工作日打卡轉加班',
		'theChangeInClassAttributesIsNeedAnnual': '班別屬性異動為排班(依班別)，需設定特休假規則、加班規則、工時規則',
		'theChangeOfClassAttributesIs': '班別屬性異動為固定班，不可設定時段班別規則、出勤時數規則、工作日打卡轉加班',
		'theClassAttributeChangeIsA': '班別屬性異動為固定班，需設定班別、行事曆、特休假規則、加班規則、工時規則',
		'ifTheEmployeeHasInformationOn': '員工有異動生效日之前的未生效留停及離職資料',
		'employeeAttendanceRulesNeedToExist': '<%=temp1%>：員工出勤規則需存在',
		'theNewPersonnelChangeOrderFailed': '新增人事異動單失敗',
		'classAttributeChangeIsFixedClass': '<%=temp1%>班別屬性異動為固定班，',
		'shiftAttributeChangeToShiftAccording': '<%=temp1%>班別屬性異動為排班(依班別)，',
		'shiftAttributeChangeIsScheduledAccording': '<%=temp1%>班別屬性異動為排班(依時段)，',
		'classAttributeChangeIsNotRequired': '<%=temp1%>班別屬性異動為不需排班(依時數申請)，',
		'specialLeaveRules': '特休假規則',
		'settingsRequired': '需設定',
		'notConfigurable': '不可設定',
		'impeachmentLeaveRules': '彈休假規則',
		'noAttendanceRules': '無出勤規則',
		'selected': '已選<%=temp1%>項',
		'ifTheCalendarTimeBeforeAnd': '異動前後曆日時間不同，刪除生效日以後的班表資料才可生效此異動',
		'someWorkingHoursDoNotSupport': '部分工時不支援特休預給',
		'changedDescription': '異動說明',
	},
	'hp.m5.m510010.wf070': {
		'effectiveDate': '生效日 <%=date%>',
		'pleaseSelectACostCenter': '請選擇成本中心',
		'apportionmentRate': '分攤比率',
		'holiday': '假日',
		'whetherHolidaysArePaid': '假日是否給薪',
		'remindYouThatTheSalaryUnit': '提醒您，計薪單位異動，請注意薪資項目的計算方式與最終金額！',
		'pleaseEnterANumber': '請輸入數字',
		'thereIsNoSalaryDataFor': '員工無薪資資料',
		'hourlyEmployeesCannotSetAFull': '時薪員工不可設定全勤獎金',
		'thereAreAlreadyChangesToThe': '已有同一項目且異動生效日同一日的薪資規則異動',
		'theChangeProjectHasMoreInformation': '異動項目有比此筆異動生效日之後的異動資料',
		'thereIsNoEffectiveInformationFor': '異動項目有未生效資料',
		'employeesShouldBeEmployedOnThe': '異動生效日員工應該在職',
		'noSalarySettlementInformationIsAvailable': '異動生效日之後不可有薪資結檔資料',
		'costCenterChangeDataIsAvailable': '已有大於等於此異動生效日的成本中心異動資料',
		'theSumOfTheCostCenter': '成本中心比例總和不為100',
		'salaryCalculationInformationCannotBeAvailable': '異動生效日後不能有薪資計算資料',
		'employeePayRulesNeedToExist': '員工薪資規則需存在',
		'salaryAdjustmentInformationIsAvailableOn': '已有同一異動生效日的調薪資料',
		'addedFailureNoSalaryDataFor': '新增<%=temp1%>失敗：員工無薪資資料',
		'costCenterProportionsMustAddUp': '成本中心比例相加需為 100%',
		'addFailurePayrollAccountCurrencyData': '新增<%=temp1%>失敗：薪資科目+幣別資料不可重複',
		'pleaseSelectTheReasonForThe': '請選擇異動原因',
		'noPayrollData': '無薪資資料',
		'amount': '金額',
		'totalNTD': '總計(新台幣)',
		'newTaiwanDollar': '新台幣',
		'salaryStructure': '薪資結構',
		'payrollItems': '薪資項目',
		'pleaseSelectAReason': '請選擇原因',
		'theReasonForTheChangeIsDisabled': '異動原因已停用',
		'theReasonForTheChangeHasBeenDeleted': '異動原因已刪除',
		'ruleVars': '計算規則異動資訊',
		'varsCause': '薪資結構核薪原因',
		'structureVars': '薪資結構異動資訊',
		'payAlteredAfter': '異動生效日後已有調薪異動資料',
	},
	'hp.m5.m510010.wf021': {
		'overtimeCheckError': '加班單檢查錯誤：',
		'theFormInformationIsIncomplete': '表單資訊不完整',
		'overtimeWorkersDoNotIncludeEmployees': '加班人未包含套用簽核流程的員工',
		'thereIsAnErrorInThe': '套用簽核流程錯誤',
		'addANewStroke': '新增一筆',
		'sinceTheOvertimeHoursAreHours': '因加班時數為0小時，無法產生簽核流程，請重新選擇其他員工',
		'common': '共',
		'totalEmps': '加班共 <%=temp1%> 人',
		'employee': '人',
		'deducted': '扣除休息時間',
		'companyRegulations': '根據公司規定而決定是否扣除休息時間'
	},
	'hp.m5.m510010.wf021_row': {
		'advancedSearch': '進階搜尋',
		'overtimePayCanOnlyBeClaimed': '僅能申請加班費',
		'youCanOnlyApplyForCompensatory': '僅能申請補休假',
		'overtimePayCompensatoryLeave': '加班費 + 補休假',
		'employeeNumberNameEnglishName': '員工編號/姓名',
		'listOfEmployees': '員工名單',
		'selected': '已選擇',
		'importIn': '匯入',
		'bit': '位',
		'ifOvertimeAllowedDuringRest': '若休息時間允許加班',
		'deductedRestPeriods': '休息時間',
	},
	'hp.m5.m510010.wf011': {
		'batchLeaveApplicationIsSuccessful': '批次請假單申請成功',
		'batchLeaveRequestFailed': '批次請假單申請失敗',
		'aMaximumOfGroupsCanBe': '假勤最多申請20組',
		'theLeaveApplicantDoesNotInclude': '請假人未包含套用簽核流程的員工',
		'sinceTheNumberOfLeaveHours': '因請假時數為0小時，無法產生簽核流程，請重新選擇其他員工',
		'total': '<%=temp1%> - <%=temp2%> 共<%=temp3%><%=temp4%>',
		'of': '的',
	},
	'hp.m5.Commons': {
		'formNumber': '表單編號：<%=temp1%>',
		'addApproverPrior': '新增我簽核前的簽核人員',
		'exceedApprovalTimeTitle': '超過可簽核時間',
		'overTimeLimitRejection': '因超過可簽核時間，僅可駁回表單',
		'pendingAtOthers': '表單正待其他人員簽核',
		'overrule': '駁回',
		'rejection': '駁回',
		'reject-pastTense': '駁回',
		'approved': '核准',
		'approval': '核准',
		'signOff': '簽核',
		'preSignoff': '預簽核',
		'operate': '操作',
		'failure': '<%=temp1%>失敗',
		'theFormHasAlreadyBeenSigned': '這張表單已被他人簽核，您已無需處理',
		'theFormCannotBeSignedPlease': '表單已無法簽核，請確認假勤狀態',
		'failure2': '<%=temp1%>失敗: <%=temp2%>',
		'oopsThereIsAnAbnormalStatus': 'Oops！請假有異常狀態',
		'ifSomeOfTheLeaveIn': '本表單部份假勤有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'oopsThereIsAnAbnormalState': 'Oops！加班有異常狀態',
		'ifThereIsAnAbnormalState': '本表單部份加班有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'oopsThereIsAnAbnormalStatus2': 'Oops！薪資異動有異常狀態',
		'oopsPersonnelAbnormalStatus': 'Oops！人事異動有異常狀態',
		'oopsTheBatchLeaveHasAn': 'Oops！批次請假有異常狀態',
		'ifSomeOfTheLeaveRequests': '本表單部份請假有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'oopsBatchOvertimeHasAnAbnormal': 'Oops！批次加班有異常狀態',
		'oopsAttendanceAbnormalStatus': 'Oops！出勤<%=temp1%>有異常狀態',
		'time': '時段',
		'ifThereIsAnAbnormalStatus': '本表單部份出勤<%=temp1%>有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'oopsThereIsAnAbnormalState3': 'Oops！預先加班有異常狀態',
		'theNumberOfApplicationHoursIs': '申請時數有變動',
		'originalApplication': '原申請：',
		'actualApproval': '實際核可：',
		'signoffStatus': '簽核狀態：',
		'pendingYourSignOff': '待您簽核',
		'waitingForYourReply': '待您回覆',
		'downloadExceptionError': '下載異常<%=temp1%>錯誤',
		'list': '名單',
		'information': '資訊',
		'theDownloadFormDidNotWork': '下載表單未施作',
		'downloadException': '下載異常<%=temp1%>',
		'yourSignatureResult': '您簽核結果:',
		'currentProcessSignOff': '目前流程：簽核中',
		'currentProcessApproved': '目前流程：核准',
		'endTheProcess': '結束流程',
		'currentProcessRejection': '目前流程：駁回',
		'currentProcessLottery': '目前流程：抽單',
		'currentProcessDeleteTheOrder': '目前流程：刪單',
		'mainBusinessContractors': '業務主要承辦人：',
		'contractorPhone': '承辦人電話：',
		'drawOrders': '抽單',
		'deleteAList': '刪單',
		'unarchive': '取消封存',
		'approved2': '已核准',
		'batchTempCompleted': '批次<%=temp1%>完成',
		'oopsNoneOfThemCanBe': 'Oops ! 全部無法簽核',
		'approvedTemp': '已核准<%=temp1%>筆',
		'personnelRepeatsTempPen': '人員重複<%=temp1%>筆',
		'reselect': '重新選擇',
		'iKnow': '我知道了',
		'skipAndProceedWithSignOff': '略過，繼續簽核',
		'restAssuredThatOtherFormsHave': '請放心，其他表單已核准',
		'youChoseForm': '你選取了<%=temp1%>張表單',
		'approvalSignOffComplete': '核准 > 簽核完成',
		'signOffOnComments': '簽核意見',
		'sign': '會簽',
		'pleaseSelectTheCountersigner': '請選擇會簽人員',
		'pleaseSelectAPersonWhoAsked': '請選擇詢問意見人員',
		'syncNotificationsCheckable': '同步通知(可複選)',
		'selectSyncNotifiers': '請選擇同步通知人員',
		'ifYouDoNotNeedTo': '若您不須新增，可直接確認<%=temp1%>',
		'allTemp': '全部<%=temp1%>',
		'pen': '已<%=temp1%><%=temp2%>筆',
		'restAssuredThatTheOtherForms': '請放心，其他表單已<%=temp1%>',
		'oopsAllCannotBe': '全部無法<%=temp1%>',
		'processedPens': '已處理<%=temp1%>筆',
		'restAssuredThatOtherFormsHave2': '請放心，其他表單已處理',
		'cause': '<%=temp1%>原因',
		'repeatSignOff': '重覆簽核',
		'inAdditionThisFormHasAlready': '另外這<%=temp1%>筆表單已被他人簽核，所以您已無需處理',
		'inAdditionThisFormHasAlready2': '另外這 <%=temp1%> 筆表單已完成簽核流程，所以您已無需處理',
		'duplicationOfPersonnel': '人員重覆',
		'thePersonYouSelectedIsAlready': '您選取的人員已為簽核 / 意見回覆者 / 申請人，請重新選擇或是繼續簽核其他表單',
		'thePersonYouSelectedIsAlready2': '您選取的人員已為簽核 / 意見回覆者 / 申請人',
		'hasServedAsASignator': '已擔任簽核者',
		'thoseWhoHaveRespondedToComments': '已擔任意見回覆者',
		'isAFormApplicant': '為表單申請人',
		'unableToSignOff': '無法簽核',
		'inAdditionThisFormCannotBe': '另外這<%=temp1%>筆表單無法簽核',
		'inAdditionThisFormCannotBe2': '另外這 <%=temp1%> 筆表單因如下原因無法簽核',
		'cannotSignOffTheseAs': '另外這 <%=count%> 筆表單不可<%=action%>',
		'restrictCountersignTitle': '無法使用會簽功能',
		'restrictCountersignMsg': '所選表單僅具備核准權限，無法使用會簽功能',
		'restrictAskMsg': '所選表單僅具備核准權限，無法使用詢問意見功能',
		'systemError': '系統錯誤',
		'theAskForOpinionFeatureIs': '無法使用詢問意見功能',
		'theSelectedWindowSheetIsThe': '所選表單為最後一關，無法使用詢問意見功能',
		'theFormHasRespondedToComments': '表單已回覆意見',
		'theSignOffProcessHasEnded': '簽核流程已結束，無法回覆',
		'respondToComments': '回覆意見',
		'opinion': '意見',
		'enterYourOpinionUpToWords': '輸入意見，最多100字',
		'youHaveAlreadyServedAsA': '已擔任簽核人，請重新選擇',
		'alreadyAResponderToTheOpinion': '已經是意見回覆者，請重新選擇',
		'confirmTheAddition': '確認新增',
		'completeTheAdditionOfPreSigners': '完成新增預簽核人',
		'thisFunctionIsToAddA': '這個功能是在您簽核【前】，新增一位簽核人來審批表單，<%=temp1%>您必須等待該簽核人的簽核結果，才能繼續審批流程。',
		'pleaseSelectASignOff': '請選擇簽核人員',
		'ifYouDoNotNeedTo2': '若您不須新增，可直接確認駁回',
		'confirmTheRejection2': '確認駁回',
		'rejected': '已駁回',
		'ifYouDoNotNeedTo3': '若您不須新增，可直接確認核准',
		'confirmApproval': '確認核准',
		'askForOpinions': '詢問意見',
		'endProcess': '結束流程<%=temp1%>',
		'applied': '已申請',
		'toBeSigned': '待簽核',
		'replied': '已回覆',
		'toBeReplied': '待回覆',
		'pleaseEnterAReason': '請輸入原因',
		'cause2': '原因：',
		'cause3': '原因',
		'opinion2': '意見：',
		'theChangeOfSignOffWas': '更改簽核人成功',
		'noNewSignOffIsSelected': '未選擇新簽核人',
		'forFormApplicantsPleaseSelectAgain': '為表單申請人，請重新選擇',
		'noChangeInSignOff': '沒有更改簽核人',
		'changeTheSignoffper': '更改簽核人',
		'formNumber2': '表單編號：',
		'raw': '原始',
		'change': '更改',
		'systemExceptionDataWriteFailed': '(系統異常，資料寫入失敗)',
		'theCounterSignerAndThePerson': '會簽人員與詢問意見人員不可相同',
		'addSignOffFormer': '新增簽核人* (前)',
		'theRemainingWereNotSigned': '尚有 <%=temp1%> 筆表單未簽核，請重新選擇',
		'ifSomeOfTheAbnormalItems': '本表單部分異動項目有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'notified': '已通知',
		'notNotified': '待通知',
		'changed': '更改簽核人',
		'viewChanged': '查看調整',
		'notifiedCkpDesc': '通知對象',
		'sysSigned': '系統代簽',
		'flowEnd': '結束',
		'agent': '代理人',
		'changeSignerFail': '更改簽核人失敗',
		'signersLostSync': '簽核人資訊已更新，請重新整理後再試一次',
		'duplicatedOldEmp': '同一關的原簽核人員不可重複，請重新選擇',
		'duplicatedNewEmp': '同一關卡已有相同的簽核人員，請確認是否更改。',
		'oldSigner': '原簽核人員',
		'newSigner': '新簽核人員',
		'oldSigner2': '原簽核人',
		'newSigner2': '新簽核人',
		'changer2': '更改人',
		'changeTime2': '更改時間',
		'notifyTime': '通知時間',
		'notifiedEmp': '被通知人',
		'downloadSummaryTable': '下載總表',
		'downloadForm': '下載表單',
		'downloadTime': '下載時間：',
		'systemAnomaly': '(系統異常)',
		'person': '主要承辦人',
		'personTel': '主要承辦人電話',
		'latestTime': '最後處理時間',
		'formNo': '表單編號',
		'downloadTime2': '下載時間',
		'onlyApprove': '僅核准',
		'oopsFormId17Title': 'Oops！表單有異常狀態',
		'oopsFormId17Msg': '本表單部分時間有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'isMultiTip3': '需全員核准',
		'isMultiTip4': '僅需一人核准',
		'oopsCancelLeaveAnAbnormalStatus': 'Oops！銷假有異常狀態',
		'ifCancelLeaveTheAbnormalItems': '本表單有異常狀態，您可駁回此張表單，或取消駁回，待資料正確後再核准',
		'systemReject': '（系統駁回）',
	},
	'hp.m5.Commons,Decision.Footer': {
		'approve': '核准中',
		'reject': '駁回中',
		'terminate': '抽單中',
		'delete': '刪單中',
	},
	'hp.m5.Commons.Decision.Mail': {
		// 'title': '簽核中...',
		'signingOffMsg': '簽核中，請稍候…',
		'signOffConfirmMsg': '請確定是否要<%=action%>？',
		'confirmBtn': '確定',
		'cancelBtn': '取消',
		'cancelledMsg': '已取消，未送出簽核',
		'notExist': '查無表單資料',
		'beWithdrawn': '表單已被抽單',
		'beDeleted': '表單已被刪單',
		'beSignedOff': '表單已被簽核',
		'cannotSignOff': '無法簽核，請查看表單資訊',
		'signOffSuccess': '核准成功',
		'rejectSuccess': '駁回成功',
	},
	'hp.m5.m510010.index': {
		'profileLoadingError': '個人資料載入錯誤',
		'unableToApply': '無法申請',
		'youDonTCurrentlyHaveA': '您目前沒有可申請的表單',
		'theAdditionSuccess': '新增<%=temp1%>成功',
		'theNewFailed': '新增<%=temp1%>失敗',
		'toFindOutPleaseProceedWith': '了解，請繼續申請',
		'returnToRefill': '返回重填',
		'leaveHoursCanBeRequested': '可申請假勤時數',
		'leaveStatistics': '假勤統計',
		'generalLeaveWork': '一般假勤',
		'noUpperLimit': '無上限',
		'compensatoryLeave': '補休',
		'elasticFake': '彈性假',
		'secondary': '次',
	},
	'components.AttachFile': {
		'unableToUploadExecutableFileE': '不能上傳執行檔',
		'maximumFileSizeMB': '，檔案大小上限 3MB',
		'filesExceedTheLimitOfMB': '檔案超過上限 3 MB',
		'unsupportedFileTypes': '不支援的檔案類型',
		'pleaseSelectAtLeastFiles': '請選擇至少 <%=temp1%> 個檔案!',
		'theFileNameCannotContainSpecial': '檔案名稱不可包含特殊字元 <%=temp1%>',
		'fileSizeExceedsLimit': ' 檔案大小超過限制!',
		'uploadFailed': '上傳失敗!<%=temp1%>',
		'deleteFailed': '刪除失敗!',
		'noFileSelected': '沒有選擇檔案!',
		'uploadTheFile': '上傳檔案',
	},
	'hp.m5.commonsDetail': {
		'applicationTime': '申請時間',
		'costCenter': '成本中心',
		'overtimeCategory': '加班類別',
		'overtimePeriod': '加班時段',
		'workOvertime': '加班',
		'overtime': '加班時間',
		'hours': '時數',
		'waysOfWorkingOvertime': '加班抵換方式',
		'support': '支領',
		'missedMealFee': '誤餐費',
		'payForMissedMeals': '支領誤餐費',
		'reasonForOvertime': '加班原因',
		'failedToLoadJudgmentCardSwipingTimeSetting': '載入判斷刷卡時間設定失敗',
		'theDayTheEventOccurred': '事件發生日',
		'theReasonForTheDayThe': '事件發生日原因',
		'timeOff': '假勤時間',
		'leaveDate': '請假日期',
		'jobAgent': '職務代理人',
		'signOffAgent': '簽核代理人',
		'reasonForTakingLeave': '請假原因',
		'contentOfTheApplication': '申請內容',
		'leavePerson': '請假人',
		'overtimers': '加班人',
		'costCenterByEmployeePayroll': '依員工薪資成本中心',
		'reasonsForTheWriteOff': '銷假原因',
		'holidayTemp': '假日<%=temp1%>',
		'totalSalary': '總薪資',
		'totalItems': '共<%=temp1%>項',
		'shift': '班別',
		'formNo': '申請單編號',
		'shiftAdjustmentTime': '調班時間',
	},
	'hp.service.m5.service-m510010_wf010': {
		'err490': '尚未設定系統串接欄位',
		'err490Last': '尚未設定系統串接欄位，無法回拋資料',
		'err491': '未產生簽核流程，無法啟動表單',
		'err492': '寫入表單失敗',
		'err493': '附件寫入錯誤',
		'err494': '寫入假勤主檔失敗',
		'err498': '申請假勤失敗 (其他原因)',
		'err499': '加扣項科目不存在',
		'err500': '加扣期間員工未到職',
		'err501': '加扣金額必須大於 1',
		'err502': '加扣幣別不存在',
		'err503': '加扣金額最多小數點後 X 位',
		'err504': '成本中心歸屬方式不存在',
		'err505': '成本中心不存在',
		'err506': '成本中心若為「依員工薪資成本中心」，不需填寫成本中心及分攤金額',
		'err507': '成本中心若為「自訂成本中心」，成本中心及分攤金額為必填',
		'err508': '分攤成本最多小數點後 X 位',
		'err509': '分攤金額加總需等於加扣金額',
		'err510': '特休假名稱不存在',
		'err511': '特休假已停用',
		'err512': '特休年度不存在',
		'err513': '特休例外人員結轉設定年度假勤重複',
		'err514': '該年度假勤已結轉',
		'err515': 'X 年度無特休假',
		'err516': '結轉方式不存在',
		'err517': '優先處理不存在',
		'err518': '所選擇的結轉方式和優先處理欄位的必填與否無法對應',
		'err519': '結轉後期限不存在',
		'err520': '結轉後期限若為「於下一特休假年度均可休」，不需填寫天數及日期',
		'err521': '結轉後期限若為「於下一特休假年度 X 天內休完」，天數為必填，且不需填寫日期',
		'err522': '結轉後期限若為「於下一特休假年度 MM/DD 內休完」，日期為必填，且不需填寫天數',
		'err523': '天數僅可為正整數',
		'err524': '天數必需為大於等於 1 的正整數',
		'err525': '天數必需為小於等於 99 的正整數',
		'err526': '日期格式不正確',
		'err527': '最多 500 個字元',
		'err528': '最多可上傳5個檔案',
		'err529': '成本中心重複',
		'err530': '檔案超過上限 3 MB',

	},
	'hp.service.m5.service-m510010_wf021': {
		'theBatchOvertimeOrderApplicationWas': '批次加班單申請成功',
	},
	'hp.m5.m510010.wf011_row': {
		'bit': '位',
	},
	'app.api.wf.api-wf040': {
		'employeesWhoDoNotNeedTo': '不需排班員工不可請假',
	},
	'hp.service.m5.service-m510010_wf060': {
		'thereAreNoChangesInPersonnel': '人事異動項目有未生效異動',
		'thereAreRelativelyNewChangesIn': '人事異動項目有較新的已生效異動',
		'notInEffect': '未生效',
	},
	'hp.m4.m410120': {
		'changeTheAccountID': '變更帳號ID',
		'changeTheLoginPassword': '變更登入密碼',
		'changeThePaybagPassword': '變更薪資袋密碼',
		'changeThePasswordWhenLoggingIn': '變更登入系統時的密碼。',
		'payrollBag': '薪資袋',
		'pleaseBeAssuredThatThisIs': '請放心，這是變更電子薪資袋的密碼，與登入時的密碼並不相同。',
		'identifyTheChange': '確定變更',
		'theAccountIDHasBeenChanged': '帳號ID變更成功',
		'theAccountIDWasChangedIncorrectly': '帳號ID變更錯誤',
		'theOriginalAccountIDIsInconsistent': '原帳號ID不一致',
		'accountDataDoesNotExist': '帳號資料不存在',
		'theNewAccountIDIsThe': '新帳號ID與舊帳號ID相同',
		'enterTheSameIDAsThe': '輸入的原帳號ID與新帳號ID相同',
		'originalAccountNumber': '原帳號',
		'newAccount': '新帳號',
		'pleaseEnterANewAccountNumber': '請輸入新帳號',
		'theLoginPasswordWasChangedSuccessfully': '變更登入密碼成功',
		'failedToChangeLoginPassword': '變更登入密碼失敗',
		'theOldPasswordWasEnteredIncorrectly': '舊密碼輸入錯誤',
		'theOldAndNewPasswordsCannot': '新舊密碼不可以一樣，請確認',
		'theNewPasswordIsInconsistentPlease': '新密碼不一致，請確認',
		'originalPassword': '原<%=temp1%>密碼',
		'newPassword': '新<%=temp1%>密碼',
		'thePayrollBagPasswordWasChanged': '變更薪資袋密碼成功',
		'failedToChangePayrollBagPassword': '變更薪資袋密碼失敗',
		'theApplicationDoesNotExist': '應用程式不存在',
		'theEmployeePaybagPasswordInformationDoes': '員工薪資袋密碼資料不存在',
		'thePayrollBagPasswordStatusIs': '薪資袋密碼狀態錯誤',
		'payrollBagPasswordToBeEnabled': '薪資袋密碼待啟用',
		'thePayrollBagPasswordIsLocked': '薪資袋密碼已鎖定',
		'thePaybagPasswordHasBeenDeactivated': '薪資袋密碼已停用',
		'enteredTooManyTimesByError': '輸入太多次錯誤:帳號已被鎖定',
		'thePasswordWasChangedSuccessfully': '密碼變更成功',
		'textAndNumberCheck': '文數字檢查',
		'thePasswordMustBeCheckedFor': '密碼需有特殊符號檢查錯誤',
		'theOldAndNewPasswordsCannot2': '新舊密碼不可以一樣',
		'changeTheEmailLanguage': '變更郵件語系',
		'theUserLanguageFamilyWasModified': '郵件語系變更成功',
		'failedToModifyUserLanguage': '郵件語系變更失敗',
		'mailLanguage': '郵件語系',
		'dataNotModified': '未修改資料',
		'languageDataError': '語系資料錯誤',
	},
	'hp.m4.m410121': {
		'filledIllustrate1': '若您有多種通勤方式，請填寫從家裡到辦公室【最主要】的通勤方式。不需考慮客戶拜訪行程的通勤方式。',
		'filledIllustrate2': '',
		'transName': '交通工具',
		'commuteStloc': '出發地',
		'commuteDsloc': '目的地',
		'commuteKM': '里程',
		'fillSelectedAddress': '請輸入地址且於選單中選擇正確地址',
		'GPSCoordinate': 'GPS 座標',
		'add': '新增通勤方式',
		'save': '儲存',
		'showMap': '顯示地圖',
		'hideeMap': '關閉地圖',
		'km': '公里',
		'lastSave': '最後存檔時間：',
		'saveSuccessfully': '儲存成功',
		'dataIsNotEdited': '資料未異動',
		'stlocAndDslocCanNotBeSame': '里程不可為 "0"，請調整交通工具的出發地和目的地',
		'selectTaichungStation': '請選擇臺中捷運車站',
		'selectTaipeiStation': '請選擇臺北捷運車站',
		'selectTaoyuanStation': '請選擇桃園捷運車站',
		'selectHighSpeedStatsion': '請選擇高鐵車站',
		'requiredField': '必填欄位',
		'serialNumber': '序號'
	},
	'wf.normal': {
		'waitingForApproval': '等待人員簽核中...',
		'approvalCompleted': '簽核完畢',
		'formHasBeenSigned': '表單已被他人簽核',
		'formInAccess': '其它使用者正在簽核此表單，請稍後重試',
	},
	'wf.service.wf010': {
		'noThisForm': '查無此表單',
		'noThisLeave': '查無假勤資料',
		'cannotVerifyHour': '無法檢查時數',
	},
	'app.api.wf.api-global': {
		'getWFReqBasic.404': '無法操作此表單',
		'isCalOrClose1': '假勤可能已計算或結檔',
		'isCalOrClose2': '假勤可能已銷假、計算或結檔',
		'noOneNeedsToSignOff': '無人需簽核',
	},
	'app.api.wf.api-wf010': {
		'noLimit': '無上限',
		'used': '已休',
		'remains': '尚可申請',
	},
	'app.api.wf.api-wf030': {
		'empNotWorking': '該日期此員工不在職',
		'FutureDateNotAllowed': '不可選擇未來時間',
		'TheApplicationTimeIsDuplicate': '申請時間不可重複',
		'TheApplicationTimeIsDuplicate2': '已有相同打卡時間',
		'reachForgetCheckinLimit': '超過忘刷次數上限',
		'noFlowNoForm': '未產生簽核流程，無法啟動表單',
	},
	'app.api.wf.api-wf020': {
		'pleaseUpgradeToTheLatestVersionOfAPP': '請升級至APP最新版本後，才可申請加班單',
		'overtimeHoursAndInconsistentCostCenterAllocation': '加班抵換方式的加班費時數與成本中心分攤不一致',
		'hoursOfCompensatoryLeaveAndInconsistentCostCenterAllocation': '加班抵換方式的補休假時數與成本中心分攤不一致',
		'overtimeTotalHoursIsInconsistentCostCenterAllocation': '加班抵換方式的總合計時數與成本中心分攤不一致',
		'overtimePayAndCompensatoryLeaveFor': '成本中心的加班費及補休假不可同時為 0',
	},
	'components.HP': {
		'arrivalDate': '到職日',
	},
	'hp.service.service-am-utils': {
		'processed': '已處理',
		'work': '上班',
		'offWork': '下班',
		'overtimeTempBegins': '加班(<%=temp1%>)開始',
		'overtimeBegins': '加班開始',
		'overtimeTempEnds': '加班(<%=temp1%>)結束',
		'endOfOvertime': '加班結束',
		'restTempGoOut': '休息(<%=temp1%>)外出',
		'restAndGoOut': '休息外出',
		'restTempReturns': '休息(<%=temp1%>)返回',
		'restBack': '休息返回',
		'takeLeaveTempToGoOut': '請假(<%=temp1%>)外出',
		'takeTimeOffWorkToGo': '請假外出',
		'leaveTempIsReturned': '請假(<%=temp1%>)返回',
		'leaveToReturn': '請假返回',
		'testTest': '測試測試',
	},
	'hp.m5.m510030': {
		'pleaseSelectACompany': '請選擇公司',
		'formName': '表單名稱',
		'search': '搜尋',
		'searchForTheApplicantOrForm': '申請人/被異動人/表單編號',
		'batchApproval': '批次核准',
		'lotRejection': '批次駁回',
		'penSelected': '已選取<%=temp1%>筆',
		'formNumber': '表單編號',
		'summaryInformation': '摘要資訊',
		'signoffAgent': '簽核代理：<%=temp1%>',
		'dedcutedRestTime': '若休息時間允許加班，扣除休息時間',
		'notDedcutedRestTime': '若休息時間允許加班，不扣除休息時間'
	},
	'hp.m5.m510031': {
		'signOffOnTheResults': '簽核結果',
		'commentsHaveBeenRepliedTo': '已回覆意見',
		'noResponse': '無回覆意見',
		'agentSignOff': '代理人簽核',
		'formSignOffStatus': '狀態',
		'completed': '已完成',
		'terminated': '已終止',
		'otherLevelsAreSignedOff': '其他關卡簽核中',
		'signoffTime': '簽核時間',
		'whenYouSignOff': '您簽核時間',
		'youSignOffOnTheResults': '您簽核結果',
		'overrule': '駁回',
		'approved': '核准',
	},
	'app.api.wf.api-wf060': {
		'retiredOrganizationalCategoriesDepartmentsCannotBe': '已停用的組織類別，不可異動部門',
	},
	'app.service.wf.service-wf060': {
		'theChangeOfClassAttributesIs': '班別屬性異動為固定班，',
		'theChangeInClassAttributesIs': '班別屬性異動為排班(依班別)，',
		'theChangeInClassAttributesIsection': '班別屬性異動為排班(依時段)，',
		'needsToBeSet': '<%=temp1%>需設定<%=temp2%>',
		'cannotBeSet': '<%=temp1%>不可設定<%=temp2%>',
		'classAttributeChangeIsNotRequired': '班別屬性異動為不需排班(依時數申請)，',
		'attachEdError': '附檔寫入人事資料失敗',
		'attachPbError': '附檔寫入出勤資料失敗',
	},
	'app.api.wf.api-wf070': {
		'salaryAccountCurrencyDataIsNot': '薪資科目+幣別資料不可重複',
		'attachError': '附檔寫入薪資資料失敗',
	},
	'hp.service.m5.service-global': {
		'signOffSignoff': '代<%=temp1%>簽核',
		'signatureResult': '<%=temp%>代簽-<%=result%>',
		'notAnApplicantOrProcessorWith': '非「申請者」或是「有編輯權限的處理人」',
		'hasBeenDrawnBySomeoneElse': '已被他人抽單',
		'hasBeenDeletedByOthers': '已被他人刪單',
		'hasBeenSignedOffBySomeone': '已被他人簽核',
		'theFormStatusIsNotSignoff': '表單狀態非簽核中',
		'formNumberFailedToDelete': '表單編號：<%=temp1%> 刪除失敗',
		'unableToDeleteOrder': '無法刪單',
		'systemDetectsTheCauseOfAnomaly': '系統判斷異常原因',
		'attendanceTime': '出勤申請時間',
		'anomalousData': '異常名單',
	},
	'app.api.wf.api-track': {
		'thereIsNoSuchForm': '無此表單',
		'theFormCannotBeResent': '無法重送表單',
	},
	'wf.service.wf011': {
		'failedToDeleteBatchesOfLeaveRequests': '批次請假單刪除失敗，',
	},
	'wf.service.wf020': {
		'theOvertimeCategoryIsInconsistentAfterTheCreditCardInformationIsAdjusted': '刷卡資料調整後之加班類別與起單之加班類別不一致',
		'theAllocationAfterTheTransactionIsInconsistent': '異動後的加班/補休時數和成本中心分攤不一致',
		'inconsistentCardInformationAfterAdjustment': '刷卡資料調整後之加班類別與起單之加班類別不一致',
	},
	'wf.api.wf021': {
		'new.err495': '單張表單的加班組數不可超過10組',
		'new.err496': '單張表單的加班總人數不可超過100人',
	},
	'wf.service.wf021': {
		'failedToDeleteBatchesOfOvertimeOrders': '批次加班單刪除失敗，',
		'zeroOverTime': '因加班時數為0小時，無法產生簽核流程，請重新選擇其他員工',
		'totally': '共',
	},
	'wf.service.wf040': {
		'noThisForm': '查無此表單',
		'employeesWhoDoNotNeedTo': '不需排班員工不可請假',
	},
	'wf.service.wf064': {
		'nonEffectiveResignationJob': '尚有未生效的離職作業',
		'theResignationDateMustBeGreaterThanTheStayEffectiveDate': '離職生效日必需大於留停作業生效日',
		'theLeavingDateMustBeGreaterThanTheStartingDate': '離職生效日必需大於等於到職日',
	},
	'wf.service.wf065': {
		'thereArePendingStayOperations': '尚有未生效的留停作業',
		'thereArePendingReinstatementOperations': '尚有未生效的復職作業',
		'noReinstatementOperations': '未有復職作業',
		'theStayDateMustBeGreaterThanTheDutyDate': '留停生效日必需大於等於到職日',
		'theStayDateMustBeGreaterThanTheLastReinstatementDate': '留停生效日必需大於等於上次復職日',
		'effectiveDateOfStayAndStayYypeCannotBeRepeated': '留停生效日+留停類型不可重複',
	},
	'h2.service.am.attend': {
		'totalCountOIs0': '合計時數為0',
	},
	'hp.H2Inputs': {
		'laborInsuranceInsuredUnits': '勞保投保單位',
		'healthInsuranceInsuredUnits': '健保投保單位',
		'departmentalLevel': '部門層級',
	},
	'sp.wf020.am.emp.ot.check': {
		'code01': '該日期此員工不在職或無班別時間資料',
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此加班類別',
		'code13': '無法讀取加班參數',
		'code14': '加班區間早於系統最早假勤日期',
		'code15': '加班區間晚於系統最晚假勤日期',
		'code16': '加班區間超出加班申請期限',
		'code17': '加班區間沒有特休假勤',
		'code18': 'HR未開放該加班時段',
		'code19type1': '在職狀態為未到職',
		'code19type2': '在職狀態為留職停薪',
		'code19type3': '在職狀態為離職',
		'code20': '加班區間不可申請加班',
		'code21': '加班區間超過可加班時間',
		'code22': '加班區間為禁止加班時間',
		'code23': '加班不能與其他項目重複',
		'code24': '需要提供附件',
		'code25': '加班必須事先申請',
		'code26': '加班須在加班事實發生後<%=A%>天內申請完',
		'code27': '需要填寫加班原因',
		'code28': '加班時數小於最少單位',
		'code29': '加班時數大於最多單位',
		'code30': '該行事曆不可加班',
		'code31': '合計時數不可以為0',
		'code32': '加班已結算',
		'code33': '加班區間不在加班歸屬日內',
		'code34': '此員工不屬於此加班折換方式適用對象',
		'code35': '加班資料不存在',
		'code36': '加班申請規則錯誤',
		'code37': '加班不允許事先申請',
		'code38': '不需排班員工不可折換補休',
		'code39': '預先加班單為必填',
		'code40': '員工預先加班單不存在',
		'code41': '實際加班時間未落於預先加班時間內',
		'code42': '加班需在加班開始前申請完成',
		'code42type1': '加班需在 加班開始前<%=A%>工作日 申請 完',
		'code42type2': '加班需在 加班開始前<%=A%>工作日 簽核 完',
		'code42type3': '加班需在 加班結束後<%=A%>工作日 申請 完',
		'code42type4': '加班需在 加班結束後<%=A%>工作日 簽核 完',
		'code42type5': '加班需在 加班開始前<%=A%>曆日 申請 完',
		'code42type6': '加班需在 加班開始前<%=A%>曆日 簽核 完',
		'code42type7': '加班需在 加班結束後<%=A%>曆日 申請 完',
		'code42type8': '加班需在 加班結束後<%=A%>曆日 簽核 完',
		'code42type9': '加班需在 加班開始前<%=A%>小時 申請 完',
		'code42type10': '加班需在 加班開始前<%=A%>小時 簽核 完',
		'code42type11': '加班需在 加班結束後<%=A%>小時 申請 完',
		'code42type12': '加班需在 加班結束後<%=A%>小時 簽核 完',
		'code43': '加班不允許預先申請',
		'code90': '重新計算加班時數與成本中心分攤不一致',
		'code91': '加班抵換方式有變動',
		'code44': '有簽核中的調班單',
	},
	'sp.wf020.am.emp.ot.checkDelete': {
		'code11': '加班已結算',
		'code12': '加班已取消',
		'code13': '員工加班換補休資料檔已結算',
		'code14': '員工加班換補休資料檔已使用',
		'code15': '加班資料不存在',
	},
	'sp.wf010.am.emp.leave.check': {
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此加班類別',
		'code13': '請假區間內不在職',
		'code14': '員工不適用此假勤項目',
		'code15': '無法讀取假勤參數',
		'code16': '假勤區間早於系統最早假勤日期',
		'code17': '假勤區間晚於系統最晚假勤日期',
		'code18': '假勤區間超出假勤申請期限',
		'code19': '尚有前置假剩餘時數',
		'code20': '假勤不能與其他項目重複',
		'code21': '假勤不允許事後申請',
		'code22': '假勤必須在實際發生後<%=A%>天內申請完',
		'code23': '需要有請假代理人',
		'code24': '需要填寫請假原因',
		'code25': '需要提供附件',
		'code26': '剩餘時數小於最小單位',
		'code27': '試用期滿日後才能申請',
		'code28': '生日當月才能申請',
		'code29': '生日當日才能申請',
		'code30': '請假時數小於最少請假單位',
		'code31': '請假時數大於最多請假單位',
		'code32': '合併其他請假時數超過上限',
		'code33': '合併其他請假次數超過上限',
		'code34': '剩餘時數不足',
		'code35': '合計時數不可以為0',
		'code36': '假勤已銷假',
		'code37': '假勤已結算或薪資已結檔',
		'code38': '職務代理人不存在或不在職',
		'code39': '超過可休區間',
		'code40': '無<%=A%>可休時數',
		'code41': '部分工時員工無<%=A%>可休時數',
		'code42': '員工請假主檔不存在',
		'code43': '事件發生日未設定',
		'code44': '請假區間與加班區間重複',
		'code45': '特休資料已結算',
		'code46': '補休資料已結算',
		'code47': '彈性假資料已結算',
		'code48': '同天多班別者,不能請假勤為 "上下半天規則" 的假勤',
		'code49': '不需排班員工不可申請請假時段',
		'code50': '職務代理人已請假',
		'code51': '部分或全部的假勤時間已擔任其他同仁的職務代理人',
		'code52': '不可同時擔任多位員工的代理人',
		'code53': '該行事曆別不可代理他人',
		'code54': '代理他人期間不可請假',
		'code55': '事件發生日資料不存在',
		'code56': '事件發生日與說明與其它假勤資料重複',
		'code57': '假勤截止日不可小於該筆最大結檔日',
		'code58': '可休時數大於全時勞工',
		'code70': '代理人不在職務代理人清單中',
		'code71': '有簽核中的調班單',
	},
	'sp.wf010.am.emp.leave.checkByHour': {
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此加班類別',
		'code13': '請假區間內不在職',
		'code14': '員工不適用此假勤項目',
		'code15': '無法讀取假勤參數',
		'code16': '假勤區間早於系統最早假勤日期',
		'code17': '假勤區間晚於系統最晚假勤日期',
		'code18': '假勤區間超出假勤申請期限',
		'code20': '假勤項目及日期重複',
		'code21': '假勤不允許事後申請',
		'code22': '假勤必須在實際發生後<%=A%>天內申請完',
		'code23': '需要有請假代理人',
		'code24': '需要填寫請假原因',
		'code25': '需要提供附件',
		'code31': '請假時數大於最多請假單位',
		'code32': '合併其他請假時數超過上限',
		'code33': '合併其他請假次數超過上限',
		'code34': '剩餘時數不足',
		'code35': '合計時數不可以為0',
		'code37': '假勤已結算或薪資已結檔',
		'code38': '職務代理人不存在或不在職',
		'code39': '超過可休區間',
		'code40': '無<%=A%>可休時數',
		'code41': '部分工時員工無<%=A%>可休時數',
		'code42': '員工請假主檔不存在',
		'code43': '事件發生日未設定',
		'code44': '事件發生日資料不存在',
		'code45': '特休資料已結算',
		'code46': '補休資料已結算',
		'code47': '彈性假資料已結算',
		'code48': '請假時數+出勤時數不可超過 24 小時',
		'code50': '職務代理人已請假',
		'code51': '部分或全部的假勤時間已擔任其他同仁的職務代理人',
		'code52': '不可同時擔任多位員工的代理人',
		'code53': '該行事曆別不可代理他人',
		'code54': '代理他人期間不可請假',
		'code56': '事件發生日與說明與其它假勤資料重複',
		'code60': '需要填寫班別',
		'code61': '班別已停用',
		'code62': '不需排班員工不可填寫班別',
		'code71': '有簽核中的調班單',
	},
	'sp.wf010.am.emp.leave.checkDelete': {
		'code11': '假勤已結算',
		'code12': '假勤已銷假',
		'code13': '員工特休資料已結算 ( 上期 )',
		'code14': '員工特休資料已結算 ( 本期 )',
		'code15': '員工補休資料已結算',
		'code16': '員工彈休資料已結算',
		'code21': '請假主檔ID錯誤',
	},
	'sp.wf010.am.emp.biz.checkDelete': {
		'code21': '出差主檔ID錯誤',
	},
	'sp.wf050.am.emp.leave.cancel.check': {
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此請假資料',
		'code13': '銷假區間超出銷假申請期限',
		'code14': '行事曆已經變更',
		'code15': '沒有足夠的銷假時數',
		'code16': '銷假期間重複',
		'code17': '該銷假假勤為其他申請假勤的前置假',
		'code18': '銷假時數小於最少請假單位',
		'code19': '合計時數不可以為0',
		'code20': '銷假已結算',
		'code21': '請假時數大於剩餘時數',
		'code22': '銷假期間必須在請假期間的範圍內',
		'code23': '員工特休資料已結算 ( 上期 )',
		'code24': '員工特休資料已結算 ( 本期 )',
		'code25': '員工補休資料已結算',
		'code26': '員工彈休資料已結算',
		'code27': '沒有該日期區間的請假資料',
		'code28': '銷假主檔不存在',
		'code29': '請假資料在途中',
		'code30': '假勤已結算',
		'code31': '請假已計薪',
		'code32': '因假勤單位異動，銷假時數大於請假時數',
		'code33': '已有特休加班資料',
		'code35': '工作時間已經異動',
		'codeL19': '尚有前置假剩餘時數',
		'codeL20': '假勤不能與其他項目重複',
		'codeL32': '合併其他請假時數超過上限',
		'codeL33': '合併其他請假次數超過上限',
		'codeL44': '請假區間與加班區間重複',
	},
	'sp.wf050.am.emp.leave.cancel.checkDelete': {
		'code11': '銷假已結算',
		'code12': '員工特休資料已結算 ( 上期 )',
		'code13': '員工特休資料已結算 ( 本期 )',
		'code14': '員工補休資料已結算',
		'code15': '員工彈休資料已結算',
		'code21': '請假主檔ID錯誤',
		'code22': '員工銷假主檔ID錯誤',
		'code23': '請假已結算',
		'codeL19': '尚有前置假剩餘時數',
		'codeL20': '假勤不能與其他項目重複',
		'codeL32': '合併其他請假時數超過上限',
		'codeL33': '合併其他請假次數超過上限',
		'codeL44': '請假區間與加班區間重複',
		'codeL34': '剩餘時數不足',
		'codeL40': '無<%=A%>可休時數',
	},
	'sp.wf022.am.emp.preot.check': {
		'code01': '該日期此員工不在職或無班別時間資料',
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此加班類別',
		'code13': '無法讀取加班參數',
		'code14': '預先加班時間早於系統最早假勤日期',
		'code15': '預先加班時間晚於系統最晚假勤日期',
		'code16': '加班區間超出加班申請期限',
		'code17': '加班區間沒有特休假勤',
		'code18': 'HR未開放該加班時段',
		'code19type1': '在職狀態為未到職',
		'code19type2': '在職狀態為留職停薪',
		'code19type3': '在職狀態為離職',
		'code20': '加班區間不可申請加班',
		'code21': '加班區間超過可加班時間',
		'code22': '加班區間為禁止加班時間',
		'code23': '加班不能與其他項目重複',
		'code24': '需要提供附件',
		'code25': '加班必須事先申請',
		'code26': '加班須在加班事實發生後<%=A%>天內申請完',
		'code27': '需要填寫加班原因',
		'code28': '預先加班時數小於最少單位',
		'code29': '預先加班時數大於最多單位',
		'code30': '該行事曆不可加班',
		'code31': '合計時數不可以為0',
		'code32': '加班已結算',
		'code33': '加班區間不在加班歸屬日內',
		'code34': '此員工不屬於此加班折換方式適用對象',
		'code35': '加班資料不存在',
		'code36': '加班申請規則錯誤',
		'code37': '加班不允許事先申請',
		'code38': '加班需事先申請',
		'code39': '加班不允許事後申請',
		'code40': '員工預先加班單不存在',
		'code41': '實際加班時間未落於預先加班時間內',
		'code42type1': '加班需在 加班開始前<%=A%>工作日 申請 完',
		'code42type2': '加班需在 加班開始前<%=A%>工作日 簽核 完',
		'code42type3': '加班需在 加班結束後<%=A%>工作日 申請 完',
		'code42type4': '加班需在 加班結束後<%=A%>工作日 簽核 完',
		'code42type5': '加班需在 加班開始前<%=A%>曆日 申請 完',
		'code42type6': '加班需在 加班開始前<%=A%>曆日 簽核 完',
		'code42type7': '加班需在 加班結束後<%=A%>曆日 申請 完',
		'code42type8': '加班需在 加班結束後<%=A%>曆日 簽核 完',
		'code42type9': '加班需在 加班開始前<%=A%>小時 申請 完',
		'code42type10': '加班需在 加班開始前<%=A%>小時 簽核 完',
		'code42type11': '加班需在 加班結束後<%=A%>小時 申請 完',
		'code42type12': '加班需在 加班結束後<%=A%>小時 簽核 完',
		'code43': '加班不允許預先申請',
		'code90': '重新計算加班時數與成本中心分攤不一致',
		'code91': '加班抵換方式有變動',
		'code44': '有簽核中的調班單',
	},
	'sp.wf022.am.emp.preot.checkDelete': {
		'code11': '加班已取消',
		'code12': '加班資料不存在',
	},
	'sp.wf090.am.emp.attend.check': {
		'code01': '該公司沒有此員工',
		'code03': '出勤時數不可超過 24 小時',
		'code04': '出勤起始時間晚於結束時間',
		'code05': '出勤時數與成本中心分攤不一致',
		'code06': '未提供附件',
		'code07': '未填寫出勤原因',
		'code08': '出勤時數小於最少單位',
		'code09': '出勤時數大於最多單位',
		'code10': '合計時數不可以為0',
		'code11': '出勤不能與其他出勤項目重複',
		'code12': '出勤不能與加班重複',
		'code13': '出勤不能與請假重複',
		'code14': '員工未設定出勤時數規則',
		'code15': '員工不在職',
		'code16': '不允許事先申請出勤時數',
		'code17': '出勤時間早於系統最早假勤日期',
		'code18': '員工於(出勤時段)期間的班別屬性不允許申請出勤時數',
		'code19': '不可申請計薪前<%=A%>的出勤資料',
		'code20': '支領出勤時數與微調值加總小於0',
		'code21': '員工於(出勤時段)期間的班別屬性不允許申請出勤時數',
		'code22': '刷卡資料不足',
		'code23': '出勤歸屬日超過出勤時間',
		'code24type1': '出勤時數單需在出勤結束日期後<%=A%>日曆天申請完成',
		'code24type2': '出勤時數單需在出勤結束日期後<%=A%>工作天申請完成',
		'code25': '申請期限參數有誤',
		'code26': '成本中心資料不可為空',
	},
	'sp.wf090.am.emp.attend.checkCardmatch': {
		'code11': '打卡比對錯誤',
	},
	'sp.wf020.am.emp.ot.checkCardmatch': {
		'code11': '打卡比對錯誤',
	},
	'sp.wf090.am.emp.attend.checkDelete': {
		'code11': '出勤時數已結算',
		'code12': '出勤時數主檔ID錯誤',
	},
	'sp.wf021.wf.batch.ot.do': {
		'code01': '該日期此員工不在職或無班別時間資料',
		'code10': '工時規則錯誤',
		'code11': '打卡比對錯誤',
		'code12': '該公司沒有此加班類別',
		'code13': '無法讀取加班參數',
		'code14': '加班區間早於系統最早假勤日期',
		'code15': '加班區間晚於系統最晚假勤日期',
		'code16': '加班區間超出加班申請期限',
		'code17': '加班區間沒有特休假勤',
		'code18': 'HR未開放該加班時段',
		'code19type1': '在職狀態為未到職',
		'code19type2': '在職狀態為留職停薪',
		'code19type3': '在職狀態為離職',
		'code20': '加班區間不可申請加班',
		'code21': '加班區間超過可加班時間',
		'code22': '加班區間為禁止加班時間',
		'code23': '加班不能與其他項目重複',
		'code24': '需要提供附件',
		'code25': '加班必須事先申請',
		'code26': '加班須在加班事實發生後<%=A%>天內申請完',
		'code27': '需要填寫加班原因',
		'code28': '加班時數小於最少單位',
		'code29': '加班時數大於最多單位',
		'code30': '該行事曆不可加班',
		'code31': '合計時數不可以為0',
		'code32': '加班已結算',
		'code33': '加班區間不在加班歸屬日內',
		'code34': '此員工不屬於此加班折換方式適用對象',
		'code35': '加班資料不存在',
		'code36': '加班申請規則錯誤',
		'code37': '加班不允許事先申請',
		'code38': '不需排班員工不可折換補休',
		'code39': '預先加班單為必填',
		'code40': '員工預先加班單不存在',
		'code41': '實際加班時間未落於預先加班時間內',
		'code42type1': '加班需在 加班開始前<%=A%>工作日 申請 完',
		'code42type2': '加班需在 加班開始前<%=A%>工作日 簽核 完',
		'code42type3': '加班需在 加班結束後<%=A%>工作日 申請 完',
		'code42type4': '加班需在 加班結束後<%=A%>工作日 簽核 完',
		'code42type5': '加班需在 加班開始前<%=A%>曆日 申請 完',
		'code42type6': '加班需在 加班開始前<%=A%>曆日 簽核 完',
		'code42type7': '加班需在 加班結束後<%=A%>曆日 申請 完',
		'code42type8': '加班需在 加班結束後<%=A%>曆日 簽核 完',
		'code42type9': '加班需在 加班開始前<%=A%>小時 申請 完',
		'code42type10': '加班需在 加班開始前<%=A%>小時 簽核 完',
		'code42type11': '加班需在 加班結束後<%=A%>小時 申請 完',
		'code42type12': '加班需在 加班結束後<%=A%>小時 簽核 完',
		'code43': '加班不允許預先申請',
		'code90': '重新計算加班時數與成本中心分攤不一致',
		'code91': '加班抵換方式有變動',
		'code44': '有簽核中的調班單',
	},
	'sp.wf011.wf.batch.leave.do': {
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此加班類別',
		'code13': '請假區間內不在職',
		'code14': '員工不適用此假勤項目',
		'code15': '無法讀取假勤參數',
		'code16': '假勤區間早於系統最早假勤日期',
		'code17': '假勤區間晚於系統最晚假勤日期',
		'code18': '假勤區間超出假勤申請期限',
		'code19': '尚有前置假剩餘時數',
		'code20': '假勤不能與其他項目重複',
		'code21': '假勤不允許事後申請',
		'code22': '假勤必須在實際發生後<%=A%>天內申請完',
		'code23': '需要有請假代理人',
		'code24': '需要填寫請假原因',
		'code25': '需要提供附件',
		'code26': '剩餘時數小於最小單位',
		'code27': '試用期滿日後才能申請',
		'code28': '生日當月才能申請',
		'code29': '生日當日才能申請',
		'code30': '請假時數小於最少請假單位',
		'code31': '請假時數大於最多請假單位',
		'code32': '合併其他請假時數超過上限',
		'code33': '合併其他請假次數超過上限',
		'code34': '剩餘時數不足',
		'code35': '合計時數不可以為0',
		'code36': '假勤已銷假',
		'code37': '假勤已結算',
		'code38': '職務代理人不存在或不在職',
		'code39': '超過可休區間',
		'code42': '員工請假主檔不存在',
		'code43': '事件發生日未設定',
		'code44': '請假區間與加班區間重複',
		'code45': '特休資料已結算',
		'code46': '補休資料已結算',
		'code47': '彈性假資料已結算',
		'code48': '同天多班別者,不能請假勤為 "上下半天規則" 的假勤',
		'code49': '不需排班員工不可請假',
		'code50': '職務代理人於請假區間 <%=S%>~<%=E%> 已請假',
		'code51': '部分或全部的假勤時間已擔任其他同仁的職務代理人',
		'code52': '不可同時擔任多位員工的代理人',
		'code53': '該行事曆別不可代理他人',
		'code54': '代理他人期間不可請假',
		'code55': '事件發生日資料不存在',
		'code56': '事件發生日與說明與其它假勤資料重複',
		'code71': '有簽核中的調班單',
	},
	'sp.signIn.ac.user.checkPwd': {
		'code11': '登入成功',
		'code12': '登入成功,但須提醒修改密碼',
		'code17': '預設密碼啟用帳號',
		'code18': '變更密碼',
		'code19': 'AD認證',
		'code21': '登入失敗',
		'code22': '帳號鎖定中',
		'code23': '帳號已關閉',
		'code24': '帳號未認證',
		'code26': '輸入太多次錯誤,帳號已被鎖定',
		'code31': '應用程式不存在',
		'code32': '帳號不存在',
		'code33': '帳號狀態錯誤',
		'code34': '認證模式錯誤',
		'code35': '帳號多公司',
		'code36': '未開啟APP 功能',
		'code37': '帳號登入公司已關閉，請聯絡權限管理者',
		'code38': '帳號登入公司已關閉，請聯絡104服務人員',
		'code91': '需要使用Microsoft帳號登入',
	},
	'sp.auth.ac.user.checkPwdChange': {
		'code11': '啟用成功',
		'code19': 'AD認證',
		'code21': '密碼輸入錯誤',
		'code22': '帳號鎖定中',
		'code23': '帳號已關閉',
		'code24': '帳號未認證',
		'code25': '輸入太多次錯誤,帳號已被鎖定',
		'code31': '應用程式不存在',
		'code32': '帳號不存在',
		'code33': '帳號狀態錯誤',
		'code34': '認證模式錯誤',
		'code41': '密碼最小長度檢查錯誤',
		'code42': '文數字檢查錯誤',
		'code43': '密碼需有特殊符號檢查錯誤',
		'code44': '時間未到',
		'code45': '與上次密碼重複',
		'code46': '新舊密碼不可以一樣',
		'code47': '密碼至少包含一個大寫英文字',
	},
	'sp.auth.ac.user.checkPwdReset': {
		'code11': '密碼變更成功',
		'code19': 'AD認證',
		'code21': '密碼輸入錯誤',
		'code23': '帳號已關閉',
		'code24': '帳號未認證',
		'code25': '輸入太多次錯誤,帳號已被鎖定',
		'code31': '應用程式不存在',
		'code32': '帳號不存在',
		'code33': '帳號狀態錯誤',
		'code34': '認證模式錯誤',
		'code39': 'TOKEN錯誤',
		'code41': '密碼最小長度檢查錯誤',
		'code42': '文數字檢查錯誤',
		'code43': '密碼需有特殊符號檢查錯誤',
		'code44': '時間未到',
		'code45': '與上次密碼重複',
		'code46': '新舊密碼不可以一樣',
		'code47': '密碼至少包含一個大寫英文字',
	},
	'app.service.wf.service-global': {
		'sinceThereAreMoreThanOvertime': '因加班人超過100人，僅可於Portal簽核',
		'holiday': '假日',
		'noneOfThemCanBeSigned': '全部無法簽核',
	},
	'app.service.am.service-personal-clock': {
		'theEmployeeDoesNotHaveThis': '員工無此筆資料',
		'theReasonForOvertimeAttendanceCannot': '此筆資料無法填寫超時出勤原因',
	},
	'hp.service.m4.service-m410070': {
		'thePreviousPeriodWasExtended': '上期展延',
		'thisIssue': '本期',
	},
	'app.service.am.service-personal-leave': {
		'cancelledLeave': '已銷假',
	},
	'app.service.am.service-manager': {
		'totalOf': '<%=temp1%>月累計請假紀錄共<%=temp2%><%=temp3%><%=temp4%>',
		'totalOfAbnormal': '<%=temp1%>月累計異常出勤紀錄共<%=temp2%>筆',
	},
	'app.service.auth': {
		'quickLoginNotCreated': '未建立快速登入',
		'keyVerificationFailed': '金鑰驗證失敗',
		'keyOperationException': '金鑰操作異常',
		'theUserAccountDoesNotExist': '該使用者帳號不存在',
		'accountLocked': '帳號鎖定中',
		'accountClosed': '帳號已關閉',
		'accountNotAuthenticated': '帳號未認證',
		'theAPPFunctionIsNotTurnedOn': '未開啟APP 功能',
		'invalidRefreshToken': '驗證失敗 (請更新 accessToken 再試一次)',
		'cannotCreateRefreshToken': '無法產生新token連結',
		'verifyToken490': 'token 無效 (JWT)',
		'verifyToken491': 'token 過期 (JWT)',
		'verifyToken492': 'user 不存在 (可能員工已經被刪除了，或相關資料被停用或刪除了)',
		'verifyToken493': 'token 無效 (作業已完成或邏輯已更換，請找最新信件的連結)',
		'noRelevantInformationFound': '找不到相關資料 (Ex: passwordRules)',
		'notOpenToUseAPP': '不開放使用APP',
		'adEnableFailed': 'AD啟用失敗',
		'userIsNotExist': '用戶不存在',
		'abnormalAccountStatus': '帳號狀態異常',
		'passwordDoesNotMatch': '密碼不符合登入規則要求的長度或複雜性',
		'forgetPwd490': '此帳號不適用，需使用Microsoft 帳號登入',
		'forgetPwd491': '帳號有誤',
		'forgetPwd492': '您使用的是AD帳號，重設AD帳號密碼請聯絡公司MIS人員，謝謝！',
		'forgetPwd493': '您的帳號未啟用，請連絡帳號管理者再寄一次帳號認證信',
		'forgetPwd494': '您的帳號已鎖定，請於鎖定效期之後再次登入本系統或連絡帳號管理者，謝謝！',
		'forgetPwd495': '您的帳號已關閉，請連絡帳號管理者，謝謝!',
		'forgetPwd496': '產生token失敗',
		'forgetPwd497': '寄送通知信失敗，無信件範本',
		'forgetPwd498': '無 email 可寄發密碼通知函，請聯絡系統管理員',
		'noRelatedRulesFound': '找不到相關規則',
		'wrongVersionNumberFormat': '版本號碼格式錯誤',
		'aadEnableFailed': 'Azure Active Directory啟用失敗',
	},
	'app.service.head': {
		'userIsNotExist': '用戶不存在',
		'noInfo': '無資料',
	},
	'app.service.presetCode': {
		'preset401': '認證失敗 (請更新 accessToken 再試一次)',
		'preset403': '權限不足',
		'preset404': '用戶不存在',
		'preset440': '參數錯誤 (請檢查 parameters 或 request body 的欄位、格式是否完整及正確)',
		'preset450': 'MulterError',
		'presetDB499': 'DB錯誤',
		'preset499': '系統異常(service 內 catch)',
		'preset500': '系統異常',
	},
	'app.service.file': {
		'invalidFileFormat': '無效的檔案格式: ',
		'wrongFileName': '檔案名稱不可包含特殊字元: ',
	},
	'app.service.am.attendStatistic': {
		'theEmployeeDoesNotHaveThis': '員工無此筆資料',
	},
	'app.service.am.clock': {
		'noCheckInLocations': '無可用的打卡地點',
		'notYetInTheCheckInRange': '尚未進入打卡範圍',
		'unableToGetDBTime': '無法取得 DB 時間',
		'clockIn490': '工時檢查錯誤',
		'clockIn491': '打卡時間重複',
		'clockIn493': '當日第一筆打卡必填體溫',
		'clockIn494': '各班別第一筆打卡必填體溫',
		'clockIn499': 'DB錯誤',
		'hyperthermia': '體溫過高',
		'disabledWifi': 'Wifi 打卡功能已關閉',
		'noWifiMatch2': '請連結可允許打卡的 Wifi 訊號位置\n前往手機設定重新選擇網路。',
		'noCheckInSetting': '無法完成打卡功能初始化(未開啟打卡功能、或無可打卡地點)',
		'checkInSettingsError': '打卡設定取得失敗',
		'noWifiCheckIn': '無可用的 Wi-Fi 打卡地點',
		'fahrenheit': '若為華氏體溫，僅接受範圍 95 ~ 113。',
		'celsius': '若為攝氏體溫，僅接受範圍 35 ~ 45。',
		'gpsTitle': 'GPS 打卡',
		'wifiTitle': 'Wi-Fi 打卡',
		'checkInWifi': '打卡 Wi-Fi 與適用 Wi-Fi 不一致。',
	},
	'app.service.ac.appReg': {
		'notAppRegRule': '使用者不適用手機綁定規則',
		'remind': '提醒您',
		'deviceBindingRequired': '需綁定裝置後，才可正常使用。',
		'oneDevicePerAccountBinding': '(一個裝置只能綁定一個帳號)',
		'deviceAlreadyBoundUseAnother': '此裝置已綁定其他帳號，請改用其他裝置綁定。',
		'accountAlreadyBoundToAnother': '此帳號已綁定其他裝置。',
		'oneAccountOneDeviceBinding': '(一個帳號只能綁定一個裝置)',
		'accountNotBoundToDevice': '此帳號尚未綁定裝置',
		'unbindSuccess': '解除綁定成功',
		'notified': '已通知',
		'unbindNotificationSentPleaseWait': '已通知承辦人解除綁定。請稍待相關人員處理。',
		'send': '已寄發',
		'verificationEmailSentUnbindUponSuccess': '已寄發驗證函至您的信箱。成功驗證後，將自動解除綁定。',
		'messageNotificationEstablished': '寄發信件失敗，尚未建立訊息通知',
		'failedToSendVerificationLetter': '寄發驗證函失敗',
		'linkExpired': '此連結已過期，請重新申請',
		'invalidLink': '無效連結，請重新申請',
		'identitySuccessful': '身份驗證成功，已自動解除手機綁定',
	},
	'hp.m5.preview.wf020': {
		'thereAreTempTypesOfOvertime': '加班類別共<%=temp1%>類',
	},
	'hp.m5.preview.wf011': {
		'aTotalOfOfPeopleOn': '請假共<%=temp1%>人',
	},
	'components.Grids': {
		'inquire': '查詢',
	},
	'workflow.common.formTable': {
		'formNo': '表單單號',
		'applicationTime': '申請時間',
	},
	'workflow.common.notification': {
		'portalUrl': 'Portal網址',
		'approveUrl': '核准URL',
		'rejectUrl': '駁回URL',
		'agentSettingUrl': '代理人設定網址',
	},
	'h2.pb.pb40910': {
		'payrollPwdDefault1': '「<%=A%><%=B%>」',
		'payrollPwdDefault2': '，預設密碼<%=C%>需加上<%=D%>',
	},
	'hp.m5.m510010.wf100': {
		'pleaseSelectBizTime': '請先選擇出差時間',
		'falseAttendanceCalculationError': '出差計算錯誤',
		'itineraryDetails': '詳細出差行程資訊',
		'rowHeader': '行程',
		'theBusinessTripApplicationFailed': '新增出差行程申請單失敗',
		'failedToWriteToTheFake': '寫入出差行程主檔失敗',
		'bizTripType': '出差性質',
		'bizDate': '出差時間',
		'totalBizTripHours': '出差合計時數',
		'bizLocation': '出差地點',
		'transportation': '交通工具',
		'appointment': '委辦事項',
		'bizReason': '出差原因',
		'servedAsAgentForOtherColleagues': '部分或全部的出差時間已擔任其他同仁的職務代理人',
		'totalCountCannotBe': '合計時數不可以為0',
		'fakeProjectLoadingError': '假勤項目載入錯誤',
		'substituteRequired': '需要有職務代理人',
		'segmentedBizTime': '分段出差時間',
		'totalBizTime': '分段出差合計時數',
	},
	'sp.wf100.am.emp.biz.check': {
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此加班類別',
		'code13': '請假區間內不在職',
		'code14': '員工不適用此假勤項目',
		'code15': '無法讀取假勤參數',
		'code16': '假勤區間早於系統最早假勤日期',
		'code17': '假勤區間晚於系統最晚假勤日期',
		'code18': '假勤區間超出假勤申請期限',
		'code19': '尚有前置假剩餘時數',
		'code20': '出差時間不能與其他出差重複',
		'code21': '假勤不允許事後申請',
		'code22': '假勤必須在實際發生後<%=A%>天內申請完',
		'code23': '需要有職務代理人',
		'code24': '需要填寫請假原因',
		'code25': '需要提供附件',
		'code26': '剩餘時數小於最小單位',
		'code27': '試用期滿日後才能申請',
		'code28': '生日當月才能申請',
		'code29': '生日當日才能申請',
		'code30': '請假時數小於最少請假單位',
		'code31': '請假時數大於最多請假單位',
		'code32': '合併其他請假時數超過上限',
		'code33': '合併其他請假次數超過上限',
		'code34': '剩餘時數不足',
		'code35': '合計時數不可以為0',
		'code36': '假勤已銷假',
		'code37': '假勤已結算',
		'code38': '職務代理人不存在或不在職',
		'code39': '超過可休區間',
		'code40': '無<%=A%>可休時數',
		'code42': '員工請假主檔不存在',
		'code43': '事件發生日未設定',
		'code44': '請假區間與加班區間重複',
		'code45': '特休資料已結算',
		'code46': '補休資料已結算',
		'code47': '彈性假資料已結算',
		'code48': '同天多班別者,不能請假勤為 "上下半天規則" 的假勤',
		'code49': '不需排班員工不可請假',
		'code50': '職務代理人已請假',
		'code51': '部分或全部的假勤時間已擔任其他同仁的職務代理人',
		'code52': '不可同時擔任多位員工的代理人',
		'code53': '該行事曆別不可代理他人',
		'code54': '代理他人期間不可請假',
		'code55': '事件發生日資料不存在',
		'code56': '事件發生日與說明與其它假勤資料重複',
		'code57': '假勤截止日不可小於該筆最大結檔日',
		'code60': '不需排班員工不可申請出差',
		'code61': '出差時間不能與其他出差重複',
		'code62': '分段出差時間需介於整體出差時間內',
		'code63': '分段時間不可重疊',
		'code70': '代理人不在職務代理人清單中',
	},
	'sp.wf050.am.emp.leave.cancel.check.byHour': {
		'code11': '該公司沒有此員工',
		'code12': '該公司沒有此請假資料',
		'code13': '銷假區間超出銷假申請期限',
		'code23': '員工特休資料已結算 ( 上期 )',
		'code24': '員工特休資料已結算 ( 本期 )',
		'code25': '員工補休資料已結算',
		'code26': '員工彈休資料已結算',
		'code29': '請假資料在途中',
		'code30': '假勤已結算',
		'code33': '已有特休加班資料',
	},
	'components.custom-form.single-text.view': {
		'maxWords': '最多<%=temp1%>字',
		'pleaseEnterAnEMailAddress': '請輸入E-mail',
	},
	'hp.m3.m310510': {
		'kindED': '人事類',
		'kindAM': '出勤類',
		'kindPB': '薪資類',
		'timeUnit': '時間單位',
		'year': '年',
		'season': '季',
		'period': '日期區間',
		'all': '全部',
		'active': '使用中',
		'deptLevel': '部門層級顯示至',
		'fullComp': '全公司',
		'proofAll': '和全公司比較',
		'yearTitle': '<%=y1%>年~<%=y2%>年',
		'xLegend1': '<%=y1%>年Q<%=q1%>',
		'xLegend2': '<%=y1%>年  第<%=q1%>季',
		'xLegend3': '<%=y1%>年',
		'men': '男性',
		'women': '女性',
		'genderTitle': '性別統計',
		'genderTip':
			'■ 資料會根據 HR 設定的每天更新頻率定時更新。\n\t\t\t■ 根據篩選條件的日期區間最後一天「在職、留停」的員工計算。\n\t\t\t■ 百分比會四捨五入到小數點第一位。\n\t\t\t■ 範例：2022 年 A 部門有 6 男 1 女，B 部門有 3 男 7 女。2023/3/1  A 部門 1 位男性轉調至 B 部門。\n\t\t\t當篩選條件為 2022 年的 A、B 部門時，A 部門為男 86% (6人)、女 14% (1人)，B 部門為男 30% (3人)、女 70% (7人)。\n\t\t\t當篩選條件為 2023 年的 A、B 部門時，A 部門為男 83% (5人)、女 17% (1人)，B 部門為男 36% (4人)、女 64% (7人)。',
		'genderCnt': '位',
		'ageTitle': '年齡統計',
		'ageTip':
			'■ 資料會根據 HR 設定的每天更新頻率定時更新。\n\t\t\t■ 根據篩選條件的日期區間最後一天「在職、留停」的員工計算。\n\t\t\t■ 百分比會四捨五入到小數點第一位。\n\t\t\t■ 範例：2022 年 A 部門 4 人（35歲、41歲、42歲、43歲）。2023 年 35 歲員工留停、42 歲員工離職。\n\t\t\t當篩選條件為 2022 年的 A 部門時，區間 31-40 歲 25%（1人）、41-50 歲 75%（3人）。\n\t\t\t當篩選條件為 2023 年的 A 部門時，區間 31-40 歲 33%（1人）、41-50 歲 67%（2人）。',
		'ageSlice': '以 X 為分析單位',
		'baseAge20': '以20歲為基礎值',
		'season1': '第一季',
		'season2': '第二季',
		'season3': '第三季',
		'season4': '第四季',
		'xLegend4': '20歲以下',
		'xLegend5': '<%=XX%>歲以上',
		'quitTitle': '離職統計',
		'quitTip':
			'■ 資料會根據 HR 設定的每天更新頻率定時更新。\n\t\t\t■ 根據篩選條件區間的離職員工計算。\n\t\t\t■ 同位員工若在篩選區間多次離職，則只計入最後一次的 1 人。\n\t\t\t■ 離職率 = 離職人數 / ((第一天在職人數 + 最後一天在職人數) / 2) *100%。\n\t\t\t■ 百分比會四捨五入到小數點第一位。\n\t\t\t■ 範例：篩選條件為以年為單位，2022~2023。\n\t\t\tA 員工在 2022、2023 年各離職 1 次。\n\t\t\tB 員工在 2023 年離職 2 次。\n\t\t\t2022/1/1 在職人數 10 人，2022/12/31 在職人數 30 人。\n\t\t\t2023/1/1 在職人數 30 人，2023/12/31 在職人數 40 人。\n\t\t\t2022 年離職員工 1 人，比例 1/20 = 5%。\n\t\t\t2023 年離職員工 2 人，比例 2/35 = 5.7%。',
		'quitLevel': '離職率超過 X 以橘色標示',
		'cover': '(含)',
		'xLegend6': '自願離職(不含退休)',
		'xLegend7': '自願離職(含退休)',
		'xLegend8': '非自願離職',
		'stopTitle': '育嬰留停復職統計',
		'stopTip':
			'■ 資料會根據 HR 設定的每天更新頻率定時更新。\n\t\t\t■ 根據篩選條件區間的留停、復職員工計算。\n\t\t\t■ 同位員工若在篩選區間多次復職，則只計入最後一次的 1 人。\n\t\t\t■ 復職率 = (實際復職人數/應復職人數)*100%\n\t\t\t■ 百分比會四捨五入到小數點第一位。\n\t\t\t■ 範例：篩選條件為以年為單位，2022~2023。\n\t\t\tA 部門某員工應 2022 年復職，實際未復職。B 部門某員工應 2023 年復職 2 次，實際 2023 年復職 2 次。\n\t\t\t則 A 部門復職率 0%、B 部門 100% 。',
		'stopLevel': '復職率低於 X 以橘色標示',
		'stopBack': '復職率',
		'stopExpect': '預計復職人數',
		'stopActual': '實際復職人數',
		'hurtTitle': '公傷病假統計',
		'hurtTip':
			'■ 資料會根據 HR 設定的每天更新頻率定時更新。\n\t\t\t■ 根據篩選條件範疇內，至少有一天「在職」的員工計算。\n\t\t\t■ 包含「所有使用中、停用」且對照台灣法令假別為「公傷病假」的加總實際請假時數。\n\t\t\t■ 實際請假時數 = 請假時數 - 銷假時數。皆僅計算「已核准」的假勤。\n\t\t\t■ 百分比 = (實際請假時數 / 總工時)*100%\n\t\t\t■ 百分比會四捨五入到小數點第一位。\n\t\t\t■ 範例：部門 2 位員工，3 月各需工作 20 天，每天工時 8 小時。A 員工請半薪病假 4 小時且核准，B 員工請公傷病假 16 小時且簽核中，則百分比為 4/(8*20*2) = 1.3%',
		'hurtLevel': '公傷病假率超過 X 以橘色標示',
		'hurtJoin': '全部(男女合併顯示)',
		'hurtApart': '全部(男女分別顯示)',
		'percent': '百分比',
		'hour': '小時',
		'hurtIssue': '實際請假時數',
		'hurtTotal': '總工時',
		'breedTitle': '產假/產檢假/陪產假統計',
		'breedTip':
			'■ 資料會根據 HR 設定的每天更新頻率定時更新。\n\t\t\t■ 根據篩選條件範疇內，至少有一天「在職」的員工計算。\n\t\t\t■ 包含「所有使用中、停用」且對照台灣法令假別為「產假、產檢假、陪產假」的加總實際請假時數。\n\t\t\t■ 實際請假時數 = 請假時數 - 銷假時數。皆僅計算「已核准」的假勤。\n\t\t\t■ 百分比 = (實際請假時數 / 總工時)*100%\n\t\t\t■ 百分比會四捨五入到小數點第一位。\n\t\t\t■ 範例：部門 2 位員工，3 月各需工作 20 天，每天工時 8 小時。A 員工請陪產假 4 小時且核准，B 員工請產假 40 小時且簽核中，則百分比為 4/(8*20*2) = 1.3%',
		'breedLevel': '產假/產檢假/陪產假率超過 X 以橘色標示',
		'pay2Title': '薪資結構統計',
		'pay2Tip': `■ 資料會根據 HR 設定的每天更新頻率定時更新。
			■ 根據篩選條件範疇內，至少有一天「在職」的員工計算。
			■ 僅計算薪資結構的薪資科目。
			■ 金額會四捨五入到整數位。`,
	},
	'hp.m1.m110010': {
		'type': '類型',
		'status': '狀態',
		'search': '搜尋',
		'announcementTime': '發佈時間',
		'titleOrPublishingUnit': '搜尋公告標題、發佈單位',
		'startDate': '請選擇日期(起)',
		'endDate': '請選擇日期(訖)',
		'no': '編號',
		'category': '類別',
		'title': '公告標題',
		'readStatus': '是否讀取',
		'publishingUnit': '發佈單位',
		'read': '已讀',
		'unread': '未讀',
		'announcement': '公告',
		'bulletinPublishingUnit': '公告單位 : ',
		'bulletinCategory': '類別：',
	},
	'hp.m1.m110020': {
		'addAnnouncement': '新增公告',
		'titleOrLastUpdater': '搜尋公告標題或最後更新人',
		'statistics': '讀取人數',
		'lastUpdate': '最後更新',
		'suspendPublication': '暫停發佈',
		'content': '公告內容',
		'category': '公告類別',
		'categoryMaintenance': '分類維護',
		'no': '公告編號',
		'general': '【一般公告】',
		'displayOnTheList': '顯示於首頁列表中',
		'important': '【重大公告】',
		'topOfTheHomepage': '首頁上方置頂顯示',
		'mandatory': '【強制公告】',
		'windowHomepage': '進入首頁前以彈跳視窗顯示',
		'pleaseSelect': '請選擇',
		'enterTheTitle': '輸入標題，最多50字',
		'attachmentLabel': '附件',
		'publishingSettings': '發佈設定',
		'announcementTime': '公告時間',
		'startTime': '開始時間 YYYY / MM / DD hh:mm',
		'endTime': '結束時間 YYYY / MM / DD hh:mm',
		'bottomButton': '置底按鈕',
		'noButtonRequired': '不需要按鈕',
		'displayButton': '顯示按鈕',
		'publishingTarget': '發佈對象',
		'publishingMethod': '發佈方式',
		'endOfAnnouncement': '公告結束，是否保留於前台訊息中心',
		'keepIt': '是，請保留',
		'takeItDown': '不用保留，請下架',
		'publishingUnit': '發佈單位',
		'optional': '（選填）',
		'noteUpToWords': '輸入備註，最多50字',
		'saveAsDraft': '儲存為草稿',
		'publish': '發佈',
		'noticeOfInspection': '檢示公告',
		'suspendPublicationDlg': '暫停發佈此則公告  ?',
		'suspendSuccessfully': '暫停發佈成功',
		'suspendFailed': '暫停發佈失敗',
		'afterSuspension': '暫停後，所有同仁皆無法看到公告',
		'deletedSuccessfully': '刪除成功',
		'deletionFailed': '刪除失敗',
		'currentlyBeingPublished': '目前公告發佈中，',
		'afterDeletion': '刪除後，前、後台皆無法查閱此則公告',
		'publicationSuccessful': '發佈公告成功！',
		'publicationfailed': '發佈公告失敗',
		'addingAttachmentFailed': '新增附件失敗！',
		'addingContentFailed': '新增公告內容失敗！',
		'contentIsRequired': '公告內容必填！',
		'contentToWords': '公告內容長度須小於 10,000 個字元',
		'formatError': '格式錯誤，僅接受http或https網址格式',
		'preview': '預覽',
		'saving': '儲存中',
		'publishing': '發佈中',
		'displayedTop': '列表置頂',
		'weekTo1': '週一',
		'weekTo2': '週二',
		'weekTo3': '週三',
		'weekTo4': '週四',
		'weekTo5': '週五',
		'weekTo6': '週六',
		'weekTo7': '週日',
		'displayPerDay': '每天顯示 <%=N%> 次 ',
		'updateAnnouncement': '更新發佈此則公告  ?',
		'updatedSuccessfully': '更新發佈成功',
		'editingAttachmentFailed': '編輯附件失敗！',
		'editingContentFailed': '編輯公告內容失敗！',
		'editingRulesFailed': '編輯規則內容失敗！',
		'startDateChanged': '發佈起日不可異動',
		'afterUpdatedAnnouncement': '發佈後，所有同仁皆看到為更新後公告內容',
		'confirmUpdate': '確認更新',
		'editAnnouncement': '編輯公告',
		'updatedAndPublished': '更新發佈',
		'enterToWords': '輸入自訂編號，最多10字',
		'displayEveryday': '每天顯示',
		'resetCalculation': '(每天 00:00重置計算次數)',
		'times': '次',
		'addToFavorites': '加入常用名單',
		'textDisplayed': '按鈕顯示文字，最多10字',
		'enterWebsite': '輸入網址 / 連結',
		'downloadedSuccessfully': '下載成功',
		'downloadFailed': '下載失敗',
		'emailSuccessfullySent': '發送催讀信件成功',
		'emailFailedSend': '發送催讀信件失敗',
		'title': '公告標題 :',
		'period': '公告期間 :',
		'type': '公告類型 :',
		'shouldRead': '應讀人數 :',
		'haveRead': '已讀人數 :',
		'unreadNum': '未讀人數 :',
		'readingRate': '閱讀率',
		'lastSent': '上次發送時間 :',
		'sendReminderNotification': '發送催讀通知',
		'download': '下載',
		'unread': '未讀',
		'read': '已讀',
		'numberOfRead': '閱讀次數',
		'latestReading': '最近一次閱讀時間',
		'announcement': '公告',
		'weekToNum1': '一',
		'weekToNum2': '二',
		'weekToNum3': '三',
		'weekToNum4': '四',
		'weekToNum5': '五',
		'weekToNum6': '六',
		'weekToNum7': '日',
		'bulletinPublishingUnit': '公告單位 : ',
		'bulletinCategory': '類別：',
		'announcementReadingStatus': '公告閱讀狀態',
		'updatingInProgress': '更新發佈中',
		'updateAndPublish': '更新發佈',
		'wantToDelete': '刪除此則公告 ?',
		'publishBtn': '發佈',
	},
	'hp.m1.m110030': {
		'addCategory': '新增類別',
		'editCategory': '編輯類別',
		'zhTW': '繁體中文',
		'zhUS': 'English',
		'zhEN': '简体中文',
		'categoryName': '公告類別名稱',
		'upTpword': '請輸入20字以內',
		'deledtedCompleted': '刪除公告分類完成!',
		'deletionFailed': '刪除公告分類錯誤',
		'defaultAndCannotBeDeleted': '此為系統預設，不可刪除',
		'wantToDelete': '確定要刪除類別「 <%=name%>」嗎?',
		'systemDefault': '系統預設',
		'additionCompleted': '新增公告類別成功',
		'addingFailed': '新增類別錯誤',
		'duplicateName ': '類別名稱重複',
		'editionCompleted': '編輯公告分類完成！<%=name%>',
		'editingFailed': '編輯類別錯誤',
		'confirmToDeactivate': '確定停用此類別',
		'categoryNotBeDeleted': '該類別已發布將不會被刪除',
		'confirmToActivate': '確定啟用此類別',
	},
	'hp.m1.m110040': {
		'addListOfFavorites': '新增常用名單',
		'closeSetting': '關閉設定',
		'name': '常用名單名稱',
		'selectTarget': '選擇對象',
		'confirmDelete': '確定要刪除常用名單「?',
		'confirmDelete1': '」嗎?',
		'deletedCompleted': '刪除常用名單(<%=name%>)完成',
		'deleteFailed': '刪除失敗: 常用名單(<%=name%>)已經使用中',
		'deleting': '刪除中',
		'noExisting': '目前沒有任何常用名單',
		'additionCompleted': '新增常用名單完成',
		'addingFailed': '新增常用名單失敗',
		'duplicateName': '常用名單名稱重複',
		'editListOfFavorites': '編輯常用名單',
		'editionCompleted': '編輯常用名單完成',
		'editingFailed': '編輯常用名單失敗',
	},
	'hp.m5.m510060': {
		'searchForAll': '申請人/簽核人/被異動人/表單編號',
		'formStatus': '表單狀態',
		'status': '狀態',
		'approver': '簽核人',
		'handlers': '主要及其他承辦人',
		'stakeholders': '表單關係人',
	},
	'components.custom-form.file-upload.prompt': {
		'format': '格式',
		'detail': '詳情',
		'executableFilesSuchAsExeCannot': '不可上傳執行檔，如 .exe 等',
		'noLimit': '不限制',
		'image': '圖片',
		'file': '文件',
		'briefing': '簡報',
		'trialBalance': '試算表',
	},
	'components.custom-form.number-format.view': {
		'enterANumber': '輸入數字',
	},
	'components.custom-form.import-image.preview': {
		'preview': '預覽',
	},
	'components.custom-form.date-range.date-range': {
		'startDate': '起始日期',
	},
	'components.custom-form.details': {
		'add': '新增',
	},
	'components.custom-form.remark': {
		'checkItems': '複選：請選擇 <%=min%> ~ <%=max%> 個選項',
	},
	'hp.m4.m410081': {
		'month': '月份',
		'shiftName': '班別',
		'scheduledTime': '應打卡時間',
		'systemCardTime': '系統打卡時間',
		'actualTime': '實際出勤時間',
		'attendStats': '出勤統計',
		'shouldWorkDays': '本月應上班日數',
		'actualWorkDays': '本月實際上班日數',
		'confirmBtn': '出勤紀錄確認',
		'confirmStatus': '確認狀態',
		'unconfirmed': '未確認',
		'confirmed': '已送出，送出日期：',
		'submittedBy': '送出人員：',
		'actualCardTime': '實際出勤時間',
		'lastSubmitTime': '最後送出時間',
		'noCardNeeded': '不需打卡',
		'overAttend': '超時出勤',
		'normal': '正常',
		'genTestMonthlyData': '隨機產生整月打卡資料',
		'err001': '請輸入時間格式(mm/dd hh:mm)',
		'err002': '您所填寫的 X 出勤時間尚有超時出勤狀況，請依規定修改後重新送出。',
	},
	'hp.m4.m410080': {
		'searchRange': '出勤區間',
		'requestStatus': '申請狀態',
		'deductedHours': '扣除時數',
		'vestingDate': '歸屬日:',
		'attendanceHoursDet': '出勤時數明細',
		'attVestingDate': '出勤歸屬日',
		'calendar': '行事曆別',
		'inTransit': '在途中',
	},
	'hp.m3.m310310': {
		'shiftLabel': '排班標籤',
		'label': '標籤',
		'shiftKeyword': '標籤關鍵字搜尋',
		'useStatus': '使用狀態',
		'source': '資料來源',
		'addLabel': '新增標籤',
		'import': '匯入',
		'serial': '序號',
		'labelCode': '標籤代碼',
		'labelName': '標籤名稱',
		'note': '備註',
		'lastUpdate': '最後更新',
		'addShiftLabel': '新增排班標籤',
		'copyLabel': '複製標籤',
		'pleaseSelectLabel': '請選擇標籤',
		'shiftLabelCode': '排班標籤代碼',
		'pleaseEnterLabelCode': '請輸入標籤代碼',
		'shiftLabelName': '排班標籤名稱',
		'pleaseEnterLabelName': '請輸入名稱',
		'fillColor': '填滿顏色',
		'wordColor': '文字顏色',
		'preview': '預覽結果',
		'pleaseEnterText': '請輸入文字',
		'editShiftLabel': '編輯排班標籤',
		'shiftLabelDetail': '排班標籤詳細資料',
		'latestUpdate': '最後修改時間',
		'confirmDelete': '確定要刪除「<%=name%>」嗎?',
		'shiftLabelImport': '排班標籤匯入',
		'importShiftLabel': '匯入排班標籤',
		'status': '狀態',
		'rules': '填寫規則',
		'format': '欄位格式',
		'example': '範例',
		'required': '必填',
		'labelCodeConflict': '代碼不可重複，限制 10 字以內',
		'useOrDeactivated': '使用中、停用',
		'upTo20Words': '限制 20 個字以內',
		'addShiftLabelCompleted': '新增排班標籤完成',
		'addShiftLabelFailed': '新增排班標籤失敗',
		'labelNameNotRepeated': '標籤名稱不可重複',
		'labelCodeNotRepeated': '標籤代碼不可重複',
		'shiftLabelCodeNotContainComma': '排班標籤代碼不得包含 "，"',
		'shiftLabellNameNotContainComma': '排班標籤名稱不得包含 "，"',
		'labelCodeNotContainComma': '標籤代碼不得包含 "，"',
		'labelNameNotContainComma': '標籤名稱不得包含 "，"',
		'importFormat': '匯入類型',
		'downloadImportSample': '下載匯入範例',
		'fieldRequired': '必填欄位',
		'importFileFormatRequired': '匯入方式為必填欄位',
		'fileNameNotContainSpecialChar': '檔案名稱不可包含特殊字元 \\ / : * ? " < > | # % &',
		'shiftLabelReadError': '讀取排班標籤資料錯誤',
		'shiftLabelNotExist': '排班標籤資料不存在',
		'editShiftLabelCompleted': '編輯排班標籤完成',
		'editShiftLabelFailed': '編輯排班標籤失敗',
		'deleteShiftLabelCompleted': '刪除排班標籤完成',
		'deleteShiftLabelFailed': '刪除排班標籤失敗',
		'addShiftLabelImportFormat': '新增排班標籤匯入格式.xlsx',
		'editShiftLabelImportFormat': '編輯排班標籤匯入格式.xlsx',
		'backstage': '後台',
		'usageStatusNotExist': '使用狀態不存在',
		'systemId': '系統ID',
		'errorMsg': '錯誤訊息',
		'duplicateCode': '代碼重複',
		'duplicateTraditionalChineseName': '繁體中文名稱重複',
		'duplicateEnglishName': '英文名稱重複',
		'duplicateSimplifiedChineseName': '簡體中文名稱重複',
		'systemIdNotExist': '系統ID不存在',
		'duplicateDataExist': '存在相同資料',
		'shiftGroup': '排班群組',
		'group': '群組',
		'groupKeyword': '群組關鍵字搜尋',
		'commonShift': '常用班別',
		'commonLabel': '常用標籤',
		'addGroup': '新增群組',
		'deleteShiftGroupMsg': '確定要刪除此 <%=count%> 筆排班群組嗎?',
		'groupName': '群組名稱',
		'shiftManager': '班表負責人',
		'addShiftGroup': '新增排班群組',
		'copyGroup': '複製群組',
		'selectGroup': '請選擇群組',
		'pleaseEnterGroupName': '請輸入名稱',
		'shiftLeaderAuthorityDescription': '班表負責人可視為小主管，具備排班、發佈班表，並提出調班申請單及支援申請單之權限。',
		'shiftScheduleApprover': '班表核決者',
		'classListApproverAuthorityDescription': '班表核決者可視為大主管，具備審核發佈班表，簽核調班申請單及支援申請單之權限。',
		'shiftScheduleCoordinator': '班表承辦人',
		'scheduleOrganizerPermissionsDescription': '班表承辦人可視為HR，具備審核發佈班表，簽核調班申請單及支援申請單之權限。',
		'applicableRecipients': '適用對象',
		'scheduleValidationExplanation': '當您進行排班時，系統會再自動檢查群組內適用對象，在實際的班表周期內是否至少有一天班別屬性為排班人員，若某員工在週期內並未設定為排班人員，則無法排定此員工的班表。',
		'shiftScheduleCycle': '班表週期',
		'to': '至',
		'shiftsPerDay': '每日可排班別數',
		'shift1': '一段班',
		'shift2': '兩段班',
		'shift3': '三段班',
		'shift4': '四段班',
		'editShiftGroup': '編輯排班群組',
		'shiftGroupDetails': '排班群組詳細資料',
		'maxShiftsPerDayPerPerson': '班表可排<%=alias%>段班 (每人每日最多可排<%=shiftMax%>個班別)',
		'shiftGroupImport': '排班群組匯入',
		'importShiftGroup': '匯入排班群組',
		'companyName': '公司名稱',
		'staffId': '員工編號',
		'workHourRegulationCycle': '固定週期、依照工時規則週期',
		'startMonth': '起始月',
		'fixedCycleRequired': '若班表週期設定為"固定週期"，則此欄位為必填',
		'monthPosition': '前一個月、本月、次月',
		'startDate': '起始日',
		'monthDate': '1日...30日、31日',
		'endMonth': '結束月',
		'endDate': '結束日',
		'monthDateEnd': '1日...30日、31日、月底',
		'typeWorkRules': '工時規則種類',
		'workingHourRegulationCycleRequired': '若班表週期設定為"依照工時規則週期"，則此欄位為必填',
		'workingHourRegulationOptions': '一般工時、雙週變形、四週變形、八週變形',
		'workingHourCycleStartDate': '工時計算週期起始日期',
		'dateFormatDescription': "請填寫日期，格式順序為: 年月日 西元-可接受間隔符號為'/'、'-' 民國-可接受間隔符號為'/'、'-'、'國字",
		'multipleCommonShiftsDescription': "若有多個常用班別，可輸入多個班別代碼或班別簡稱，並以 '，'間隔",
		'shift': '班別',
		'shiftCode': '班別代碼',
		'shiftAbbreviation': '班別簡稱',
		'viewWorkingHourCalculationCycle': '檢視工時計算週期',
		'previousCycle': '上一週期',
		'nextCycle': '下一週期',
		'viewCycle': '檢視週期',
		'groupNameConflictNotAllowed': '群組名稱不可重複',
		'shiftGroupDataNotExist': '排班群組資料不存在',
		'setAtLeastOneFilterCriteria': '請至少建立一個篩選條件',
		'startDateShouldBeEarlierThanEndDate': '開始時間必須早於結束時間。',
		'viewSchedulesLimitedTo8Weeks': '最多只能看到 8 周的班表',
		'addShiftGroupFailed': '新增排班群組失敗',
		'addShiftGroupCompleted': '新增排班群組完成',
		'shiftGroupReadError': '讀取排班群組資料錯誤',
		'editShiftGroupFailed': '編輯排班群組失敗',
		'editShiftGroupCompleted': '編輯排班群組完成',
		'one': '一',
		'two': '兩',
		'three': '三',
		'four': '四',
		'accordingToWorkHourRulesCycle': '依照<%=otWorkhourType%> 規則週期',
		'theStartDateOfWorkingHourCalculationCycleIs': '工時計算週期起始日期為 <%=date%>',
		'deleteShiftGroupCompleted': '刪除排班群組完成',
		'deleteShiftGroupFailed': '刪除排班群組失敗',
		'editShiftGroupImportFormat': '編輯排班群組匯入格式.xlsx',
		'otherErrorMsg': '其他錯誤訊息',
		'staffIdNotExist': '員工編號不存在',
		'shiftScheduleCycleNotExist': '班表週期不存在',
		'startMonthNotExist': '起始月不存在',
		'startDateNotExist': '起始日不存在',
		'endMonthNotExist': '結束月不存在',
		'endDateNotExist': '結束日不存在',
		'typeWorkRulesNotExist': '工時規則種類不存在',
		'commonShiftNotExist': '常用班別不存在',
		'commonLabelNotExist': '常用標籤不存在',
		'companyNotExist': '公司名稱不存在',
		'duplicateSystemId': '系統ID重複',
		'importFileSameGroupName': '匯入檔案內有相同名稱的群組',
		'unauthorizedOperation': '未授權的操作',
		'employeeNotActiveEmployment': '員工非在職狀況',
		'availableWorkHours': '可上班時間',
		'start': '開始',
		'end': '結束',
		'totalManpower': '總計人數',
		'employeeMgmt': '員工管理',
		'importEmployeeManagement': '員工管理匯入',
		'empNo': '員工編號',
		'empName': '員工姓名',
		'labelIsNotExist': '標籤不存在',
		'invalidTimeFormat': '不符合時間格式',
		'startTimeShouldBeEarlierThanEndTime': '開始時間必須早於結束時間。',
		'required': '必填',
		'mondayStart': '星期一開始',
		'mondayEnd': '星期一結束',
		'tuesdayStart': '星期二開始',
		'tuesdayEnd': '星期二結束',
		'wednesdayStart': '星期三開始',
		'wednesdayEnd': '星期三結束',
		'thursdayStart': '星期四開始',
		'thursdayEnd': '星期四結束',
		'fridayStart': '星期五開始',
		'fridayEnd': '星期五結束',
		'saturdayStart': '星期六開始',
		'saturdayEnd': '星期六結束',
		'sundayStart': '星期日開始',
		'sundayEnd': '星期日結束',
		'nationalHolidayStart': '國定假日開始',
		'nationalHolidayEnd': '國定假日結束',

		'incorrectDataImport': '錯誤員工管理匯入資料',
	},
	'hp.m3.m310080': {
		'exportCompleted': '匯出完成',
		'exportFailed': '匯出失敗',
		'downloadDetailed': '下載明細表',
		'staffIdName': '員工編號 / 姓名',
		'totalAttHours': '出勤時數合計',
		'companyDept': '公司 / 部門',
		'attendancePeriod': '出勤區間:',
		'totalAttendanceHours': '出勤時數合計 <%=h%>小時 <%=m%>分鐘',
		'min': '分鐘',
		'detailedAttendanceReportTitle': '部屬出勤時數明細表',
		'detailedAttendanceReport': '部屬出勤時數明細表',
		'company': '公司名稱',
		'chineseName': '中文姓名',
		'englishName': '英文姓名',
		'startDate': '出勤起始時間',
		'endDate': '出勤結束時間',
		'number': '時數',
		'unit': '單位',
		'deductingHours': '扣除時數區間',
		'searchRange': '查詢期間：',
	},
	'hp.m4.m410060': {
		'leaveType': '假勤類別',
		'leaveTime': '假勤時間',
		'leaveHours': '假勤時數',
		'leaveResumptionHours': '銷假時數',
		'actualHours': '實際時數',
		'substitute': '代理人',
		'leaveStartAndEendTime': '假勤起訖日期',
		'eventDateDescription': '事件發生日說明',
		'officialLeave ': '公司假',
		'annualLeave': '特休',
		'compensatoryTime': '補休',
		'flexibleLeave': '彈性假',
		'generalLeave': '一般假勤',
		'leaveResumptionLoadingError': '載入銷假明細錯誤',
		'leaveResumptionDetails': '銷假明細',
		'available': '可休期間',
	},
	'hp.m4.m410050': {
		'overtimeStartAndEndTime': '加班起訖時間',
		'overtimeHours': '加班時數',
		'deductedHours': '扣除時數',
		'redeemedForOvertimePay': '折換加班費',
		'redeemedForCompensatoryTime': '折換補休',
		'detailedOvertimeInformation': '加班詳細資訊',
		'available': '可休:',
		'availableNoExpiration': '可休: 無限期',
		'aboutToExpire': '即將到期',
		'expiryDate': '到期日',
		'noDetailedOvertime': '無加班詳細資訊',
		'noExpiration': '無限期',
	},
	'hp.m4.m410070': {
		'year': '統計年度',
		'rule': '可休規則',
		'noLimit': '無上限',
		'or': '或',
		'time': '次',
		'every': '每',
		'used': '已休',
		'remaining': '剩餘',
		'approving': '簽核中',
		'canApply': '可申請',
		'businessTrip': '出差',
		'annualLeaveEntitlement': '年度可休',
		'officialLeave': '公司假',
		'officialLeaveStatistics': '公司假統計',
		'annualLeaveStatistics': '特休統計',
		'startDateForLeave': '給假起始日',
		'endDateOfAllowableLeave': '可休到期日',
		'type': '類別',
		'available': '可休',
		'useding': '已使用',
		'total': '合計',
		'wantToTakeALeave': '我要休假',
		'compensatoryTimeStatistics': '補休統計',
		'restLimit': '可休額度',
		'source': '來源',
		'flexibleLeaveStatistics': '彈性假統計',
		'aAndBYear': '<%=A%> 年<%=B%>',
		'flexName': '彈性假名稱',
		'leaveDate': '給假日期',
		'allowAdvanceUse': '允許預支',
		'deduction': '扣回',
		'generalLeaveStatistics': '一般假勤統計',
		'goOnABusinessTrip': '我要出差',
		'tripStartDate': '出差起始日',
		'tripEndDate': '出差結束日',
		'businessTripDuration': '出差時數',
		'leaveSart': '請假起始日',
		'leaveEnd': '請假結束日',
		'perYear': '年度可休 <%=A%> <%=B%>',
		'everyYear': '每 <%=A%> 年<%=B%>',
		'everyMonth': '每 <%=A%> 月<%=B%>',
		'everyDay': '每 <%=A%> 天<%=B%>',
		'everyTime': '每次',
		'birthMonth': '生日當月',
		'birthDay': '生日當日',
		'leavehours': '請假時數',
		'endDate': '到期日',
	},
	'hp.m3.m310040': {
		'abnormal': '異常狀態',
		'leaveType': '異常狀態各項目的計數，來自於該員工出勤紀錄比對後的結果。',
		'oddLate': '異常-不拘',
		'oddLeaveEarly': '異常-遲到',
		'oddAbsenteeism': '異常-早退',
		'oddFailureToClockIn': '異常-曠職',
		'oddExcessAttendanceHours': '異常-未打卡',
		'oddOvertimeClockInTime': '異常-超時出勤',
		'oddOvertimeSwiping': '加班刷卡時間不足',
		'overtimeClockInTime': '加班刷卡時間不足',
		'oddClockInOutData': '異常-刷卡資料不足',
		'explanation': '異常狀態各項目的計數，來自於該員工出勤紀錄比對後的結果。',
		'explanationAll': '包含已核准與簽核中狀態。總合值因算法限制，約為概略值，細節請點擊查看全部。',
		'late': '遲到',
		'leaveEarly': '早退',
		'absenteeism': '曠職',
		'failureToClockIn': '未打卡',
		'excessAttendanceHours': '超時出勤',
		'clockInOutData': '刷卡資料不足',
		'anomalousDetails': '出勤打卡異常明細',
		'searchRange': '查詢期間:',
		'total': '共計',
		'anomalousData': '項異常',
		'haveBeenProcessed': '已處理',
		'waitForProcessing': '待處理',
	},
	'hp.m3.m310050': {
		'downloadMultiplierStatistical': '下載倍率統計表',
		'totalHourMin': '<%=h%>小時 <%=m%>分鐘',
		'overtimeDetails': '加班明細',
		'searchRange': '查詢期間: ',
		'overtimeHourMin': '加班時數合計 <%=h%>小時 <%=m%>分鐘',
		'vestingDate': '歸屬日:',
		'available': '可休期間：',
		'noExpiration': '無限期',
		'aboutToExpire': '即將到期',
		'subordinateOvertimeRateStatistics': '部屬加班倍率統計表',
		'subordinateOvertimeRateCalendar': '部屬加班倍率統計表–依行事曆別統計',
		'subordinateOvertimeDetails': '部屬加班明細表',
		'startDate': '加班起始時間',
		'endDate': '加班結束時間',
		'overtimeVestingDate': '加班歸屬日',
		'overtime': '加班',
		'deduction': '扣除',
		'compensatoryLeaveStart': '補休假可休起始日',
		'compensatoryLeaveEnd': '補休假可休截止日',
		'times1334': '1.334倍',
		'workingDay': '工作日',
		'times': ' 倍',
		'statisticsTitle': '部屬加班倍率統計表',
		'rateCalendarTitle': '部屬加班倍率統計表–依行事曆別統計',
	},
	'hp.m3.m310060': {
		'statisticsloadingError': '載入公司年度假勤統計錯誤',
		'listMode': '清單模式',
		'sumMode': '總和模式',
		'leaveRecords': '假勤記錄',
		'annualUnit': '特休 <%=n%> 小時',
		'compensatoryUnit': '補休 <%=n%> 小時',
		'flexibleUnit': '彈休假 <%=n%> 小時',
		'officialUnit': '公司假 <%=n%> 小時',
		'generalUnit': '一般假勤 <%=n%> 小時',
		'subordinateLeaveDetails': '部屬假勤明細表',
		'leaveStartDate': '假勤起始時間',
		'leaveEndDate': '假勤結束時間',
		'leave': '假勤',
		'leaveResumption': '銷假',
		'actual': '實際',
		'attachment': '附件名稱',
		'leaveTime': '假勤時間',
		'approx': '約 <%=n%> 小時',
	},
	'hp.m3.m310070': {
		'keyword': '員工關鍵字',
		'leaveDataSearch': '部屬出/假勤資料查詢',
		'noData ': '沒有符合查詢條件的資料',
		'leaveSummary': '部屬假勤總表',
		'downloadYear': '統計年度：',
		'used': '已休時數',
		'remaining': '剩餘時數',
	},
	'hp.m3.m310110': {
		'subordinateProfileSearch': '部屬個人資料查詢',
		'salaryData': '薪資資料',
		'downloadingFailed': '載入個人資訊錯誤',
		'jobAndYearOfService': '職務及年資',
		'eduAndWorking': '學經歷資料',
		'skillsAndExpertise': '技能專長證照',
		'payrollLoadingError': '載入薪資袋錯誤',
		'noSalaryRule': '尚無已生效的薪資規則',
		'fromSalaryCalculation': '顯示不計薪科目',
		'effectiveDate': '生效日期：',
		'salaryMethod': '計薪方式：',
		'salaryApproval': '核薪原因：',
		'changeHistory': '異動歷程',
		'salaryAccount': '薪資料目',
		'partOfTheSalary': '是否計薪',
		'numberOfChanges': '異動次數：',
		'loginFailed': '登入失敗：',
		'noData': '目前無資料',
		'listening': '聽',
		'speaking': '說',
		'reading': '讀',
		'writing': '寫',
		'level': '程度',
	},
	'hp.m4.m410110': {
		'familyMembersError': '親屬名單載入錯誤',
		'changeDetails': '異動明細',
		'listOfFamilyMembers': '親屬名單',
		'changeDetailsOfFamilyMembers': '親屬名單異動明細',
		'rejectionOpinion': '駁回意見：',
		'relationship': '關係',
		'birthday': '生日',
		'nationality': '國籍',
		'dependents': '被扶養人',
		'idNumber': '身分證號',
		'alienResidentNumber': '外僑統一證號',
		'degreeOfDisability': '身障程度',
		'survivalStatus': '存歿',
		'requestTimeStart': '申請時間(起)',
		'requestTimeEnd': '申請時間(訖)',
		'auditStatus': '審核狀態',
		'changeitems': '異動項目',
		'approver': '審核人',
		'auditTime': '審核時間',
		'result': '審核結果',
		'originalContent': '原內容',
		'contentAfterModification': '維護後內容',
		'blueTextRepresents': '藍字代表申請異動項目',
		'deleted': '(刪除)',
		'releativesData': '親屬名單資料不存在',
		'attachmentsError': '儲存附件發生錯誤',
		'dependentsT': '被扶養人：',
		'reviewNotification': '您已在 <%=t%> 提交資料，請稍待管理者審核通知。',
		'wantToDelete': '確定要刪除親屬名單:「',
		'wantToDelete1': '」 嗎?',
		'exJessicaLo': '例:羅琪夢',
		'error': '錯誤',
		'category': '類別',
		'changeIems': '項目',
		'resultTd': '狀態',
		'note': '備註',
		'approved': '核准',
		'rejected': '駁回',
		'releativesError': '<%=name%> 已有保險相關資料，無法刪除',
		'updateError': '<%=s%>異動失敗',
	},
	'hp.m4.m410100': {
		'profileLoadingError': '個人資料載入錯誤',
		'changeDetails': '異動明細',
		'personalSummary': '個人摘要',
		'contactInfo': '聯絡資訊',
		'education': '學歷',
		'workingExperiences': '經歷',
		'skillsAndExpertise': '技能專長',
		'certifications': '證照',
		'disabilityCategory': '身障類別',
		'passportName': '護照姓名',
		'passportnumber': '護照號碼',
		'exitDates': '入出境日期',
		'expirationDateOfResidencePermit': '居留證到期日',
		'intermediaryUnit': '仲介單位',
		'contactPhoneNumber': '通訊電話',
		'primaryEmergencyContact': '主要緊急聯絡人',
		'noData': '(空白)',
		'secondaryEmergencyContact': '次要緊急聯絡人',
		'languageProficiency': '語言能力',
		'dialectProficiency': '方言能力',
		'level': '程度',
		'competency': '職能',
		'schoolNameChinese': '學校名稱 (中文)',
		'departmentNameChinese': '科系名稱 (中文)',
		'dateOfEnrollment': '入學日期',
		'dateOfDepartureFromschool': '離校日期',
		'departmentProgramCategory': '科系類別',
		'companyName': '公司名稱',
		'dateOfEmployment': '就職日期',
		'dateOfResignation': '離職日期',
		'positionCategory': '職務類別',
		'managerialPosition': '是否擔任管理職',
		'certificateName': '證照名稱',
		'type': '種類',
		'certificateNumber': '證照號碼',
		'issuingAuthority': '發照單位',
		'approvalNumber': '核准文號',
		'trainingHours': '訓練時數',
		'acquisitionDate': '取得日期',
		'cancellationDate': '註銷日期',
		'changeDetailsOfProfile': '基本資訊異動明細',
		'changeCategory': '異動類別',
		'category': '類別',
		'disabilityCategoryIsDuplicated': '身障類別重複',
		'exitDateRangeExists': '已有相同的出入境日期區間資料',
		'theSavedData': '出入境日期區間需大於已儲存資料',
		'dateIsDuplicated': '居留證到期日重複',
		'exJessicaLoEN': '例: Jessica Lo',
		'age': '年齡',
		'year': '<%=n%>歲',
		'asShownOnPassport': '護照姓名 (as shown on passport)',
		'passportNumber': '護照號碼 (Passport No)',
		'idNoARC': '外僑統一證號 (ID No)',
		'doesNotExist': '聯絡資訊資料不存在',
		'areYouSave': '若異動員工的公司email，則Portal需重新認證帳號才可使用。確定要儲存嗎？',
		'countyCityArea': '請選擇縣市區域',
		'permanentAddress': '請輸入戶籍地址',
		'registeredInformation': '同戶籍',
		'mailingAddress': '請輸入通訊地址',
		'exTel': '例: 02 22881256',
		'exCel': '例: 0912 345 678',
		'exEmail': '例: youremail@company.com',
		'exEmail2': '例: youremail@urself.com',
		'exSelect': '請選擇',
		'listeningTemplate': '聽<%=n%>',
		'speakingTemplate': '說<%=n%>',
		'readingTemplate': '讀<%=n%>',
		'writingTemplate': '寫<%=n%>',
		'listening': '聽',
		'speaking': '說',
		'reading': '讀',
		'writing': '寫',
		'exCompetency': '請挑選「職能」(最多50項)',
		'eduDataDoesNotExist': '學歷資料不存在',
		'reviewNotification': '您已在 <%=t%> 提交資料，請稍待管理者審核通知。',
		'youWantToDelete': '您要刪除<%=d%>嗎?',
		'exCollege': '例: 104系統大學',
		'exDepartments': '例: 工業工程系',
		'graduation': '畢業',
		'periodOfStudy': '就學期間',
		'expDoesNotExist': '經歷資料不存在',
		'companyNameP': '請輸入公司名稱',
		'termOfEmployment': '任職期間',
		'certificationAddingFailed': '新增證照失敗',
		'certificationDataDoesNotExist': '證照資料不存在',
		'laterThanThe': '生效日期大於有效日期',
		'laterThanTheAcquisitionDate': '取得日期大於註銷日期',
		'expirationDateT': '有效日期：',
		'effectiveDateT': '生效日期：',
		'exTOEIC': '例: TOEIC',
		'exNo': '例: 12345678',
		'pleaseFillIssuingAuthority': '請填寫發照單位',
		'number': '請填入時數',
		'date': '請選擇日期',
		'underReview': '資料審核中',
		'loadingError': '<%=t%>載入錯誤',
		'updatedSuccessfully': '<%=s%>更新成功',
		'noMessageNotification': '無訊息通知範本',
		'noAssignedPersonnel': '無承辦人員',
		'noFieldChanges': '無欄位異動',
		'noRelatedFormSettings': '沒有相關表單設定',
		'pleaseRefreshAndRryAgain': '含有禁止操作欄位，請重新整理後再試一次',
		'overridden': '需覆寫此 method',
		'notRequireReview': '編輯不需審核資料',
		'editingRequiresToReview': '編輯需審核資料',
		'submit': '送出審核',
		'itWillTakeEffect': '以下欄位填寫後，需送出審核，由管理員進行審核，通過後即生效。',
		'afterApproval': '您已在 <%=t%> 提交資料，請稍待管理員審核通知。待審核通過後，再開放編輯以下欄位。',
		'waitingForTheReviewProcess': '您已在 <%=t%> 提交資料，請稍待管理員審核通知，等待審核的過程中，您也可以繼續編輯其他欄位。',
		'wantToDeleteTheData': '你確定要刪除此筆資料嗎？',
		'hasBeenDeleted': '<%=d%>已刪除',
		'deletionFailed': '<%=d%>刪除失敗',
		'notYetImplemented': '尚未實作 <%=n%> 的 renderBody()',
		'deleteTheData': '確定刪除？',
		'administratorReviewAndNotification': '您已在 <%=t%> 提交資料，請稍待管理者審核通知。',
		'language': '語言',
		'identity': '身份',
		'dialect': '方言',
		'expirationDate': '有效日期',
	},
	'hp.m3.m310220': {
		'readingFailed': '讀取統計失敗',
		'shiftGroup': '群組',
		'searchRange': '時間區間',
		'items': '班別項目',
		'subtotal': '小計',
		'downloadFail': '下載班表人力統計失敗',
		'notSchedule': '未排班',
		'leave': '請假',
		'allDayLeave': '全天請假',
		'overtime': '加班',
		'rotatingShiftsByShiftEmployees': '排班(依班別)員工',
		'rotatingShiftsByPeriodEmployees': '排班(依時段)員工',
		'allRotatingShiftsEmployees': '所有排班員工',
		'workTime': '工作時間：',
		'restTime': '休息時間：',
		'exportDate': '匯出日期：',
		'startendtime': '起訖時間：',
		'shiftTime': '班表起訖時間：',
		'dept': '部門：',
		'date': '日期',
		'manpowerStatisticsByClass': '班別人力統計',
		'manpowerStatisticsByShift': '排班人力統計',
		'shift': '排班班别',
		'workTimeTitle': '工作時間',
		'restTimeTitle': '休息時間',
		'allowableOvertimeHours': '可加班時間',
		'prohibitionOfOvertimeHours': '禁止加班時間',
		'shiftHours': '班別時數：<%=N%>小時',
		'dailyTotal': '日總計',
		'actualShiftHours': '實際班別時數：<%=N%>小時',
		'everyHourOfWorkMinuteOfRest': '每工作<%=H%>小時，休息<%=M%>分鐘',
		'previousDay': '前日',
		'currentDay': '當日',
		'followingDay': '次日',
		'restTemp': '每<%=H%>小時休息<%=M%>分鐘',
		'weeklyTemp': '每週：每<%=H%>小時要休息<%=M%>分鐘',
		'fixedTimeTemp': '固定時間：<%=S%> - <%=E%>',
	},
	'hp.m3.m310230': {
		'reportSettings': '報表設定',
		'manpowerStatisticsbyPeriod': '時段人力統計',
		'startendtime': '起訖時間',
		'shiftGroupIsNotSet': '未設定群組排班人員',
	},
	'hp.m4.m410090': {
		'62-bonusForExceeding': '62-所屬投保單位給付全年累計逾當月投保金額四倍部分之獎金',
		'63-nonInsuredUnits': '63-非所屬投保單位給付之薪資所得',
		'65-incomeFromProfessionalPractice': '65-執行業務收入',
		'66-dividendIncome': '66-股利所得',
		'67-interestIncome': '67-利息所得',
		'68-rentalIncome': '68-租金收入',
		'reportType': '報表類型',
		'corporateTaxIDNo.': '公司統編',
		'period': '保費期間',
		'result': '資料搜尋結果',
		'details': '明細',
		'insurancePremiumProofSearch': '保費明細查詢',
		'proof': '證明',
		'laborInsurancePremiumDetailsItem': '勞保保費明細',
		'yearMonthOfHealth': '健保年月',
		'yearMonthOfLabor': '勞保年月',
		'actualPaidLaborInsurancePremium': '實繳勞保費',
		'healthInsurancePremiumDetails': '健保保費明細',
		'relationship': '稱謂',
		'actualPaidHelathInsurancePremium': '實繳健保費',
		'laborAndHealthInsurancePremiumDetails': '勞保、健保保費明細',
		'TotalActualPaidInsurancePremium': '實繳總保費',
		'proofOfLaborInsuranceAndHealthInsurancePremiums': '勞保、健保保費證明',
		'IDNumber': '身分證字號',
		'dateOfBirth': '出生年月日',
		'healthInsurancePremium': '健保費',
		'laborInsurancePremium': '勞保費',
		'totalInsurancePremium': '總保費',
		'nationalHealthInsurance': '全民健康保險',
		'certificateOfSupplementaryInsurancePremium': '各類所得(收入)扣繳補充保險費證明單',
		'unifiedBusinessNumberForDeductionUnit': '扣費單位統一編號',
		"taxpayersIDNo": '所得人身分證號',
		'incomeCategory': '所得(收入)類別',
		'taxpayersName': '所得人姓名',
		'taxpayersAddress': '所得人地址',
		'yearOfPayment': '所得給付年度',
		'totalAmountPaid': '給付總額',
		'amountOfSupplementaryInsurancePremiumWithheld': '扣繳補充保險費金額',
		'deductionUnit': '扣費單位',
		'name': '名稱',
		'taxWithholders': '扣費義務人',
		'incomeCategoryExplain': '所得(收入)類別說明',
		'accurate': '以上資料經查證正確無誤。',
		'corporateTaxIDNumber': '統一編號 :',
		'companyName': '公司名稱 :',
		'companyAddress': '公司地址 :',
		'nameOfTheResponsiblePerson': '負責人姓名 :',
		'fiscalYear': '所得年度',
		'myself': '本人',
		'address': '地址',
		'page': '頁次：第 <%=temp1%> 頁／共 <%=temp2%> 頁',
		'noInformation': '無資料，試試重新搜尋吧！',
		'amountInNT': '金額以新台幣計',
		'dateOfCompilation': '製表日期 : ',
		'groupInsuranceApplicantNo': '投保單位代號',
		'proofOfPremium': '保費證明',
		'premiumDetails': '保費明細',
		'proofOfSupplementaryPremium': '補充保費證明',
		'healthInsurancePremiumDetails': '健保明細',
		'laborInsurancePremiumDetails': '勞保明細',
	},
	'hp.m4.m410030': {
		'fiscalYear': '所得年度',
		'noTaxWithholdingForm': '無扣繳憑單資料',
		'taxWithholdingFormSearch': '扣繳憑單查詢',
		'theInquiryFunctionIsCurrentlyUnavailable.': '目前未開放查詢功能',
		'parameterFileLoadingError': '參數檔載入錯誤',
		'taxWithholdingFormLoadingError': '扣繳憑單載入錯誤',
		'noTaxWithholdingFormFor': '申請所得年度 <%=temp1%>，無扣繳憑單資料',
		'incomeLessThan1000 ': '申請所得年度$<%=temp1%>，所得未滿1,000元，不需扣繳憑單',
		'taxWithholdingForm': '-扣繳憑單.pdf',
	},
	'hp.m5.m510050': {
		'applicantApproverFormNo': '申請人/簽核人/被異動人/表單編號',
		'deleteByBatch': '批次刪單',
		'cancelArchivingByBatch': '批次取消封存',
		'generalForm': '一般表單',
		'archivedForm': '封存表單',
		'rquestLeaveOver': '申請時間/假勤時間/加班時間/調班時間',
		'unableToWithdrawOrDelete': '無法抽單或刪單',
		'withdrawalFailed': '抽單失敗: 表單已被他人抽單、刪單、簽核完成、或已進行結算，因此無法抽單',
		'deletionFailed': '刪單失敗',
		'confirmDeletion': '確認刪單',
		'deletionCompleted': '刪單完成',
		'reason': '原因說明',
		'confirmWithdrawn': '確認抽單',
	},
	'hp.m4.m410200': {
		'shiftType': '班別屬性：',
		'calendar': '行事曆別：',
		'shift': '排班班別：',
		'noEmployeeAttendanceRulesOrCalendars': '未建立員工出勤規則或行事曆的資料',
		'leaveOvertimeDetails': '請假加班明細',
		'annualSchedule': '年度班表查詢',
		'monthlySchedule': '月行事曆查詢',
		'loadingFailed': '載入先導資料失敗',
		'beforeTheChange': '異動前',
		'afterTheChange': '異動後',
		'notScheduled': '未排班:',
		'loadingOfShiftDataFailed': '載入員工班表資料錯誤',
		'leaveAbbreviation': '假',
		'leave': '請假',
		'leaveTime': '請假時間:',
		'leaveResumption': '銷假時間:',
	},
	'h2.am.ShiftingSidePanelComps': {
		'workingHoursStatistics': '工時統計',
		'hoursDays': '時數/天數',
		'scheduledHours': '排班時數',
		'numberOfUnscheduledDays': '未排班天數',
		'shouldBeScheduled': '應排',
		'alreadyScheduled': '已排',
		'difference': '差異',
		'statisticsOfFlexibleWorkingHoursIntervals': '變形工時區間統計',
		'period': '期間',
		'workingHours': '已排時數',
		'publicHolidays': '例假日',
		'restDays': '休息日',
		'theCycleDaysAreNotMet': '週期天數未滿',
		'calendarStatistics': '行事曆別統計',
		'shiftStatistics': '班別統計',
		'shift': '排班班別',
		'labelStatistics': '標籤統計',
		'leaveOvertimeStatistics': '請假/加班統計',
		'hoursTimes': '時數/次數',
		'overtimeHours': '加班時數',
		'leaveHours': '請假時數',
		'totalFullDayLeaveInstances': '全天請假次數',
		'project': '項目',
		'hour': '小時',
		'day': '天',
		'days': '天數',
		'unitOfDays': '天數',
		'calendar': '行事曆別',
		'shiftLabel': '排班標籤',
		'times': '次數',
		'secondary': '次',
		'onlyWorkingDays': '只計算工作日',
	},
	'hp.m5.m510040': {
		'formName': '表單名稱',
		'firstSubstitute': '第一位代理人',
		'secondSubstitute': '第二位代理人',
		'agentStatus': '代理狀態',
		'signOffAgentTime': '簽核代理時間',
		'selectSubstitute': '選擇代理人',
		'atLeastOneSubstitute': '必填至少1位',
		'proxyTime': '代理時間',
		'atLeastOneInterval': '必填至少1組',
		'setSubstituteApprover': '簽核代理人設定',
		'batchSettings': '批次設定',
		'substituteApproverBatchSettings': '簽核代理人設定 - 批次設定',
		'selectForms': '選擇表單',
		'applyTheSettings': '套用上方設定到所選擇的表單',
		'noFormDataFound': '查無表單資料',
		'theModificationOfApproverSubstituteSettingsIsComplete': '修改簽核代理人設定完成',
		'theModificationOfApproverSubstituteSettingsFailed': '修改簽核代理人設定失敗',
		'theFormDoesNotExist': '表單不存在',
		'theEndDateOfTheProxyTimeIsBeforeTheSetDate': '代理時間迄日小於設定日時間，請重新設定',
		'noProxyTimeConflictIsAllowed': '代理時間重覆，請重新設定',
		'theProxyStartAndEndTimesCannotOverlap': '代理起訖時間不可重複，請重新設定',
		'savedSuccessfully': '儲存成功',
		'batchSettingsFailed': '批次設定失敗',
		'pleaseSelectForms': '請選擇表單',
	},
	'hp.m3.m310210': {
		'subordinateShift': '員工班表資訊',
		'downloadReport': '下載報表',
		'reports': '統計報表',
		'failedToExportTheReport': '匯出報表失敗',
		'noDataAvailableForExport': '無資料可匯出，請重新設定匯出條件',
		'shiftStartEndTime': '班表起訖時間',
		'pleaseSetTheShiftStartEndTime': '請設定班表起訖時間',
		'allEmployees': '全體員工',
		'specificEmployees': '特定員工',
		'reportType': '報表名稱',
		'shiftHoursSummary': '排班時數彙總表',
		'employeePeriod': '人力明細表（依員工／時段）',
		'shiftDate': '人力統計表（依班別／日期）',
		'shiftAndDate': '人力統計表（依班別 日期）',
		'periodDate': '人力統計表（依時段／日期）',
		'periodAndDate': '人力統計表（依時段 日期）',
		'totalShiftHours': '加總班別時數',
		'totalClockInHours': '加總刷卡時數',
		'totalOvertimeHours': '加總加班時數',
		'totalLeaveHours': '加總請假時數',
		'shiftReport': '排班報表',
		'totalManpowerHours': '加總人力／時數',
		'timeUnit': '時間單位：',
		'shiftToN': '班別(<%=N%>)',
		'shiftHours': '班別時數',
		'clockInHours': '刷卡時數',
		'employee': '員工：',
		'totalEmployee': '共<%=N%>位員工',
		'specificReport': '特定員工，',
	},
	'hp.m2.m210021': {
		'tree': '樹狀圖',
		'pyramid': '金字塔圖',
		'display': '展開到',
		'proportion': '顯示比例',
		'deptHead': '顯示部門主管',
		'closedDpet': '顯示關閉部門',
		'deptHeadCount': '顯示部門人數',
		'noCurrentSupervisor': '無現任主管',
		'noSupervisorAssigned': '未設定主管',
		'noCurrentDeputySupervisor': '無現任副主管',
		'noDeputySpuerviseorAssigned': '未設定副主管',
		'code': '代碼',
		'name': '名稱',
		'abbr': '簡稱',
		'supervisor': '主管',
		'deputySupervisor': '副主管',
		'upperDept': '上層部門',
		'organizationLevel': '組織層級',
		'deptAddress': '部門地址',
		'deptEnglishAddress': '英文地址',
		'tel': '電話',
		'fax': '傳真',
		'note': '備註',
		'status': '狀態',
		'noOrganizationalData': '無可查看組織圖的公司',
		'noMatchData': '咦，找不到符合的資料 !',
		'dataNotEffectSearchCriteria': '可能是資料尚未生效，建議您詢問系統管理員或重新設定搜尋條件',
		'expandFromDept': '以此部門展開',
		'onlyDisplay': '只顯示',
		'subDept': '以下部門',
		'onlyDisplaySunDept': '只顯示以下部門',
		'restoreOrganizationChart': '還原全公司組織圖',
	},
	'hp.m3.m310410_new': {
		'theNameOfTheSchedule': '班表名稱',
		'enterAScheduleName': '輸入班表名稱',
		'scheduleTime': '班表時間',
		'scheduleFrom': '班表時間 (起)',
		'timetableAttendance': '班表時間 (訖)',
		'holidaysTotalTempDays': '假節日(共<%=temp1%>日)',
		'shiftStaff': '排班人員',
		'pleaseSelectAShiftGroup': '請選擇排班群組',
		'editMembers': '編輯成員',
		'pleaseSelectYourRegularClass': '請選擇常用班別',
		'pleaseSelectAFrequentlyUsedTag': '請選擇常用標籤',
		'employeePreScheduling': '員工預排班表',
		'rowableTypes': '可排類型',
		'allowEmployeesToPrescheduleShiftsWhen': '允許員工預排班表時，可以排的類型。譬如允許員工排休息日，則員工不可排國定假日及例假日。<%=temp1%>若開放員工可排「請假」，僅代表員工可預先壓請假，實際請假仍需提交申請單。',
		'employeesCanBeScheduledForShifts': '員工可排班別',
		'pleaseSelectTheEmployeeAvailableShifts': '請選擇員工可排班別',
		'openSchedulingHours': '開放排班時間',
		'ifTheScheduleStartsAndEnds': '若班表起訖為7/1~7/30，開放排班時間為前10~5天，則員工可於6/21~6/26預排班。',
		'theScheduleStartsBeforeTheDate': '班表起日前',
		'pleaseEnter': '請輸入',
		'sky': '天',
		'daysYouCanSchedule': '天，可於<%=temp1%>~<%=temp2%>排<%=temp3%>~<%=temp4%>的班表',
		'openToViewOtherEmployeesPre': '開放檢視其他員工預排班表',
		'canEmployeesViewOtherStaffSchedules': '員工可否檢視同份班表中的其他員工班表。',
		'editTheRoster': '編輯排班人員',
		'thereShouldBeAtLeastOne': '排班人員至少要一位',
		'aTotalOfPersonnelWereIncluded': '共納入排班人員<%=temp1%>位',
		'storageToTheNextStep': '儲存，至下一步',
		'itMustNotBeLessThan': '不可小於後方的時間',
		'failedToSaveScheduleTheAvailable': '儲存班表失敗：員工預排班表的可排類型，必須同時選入班別及標籤。',
		'ifYouChangeTheScheduleTime': '若更改班表時間，班表內容將會清空，確定要更改嗎？',
		'failedToAddASchedule': '新增班表失敗',
		'theScheduleDoesNotExist': '班表不存在',
		'duplicateScheduleNames': '班表名稱重複',
		'shiftGroupDisabled': '排班群組已停用，請重新選擇',
		'thereAreNoScheduledStaffPlease': '無可排班人員，請重新確認',
		'saveAndPublishSchedules': '儲存並發布班表',
		'theStorageScheduleWasSuccessful': '儲存班表成功',
		'addedASchedule': '新增班表',
		'addedAScheduleDlg': '新增班表',
		'setScheduleProperties': '設定班表屬性',
		'editTheSchedule': '編輯班表',
		'deleteTheScheduleAndYouRe': '刪除班表完成!',
		'deleteAScheduleError': '刪除班表錯誤',
		'areYouSureYouWantTo': '確定要刪除此 <%=temp1%> 筆班表嗎?',
		'scheduleStatus': '班表狀態',
		'reasonsForRejection': '駁回原因',
		'unpublish': '取消發佈',
		'stockpile': '儲存',
		'cancelThisSchedule': '取消此班表？',
		'theScheduleHasnTBeenSaved': '班表尚未儲存，確定要取消嗎？',
		'goBackToThePreviousStep': '回到上一步',
		'pleaseMakeSureThatTheSchedule': '請確認已儲存班表，避免資料遺失。',
		'areYouSureYouWantTo2': '確定回到上一步嗎？',
		'time': '時間',
		'inShifts': '排班中',
		'toBeReviewed': '待審核',
		'published': '已發佈',
		'reasonsForRejectionOfSchedules': '駁回班表原因',
		'className': '班表名稱：',
		'dismissalOfThePerson': '駁回人',
		'timeOfRejection': '駁回時間',
		'unpublishTheSchedule': '取消發佈班表',
		'theScheduleWasUnpublishedSuccessfully': '取消發佈班表成功',
		'failedToUnpublishSchedule': '取消發佈班表失敗',
		'oKToUnpublish': '確定取消發佈',
		'areYouSureYouWantTo3': '確定要取消發佈此班表？',
		'manpowerStatistics': '人力統計',
		'failedToDownloadTheSummaryTable': '下載總表失敗',
		'thereIsNoDataToExport': '無資料可匯出，請重新設定匯出條件',
		'theDatePeriodMustBeWithin': '日期區間需在2個月內',
		'onlyPublishedSchedulesAreDownloaded': '僅下載已發佈的班表',
		'exportTheObject': '匯出對象',
		'approver': '審核人',
		'endDateAfterStartDate': '結束時間需晚於或等於起始時間',
		'maxPeople': '排班人員上限60人',
	},
	'hp.m3.m310410': {
		'myNewSchedule': '我新增的班表',
		'theScheduleIReviewed': '我審核的班表',
	},
	'hp.m3.m310410_statistics': {
		'actualShiftHoursHours': '實際班別時數：<%=temp1%>小時',
		'realTimeManpowerStatistics': '即時人力統計',
		'shiftStagingFailed': '班表暫存失敗',
		'failedToReadParameters': '讀取參數失敗',
		'failedToExportShiftStatistics': '匯出班表統計失敗',
		'realTimeClassManpowerStatistics': '即時班別人力統計',
		'realTimeManpowerStatisticsForPeriods': '即時時段人力統計',
		'downloadTheReport': '下載報表',
		'employees': '位員工',
		'startendtime': '時間',
		'realTimeShiftReport': '即時班別人力統計表',
		'realTimeSectionReport': '即時時段人力統計表',
	},
	'hp.m3.m310410_shifting': {
		'ndSection': '二段班',
		'failedToGetTheSchedule': '班表獲取失敗',
		'workingHours': '工作時間：<%=temp1%>',
		'allowableOvertimeHours': '可加班時間：',
		'prohibitionOfOvertimeHours': '禁止加班時間：',
		'clearThemAll': '全部清除',
		'overlappingWorkingHours': '工作時間重疊',
		'theCalendarTimeOfTheClass': '班別曆日時間不同',
		'theOvertimeAttributionDaysOfThe': '班別加班歸屬日不同',
		'temp': '<%=temp1%> 與 <%=temp2%><%=temp3%>',
		'temp1': '<%=temp1%>~<%=temp2%> 與 <%=temp3%>~<%=temp4%> <%=temp5%>',
		'overlapsWithRestTime': '<%=temp1%>~<%=temp2%> 與 <%=temp3%>~<%=temp4%> 休息時間重疊',
		'shiftSchedules': '排班班別',
		'thereAreNoScheduledShiftsOn': '工作日未排班',
		'theClassIsFullAndNo': '班別已排滿，無法再新增班別',
		'aMaximumOfScheduleTagsCan': '每個班別最多新增 <%=temp1%> 個排班標籤',
		'thereAreDaysOfClassesAre': '有<%=temp1%>天班別已排滿，無法再新增班別',
		'thereAreStaffClassesAreFull': '有<%=temp1%>位員工班別已排滿，無法再新增班別',
		'scheduleStatistics': '班表統計',
		'theScheduleHasBeenScheduledSection': '班表已排定<%=temp1%>段班，不可減少可排班別數',
		'thereIsAnErrorInThe': '班表存在錯誤，無法儲存暫存檔。',
		'theImportWasSuccessful': '匯入成功',
		'thereIsNoScheduleInformationTo': '沒有班表資料可儲存',
		'thereIsAnErrorInThe2': '班表存在錯誤，無法儲存。',
		'performAComparisonOfStoredData': '進行儲存資料比對',
		'saveTheError': '儲存錯誤',
		'someOfTheStaffHaveChanged': '部分員工已排時數已變更，要離開網站嗎？',
		'optionToCollapse': '選項收合',
		'shiftsCanBeScheduledDaily': '每日可排班別',
		'incomingClassScheduling': '匯入班別排班',
		'importTimeSlotScheduling': '匯入時段排班',
		'roundRobinScheduling': '循環排班',
		'clearTheSchedule': '清空班表',
		'importEmployeeSchedules': '匯入員工預排',
		'batchJobs': '批次作業',
		'other': '其他',
		'areYouSureYouWantTo': '確定要清空此班表的所有班表資料?',
		'day': '第<%=temp1%>天: <%=temp2%>',
		'breaksOverlapWithMultipleShifts': '休息時間與多個班別工作時間重疊',
		'theSetupIsComplete': '設定完成',
		'noTimeSlotSchedulingEmployeeData': '無時段排班員工資料',
		'areYouSureYouWantTo2': '確定要套用新規則，取代現在的班表資料?',
		'theClassScheduleScreenImportFormat': '班表畫面匯入格式.xlsx',
		'selectThePersonOnTheRoster': '選擇排班人員',
		'timeManagementRulesAreNotBeing': '未符合工時管理規則',
		'theTimeRuleCheckFailed': '工時規則檢查失敗',
		'thereIsNoExportMaterial': '無匯出資料',
		'employeesOtherEmployeesEmployeesATotal': '<%=temp1%> <%=temp2%> 位員工 + 其他員工 <%=temp3%> 位員工，共 <%=temp4%> 位員工',
		'scheduleStartAndEndTimes': '班表起訖時間',
		'theTypeOfWorkException': '工時異常類型',
		'violationOfTheRules': '違反規則',
		'exceptionDate': '異常日期',
		'allEmployeesInTheShiftAre': '班表內所有員工都符合工時規則檢查',
		'theTypeOfWorkException2': '工作異常類型',
		'anomalyIntervals': '異常區間',
		'workProjects': '工時項目',
		'schedulesStoreResults': '班表儲存結果',
		'saveShiftFailed': '儲存排班失敗',
		'shiftStaff': '排班人員:',
		'classScheduleStartsAndEndsTimetable': '班表起訖時間:',
		'workingHoursRuleReminder': '<%=temp1%>筆(工時規則提醒:<%=temp2%>筆)',
		'executionResult': '執行結果',
		'theResultOfTheWorkHour': '工時異常檢查結果',
		'reminderCount': '提醒筆數',
		'numberOfStrokesIsProhibited': '禁止筆數',
		'pen': '<%=temp1%>筆',
		'remindersOfAbnormalWorkingHours': '工時異常提醒',
		'theTimeRulesAreNotBeing': '未符合工時規則',
		'scheduledEmployeesHaveBeenSelected': '已選取排班員工',
		'schedule': '排班表',
		'offDays': '請假天數',
		'offFullDays': '全天請假天數',
		'deformPeriod': '變形工時週期切換',
		'shifting': '班表資料',
		'leaveName': '假節日名稱',
		'restTemplate': '週期：每<%=H%>小時休息<%=M%>分鐘',
		'sumFile': '排班總表',
		'totalStaff': '全體員工 <%=N%> 位',
		'totalStaff2': '全體員工 <%=N%> 位',
		'shiftResult': '儲存班表結果',
		'failSchedule': '錯誤班表畫面匯入格式',
		'areYouSureYouWantTo3': '確定批次清除班表資料？',
	},
	'hp.m3.m310410_extra': {
		'employees': '<%=temp1%> <%=temp2%> 位員工',
		'checkTheWorkingHours': '檢查工時',
		'exportSchedules': '匯出班表',
		'failedToExportSchedules': '匯出班表失敗',
		'allEmployeesInTheSchedule': '班表內所有員工',
		'partOfTheStaff': '部份員工',
		'theScheduleDisplaysInformation': '班表顯示資訊',
		'classScheduleContent': '班表內容',
		'showHolidayNonWorkingDay': '顯示假節日(非工作日)',
		'calendarExportFormat': '行事曆別匯出格式',
		'shiftExportFormat': '排班班別匯出格式',
		'shiftLabelExportFormat': '排班標籤匯出格式',
		'someDatesArePastTheSchedule': '部分日期超過班表異動期限',
		'schedulingDataIsAvailable': '已有排班資料',
		'violationOfWorkingHoursRulesReminders': '違反工時規則（提醒）',
		'employeesAreNotScheduledEmployeesOn': '員工部分日期不是排班員工',
		'importClassSchedules': '匯入班別排班班表',
		'theImportFormatIsIncorrect': '匯入格式錯誤',
		'theNumberOfShiftsThatEmployees': '員工可排班別數不同',
		'scheduleDatesAreNotConsecutive': '班表日期不連續',
		'theNumberOfScheduleDaysExceeds': '班表天數超過限制',
		'exceedingTheNumberOfShiftsThat': '超過可排班別數',
		'pleaseDoNotChangeTheImport': '請勿異動班表匯入格式，否則可能造成班表無法匯入。',
		'ifYouAreSureThatYou': '匯入後一律覆蓋預覽的班表內容，若您確定要更新班表資料，務必點擊「儲存班表」按鈕，才會更新成功。',
		'theCalendarIsCombinedWithDifferent': '行事曆別班別合併，不含標籤',
		'theCalendarIsCombinedWithTags': '行事曆別班別合併，含標籤',
		'calendarClassesAreNotCombined': '行事曆別班別不合併',
		'numberOfShiftTags': '排班標籤數',
		'importFormat': '匯入類型',
		'calendarTempOrClass': '行事曆別<%=temp1%>或班別',
		'incorrectFormatting': '格式不正確',
		'required': '(必填)',
		'optional': '(非必填)',
		'abnormalData': '異常資料:',
		'downloadTheResultsOfTheTime': '下載工時檢查結果',
		'importTimeSlotSchedules': '匯入時段排班班表',
		'employeesOtherEmployeesEmployeesATotal': '<%=temp1%> <%=temp2%> 位員工 + <%=temp3%> 其他員工 <%=temp4%> 位員工，共 <%=temp5%> 位員工',
		'shiftStaff': '排班人員：',
		'classScheduleStartsAndEndsTimetable': '班表起訖時間：',
		'succeed': '成功：',
		'failed': '失敗：',
		'workingHoursRuleReminderTransactions': '<%=temp1%>筆(工時規則提醒:<%=temp2%>筆)，<%=temp3%>',
		'itCannotBePublishedBecauseThere': '！因尚有失敗資料，所以無法發佈',
		'confirmTheRelease': '確定發佈',
		'theReleaseWasSuccessful': '發佈成功',
		'reminderOfWorkingHours': '<%=temp1%>筆(工時規則提醒:<%=temp2%>筆)',
		'importEmployeeSchedules': '匯入員工預排班表<%=temp1%>',
		'onceAnEmployeeScheduleIsImported': '！ 匯入員工預排班表後，員工即無法進行預排作業。',
		'pleaseCheckAtLeastOneEmployee': '請至少勾選一位員工',
		'previewStatus': '預排狀態',
		'importSchedules': '匯入班表',
		'reflowIsAllowed': '允許重排',
		'toBeContinued': '未完成',
		'imported': '已匯入',
		'notImported': '未匯入',
		'totalPeople': '共<%=temp1%>人',
		'peopleWhoHaveCompletedThePre': '已完成預排<%=temp1%>人',
		'tempPeopleWhoHaveNotCompleted': '未完成預排<%=temp1%>人',
		'lastSent': '上次發送時間：<%=temp1%>',
		'sendReminderNotifications': '發送催排通知',
		'theReminderLetterWasSentSuccessfully': '發送催排信件成功',
		'openReschedule': '開放「<%=temp1%>」重排班表？',
		'statisticalReports': '統計報表',
		'scheduleStatisticsReport': '排班統計報表',
		'failedToReportForm': '匯出報表失敗',
		'partOfTheStaff2': '部分員工',
		'theNameOfTheReport': '報表名稱',
		'employee2': '<%=temp1%> <%=temp2%> 位員工',
		'sectionImportSample1': '班表匯入格式 - 1',
		'sectionImportSample2': '班表匯入格式 - 2',
		'sectionImportSample3': '班表匯入格式 - 3',
		'scheduleOrShift': '行事曆別及班別',
		'feteOrShift': '假節日名稱及班別簡稱',
		'unauthorized': '員工在這段時間內不是排班人員或無權限',
		'containsError': '欄位內容錯誤',
		'staffIdRequired': '員工編號必填',
		'has': '有',
		'fatal': '錯誤資訊',
		'shiftMemberOnly': '僅可匯入該班表的被排班人員',
		'shiftDeadlineExceeded': '超過班表異動期限',
		'notShiftingStaff': '員工當日不是排班員工',
		'unauthorizedSection': '員工在這段時間內不是時段排班人員或無權限',
		'calendarMissed': '找不到設定的行事曆別',
		'shiftMissed': '找不到設定的排班班別',
		'calendarAndShiftMissed': '找不到設定的行事曆別或班別',
		'tagMissed': '找不到設定的排班標籤',
		'tagNoMapping': '標籤沒有對應班別',
		'jobFrom': '工作起始時間',
		'jobEnd': '工作結束時間',
		'restFrom': '休息起始時間',
		'restEnd': '休息結束時間',
		'noFixShift': '固定班不可匯入',
		'noWorkShift': '班別排班不可匯入',
		'unauthorizedType': '班別屬性非排班(依時段)或無權限',
		'staffMissing': '員編不存在',
		'dateMalformed': '時間格式錯誤',
		'workPartial': '工作時間不完整',
		'restPartial': '休息時間不完整',
		'repetitiveShift': '排班資料重覆',
		'defyBanRule': '違反工時規則（禁止）',
	},
	'hp.m3.m310410_cycle_dup': {
		'failedToLoadEmployeeProfile': '載入員工資料失敗',
		'employeesScheduledForAllTimeSlots': '班表內所有時段排班員工',
		'employeesScheduledForAllShiftsIn': '班表內所有班別排班員工',
		'specificEmployees': '特定員工',
		'startAndEndTime': '起迄時間',
		'startEndTime': '起迄時間(起)',
		'startEndTimeYet': '起迄時間(迄)',
		'dayNth': '第N天',
		'classesAndLabels': '班別及標籤',
		'customizeWorkingHoursAndLabels': '自訂工作時間及標籤',
		'pleaseSelectAClass': '請選擇班別',
		'customizeWorkingHours': '自訂工作時間',
		'breaks': '休息時間',
		'copyTheCalendar': '複製行事曆',
		'failedToMountCalendarData': '載入行事曆資料失敗',
		'calendarPreview': '行事曆預覽',
		'schedulingPatterns': '排班方式',
		'roundRobinClassOrder': '循環班別順序',
		'employees': '員工名單',
	},
	'hp.m3.m310410_audit': {
		'rejectionOfSchedules': '駁回班表',
		'determineTheRejection': '確定駁回',
		'mandatoryReasonForRejectionMaximumWords': '必填駁回原因，最多300字。',
		'theSystemIsAbnormalAndThe': '系統異常，資料寫入失敗',
		'reviewTheSchedule': '檢視班表',
		'rejectionOfTheScheduleIsCompleted': '駁回班表完成',
		'approvalSuccessful': '核准成功',
		'theScheduleHasBeenApprovedBy': '<%=temp1%>筆班表已被他人簽核，所以您已無需處理',
		'reviewTheReasonForTheRejection': '查看駁回原因',
	},
	'h2.am.Shifting': {
		'leave': '假',
		'leavePeriod': '請假時間:',
		'cancellationTime': '銷假時間:',
		'customShiftFailureTheBreakOverlaps': '自訂班別失敗:休息時間與多個班別工作時間重疊',
		'customizeYourClass': '自訂班別',
		'workingHours': '工作時間',
		'customClassFailed': '自訂班別失敗:',
		'confirm': '確認',
		'timeSlotScheduling': '時段排班',
		'noEditingPermissions': '無編輯權限',
		'tempHours': '<%=temp1%>小時',
		'tempDays': '<%=temp1%>天',
		'violationOfWorkingHourRules': '違反工時規則',
		'scheduleError': '班表錯誤',
		'ifThereIsNoInformationThat': ' 沒有符合查詢條件的資料，請放寬條件重新查詢',
		'ifThereIsNoDataThat': ' 沒有符合查詢條件的資料，點選下方按鈕直接選擇排班員工',
		'selectTheEmployee': '選擇員工',
		'failedToCreateATag': '創建標籤失敗',
		'otherErrors': '其他錯誤',
		'enterAnEmployeeKeywordQuery': '輸入員工關鍵字查詢',
		'editTheEmployee': '編輯員工',
		'fieldSettings': '欄位設定',
		'notYetInService': '未到職',
		'regularShifts': '固定班',
		'dimission': '離職',
		'stay': '留停',
		'theRevisionPeriodHasPassed': '已超過修改期限',
		'thereIsNoNeedToSchedule': '不需排班',
	},
	'h2.am.ShiftingSidePanel': {
		'theResultOfTheWorkRule': '工時規則檢查結果',
		'examine': '檢查',
		'lastCheckTime': '最後檢查時間',
		'youHavenTCheckedYourSchedule': '您還未檢查過班表',
		'complyWithTimeRulesChecks': '符合工時規則檢查',
		'forbid': '禁止',
		'remind': '提醒',
		'manHourStatistics': '工時統計',
		'beforeStorage': '儲存前',
		'afterStorage': '儲存後',
		'difference': '差異',
		'shouldBeArranged': '應排',
		'scheduled': '已排',
		'leaveAndOvertimeDetails': '請假加班明細',
		'scheduleCheckResults': '班表檢查結果',
	},
	'h2.am.ShiftingConstants': {
		'nameStaff': '姓名/員編',
		'remainingSpecialHolidayHours': '剩餘特休(時)',
		'remainingCompensatoryTimeOffHours': '剩餘補休(時)',
		'actualCreditCardSwipingManHours': '實際刷卡工時',
		'hoursShouldBeScheduled': '應排時數',
		'differentialWork': '差異工時',
		'linedShouldBeArranged': '已排-應排',
		'workingDaysShouldBeScheduled': '應排工作日',
		'nationalHolidaysShouldBeScheduled': '應排國定假日',
		'restDaysShouldBeScheduled': '應排休息日',
		'holidaysShouldBeScheduled': '應排例假日',
		'shiftsShouldBeEmptied': '應排空班',
	},
	'hp.m4.m410210': {
		'shiftSchedules': '預排班表 > ',
		'rehearsingIsNoLongerAllowed': '已不允許預排',
		'unableToFindASavetableSchedule': '找不到可儲存班表',
		'storageSuccessful': '儲存成功',
		'savedAndSubmittedTheScheduleSuccessfully': '儲存並提交班表成功',
		'rehearsableAvailable': '可預排',
		'unableToPreRehearse': '無法預排',
		'scheduledTime': '預排時間',
	},
	'hp.m3.m310410_inspection.index': {
		'jobCheck': '崗位檢核',
		'postManpowerCheck': '崗位人力檢核',
		'classGroups': '班別群組',
	},
	'hp.m3.m310410_inspection.group_config_dialog': {
		'selectAGroupClass': '選擇群組班別',
	},
	'hp.m3.m310410_inspection.inspect_config': {
		'selectedClass': '已選班別',
		'theFileFormatIsIncorrect': '檔案格式錯誤',
	},
	'hp.m3.m310410_inspection.inspect_dialog': {
		'thereIsNoInformationAfterSelecting': '無資訊，選擇班別後，點選＋，即可設定該班別的崗位應排人力',
		'addedAClassGroup': '新增班別群組',
		'classGroupSetting': '班別群組設定',
		'postStaffingSample': '崗位應排人力匯入格式',
		'postStaffingFail': '錯誤崗位應排人力匯入資料',
		'tagState': '標籤狀態',
		'noEdit': '請勿異動匯入格式，匯入後一律覆蓋當前資料，確定匯入資料正確後，點選「確定」按鈕即可儲存設定。',
		'notPlus': '非正整數',
		'exceeded': '超過上限',
	},
	'hp.m3.m310410_inspection.view_dialog': {
		'noInformationTryToResetThe': '無資訊，試試重新設定崗位應排人力吧！',
		'manpowerShouldBeArrangedForThe': '設定崗位應排人力',
		'noteMeansThatTheDifferenceIs': '備註：「-」表示差額等於0，「/」 表示無法計算差額',
	},
	'h2.am.ShiftingFieldSetting': {
		'pleaseSelectTheItemsYouNeed': '請勾選您需要的項目，再拖曳「<%=temp1%>」排序位置。',
		'staffNameNameStaffEnglishName': '員編、姓名、姓名/員編、英文姓名，擇一必填',
		'illustrate': '說明',
	},
	'h2.am.ShiftingDialog': {
		'remainingSpecialHolidayHours': '剩餘特休時數',
		'remainingCompensatoryHours': '剩餘補休時數',
		'validStartDates': '可休起始日',
		'closedEndDays': '可休結束日',
		'specialSabbaticalYear': '特休年度',
	},
	'h2.am.ShiftingContext': {
		'realTimeScheduleStatistics': '即時班表統計',
	},
	'components.Pdf': {
		'download': ' 下載',
		'page': '第 <%=temp1%> 頁',
		'total': '共 <%=temp1%> 頁',
	},
	'sp.sa.am.emp.skd.autoInsertShift': {
		'code11': '未自訂任何工作時間',
		'code12': '工作時間重疊',
		'code13': '休息時間與多個班別工作時間重疊',
		'code14': '休息時間重疊',
		'code15': '工作時間」結束時間早於起始時間',
		'code16': '「休息時間」結束時間早於起始時間',
		'code17': '曆日資料有誤',
	},
	'hp.m5.m510010.wf101': {
		'basicInfo': '基本資訊',
		'tripInfo': '行程資訊',
		'reasonAttachment': '原因/附件',
		'transStloc': '出發地',
		'transDtloc': '目的地',
		'number': '輸入數字',
		'km': '公里',
		'addTrip': '新增行程',
		'delTrip': '刪除行程',
		'transKm': '里程數',
		'requiredTrans': '需填寫出發地、目的地、里程數',
		'requiredRail': '需填寫出發地、目的地',
		'verifyDeactivation': '<%=f%> <%=n%> 已停用',
		'verifyDeletion': '<%=f%> <%=n%> 已刪除',
		'sameTransportation': '同一個交通工具的出發地、目的地不可相同',
	},
	'104service.redirection': {
		490: '帳號狀態異常(鎖定、關閉、未認證...)，請聯絡系統管理者',
		491: '非員工不可使用',
		492: '未設定 Email 不可使用',
		493: '服務參數尚未設定，請與 104 聯繫',
		494: '目前無法取得服務 Token，請與 104 聯繫',
		495: '服務異常，請與 104 聯繫',
		496: '104 企業學習平台仍未啟用，不可使用',
		489: '姓名/英文姓名皆為符號，無法使用104服務，請聯絡系統管理者',
	},
	'sso.verify': {
		'verificationFailed': 'SSO驗證失敗',
		'linkExpired': '此連結已過期，請重新申請',
		'verificationSuccessful': 'SSO驗證成功',
	},
};
